/**
 * 미국 주식 티커 → 영문 회사명 매핑 (자동 생성)
 * 총 6425개
 */

export const US_TICKER_TO_EN: Record<string, string> = {
  "A": "Agilent Technologies Inc.",
  "AA": "Alcoa Corporation",
  "AACB": "Artius II Acquisition Inc. Class A",
  "AACG": "ATA Creativity Global ADR",
  "AACI": "Armada Acquisition Corp. III Class A Ordinary Share",
  "AACO": "Abony Acquisition Corp. I Class A Ordinary Share",
  "AACP": "Apogee Acquisition Corp Class A",
  "AADX": "Applied Aerospace & Defense, Inc.",
  "AAL": "American Airlines Group Inc.",
  "AAME": "Atlantic American Corp",
  "AAMI": "Acadian Asset Management Inc.",
  "AAOI": "Applied Optoelectronics, Inc.",
  "AAON": "Aaon Inc",
  "AAP": "ADVANCE AUTO PARTS INC",
  "AAPG": "Ascentage Pharma Group International ADR",
  "AAPL": "Apple Inc.",
  "AARD": "Aardvark Therapeutics, Inc. Common Stock",
  "AAT": "AMERICAN ASSETS TRUST, INC.",
  "AAUC": "Allied Gold Corporation",
  "AB": "AllianceBernstein Holding, L.P.",
  "ABAT": "American Battery Technology Company Common Stock",
  "ABBV": "ABBVIE INC.",
  "ABCB": "Ameris Bancorp",
  "ABCL": "AbCellera Biologics Inc. Common Shares",
  "ABEO": "Abeona Therapeutics Inc. Common Stock",
  "ABEV": "AMBEV S.A.",
  "ABG": "Asbury Automotive Group, Inc.",
  "ABLV": "Able View Global Inc. Class B",
  "ABM": "ABM Industries, Inc.",
  "ABNB": "Airbnb, Inc. Class A Common Stock",
  "ABOS": "Acumen Pharmaceuticals, Inc. Common Stock",
  "ABR": "Arbor Realty Trust, Inc.",
  "ABR-P-D": "Arbor Realty Trust, Inc Series D Preferred Stock",
  "ABR-P-E": "Arbor Realty Trust, Inc Series E Preferred Stock",
  "ABR-P-F": "Arbor Realty Trust, Inc Series F Preferred Stock",
  "ABSI": "Absci Corporation Common Stock",
  "ABT": "Abbott Laboratories",
  "ABTC": "American Bitcoin Corp. Class A Common Stock",
  "ABTS": "Abits Group Inc",
  "ABUS": "Arbutus Biopharma Corporation Common Stock",
  "ABVC": "ABVC BioPharma, Inc. Common Stock",
  "ABVX": "Abivax SA ADR",
  "ABX": "Abacus Global Management, Inc.",
  "ACA": "Arcosa, Inc. Common Stock",
  "ACAA": "Averin Capital Acquisition Corp. Class A",
  "ACAD": "Acadia Pharmaceuticals Inc.",
  "ACB": "Aurora Cannabis Inc. Common Shares",
  "ACCL": "Acco Group Holdings Limited Class A",
  "ACCO": "Acco Brands Corporation",
  "ACCS": "ACCESS Newswire Inc.",
  "ACDC": "ProFrac Holding Corp. Class A Common Stock",
  "ACEL": "Accel Entertainment, Inc.",
  "ACET": "Adicet Bio, Inc. Common Stock",
  "ACFN": "Acorn Energy, Inc. Common Stock",
  "ACGC": "ACP Holdings Acquisition Corp. Class A",
  "ACGL": "Arch Capital Group Ltd",
  "ACGLN": "Arch Capital Group Ltd Series G Preferred Stock",
  "ACGLO": "Arch Capital Group Ltd Series F Preferred Shares",
  "ACH": "Accendra Health, Inc.",
  "ACHC": "Acadia Healthcare Company, Inc.",
  "ACHR": "Archer Aviation Inc.",
  "ACHV": "Achieve Life Sciences, Inc.",
  "ACI": "Albertsons Companies, Inc.",
  "ACIC": "American Coastal Insurance Corporation Common Stock",
  "ACIU": "AC Immune SA",
  "ACIW": "ACI Worldwide, Inc.",
  "ACLS": "Axcelis Technologies Inc",
  "ACM": "Aecom",
  "ACMR": "ACM Research, Inc. Class A Common Stock",
  "ACN": "Accenture PLC",
  "ACNB": "ACNB Corp",
  "ACNT": "Ascent Industries Co. Common Stock",
  "ACOG": "Alpha Cognition Inc. Common Stock",
  "ACON": "Aclarion, Inc. Common Stock",
  "ACP": "abrdn Income Credit Strategies Fund",
  "ACP-P-A": "abrdn Income Credit Strategies Fund Series A Preferred Stock",
  "ACR": "ACRES Commercial Realty Corp.",
  "ACR-P-C": "ACRES Commercial Realty Corp Series C Preferred Stock",
  "ACR-P-D": "ACRES Commercial Realty Corp Series D Preferred Stock",
  "ACRE": "Ares Commercial Real Estate Corporation",
  "ACRS": "Aclaris Therapeutics, Inc.",
  "ACRV": "Acrivon Therapeutics, Inc. Common Stock",
  "ACT": "Enact Holdings, Inc. Common Stock",
  "ACTG": "Acacia Research Corporation",
  "ACTU": "Actuate Therapeutics, Inc. Common stock",
  "ACU": "Acme United Corporation",
  "ACV": "Virtus Diversified Income & Convertible Fund",
  "ACVA": "ACV Auctions Inc.",
  "ACXP": "Acurx Pharmaceuticals, Inc. Common Stock",
  "AD": "Array Digital Infrastructure, Inc.",
  "ADAC": "American Drive Acquisition Company Class A",
  "ADAG": "Adagene Inc. ADR",
  "ADAM": "Adamas Trust, Inc. Common Stock",
  "ADAML": "Adamas Trust, Inc Series F Preferred Stock",
  "ADAMM": "Adamas Trust, Inc Series E Preferred Stock",
  "ADAMN": "Adamas Trust, Inc Series D Preferred Stock",
  "ADAMZ": "Adamas Trust, Inc Series G Preferred Stock",
  "ADBE": "Adobe Inc.",
  "ADC": "Agree Realty Corporation",
  "ADC-P-A": "Agree Realty Corporation Series A Preferred Stock",
  "ADCT": "ADC Therapeutics SA",
  "ADEA": "Adeia Inc. Common Stock",
  "ADGM": "Adagio Medical Holdings, Inc Common Stock",
  "ADI": "Analog Devices, Inc.",
  "ADIG": "ADI Global Distribution Inc.",
  "ADIL": "Adial Pharmaceuticals, Inc",
  "ADM": "Archer Daniels Midland Company",
  "ADMA": "ADMA Biologics, Inc.",
  "ADNT": "Adient plc",
  "ADP": "Automatic Data Processing",
  "ADPT": "Adaptive Biotechnologies Corporation Common Stock",
  "ADSE": "ADS-TEC ENERGY PLC",
  "ADSK": "Autodesk Inc",
  "ADT": "ADT Inc.",
  "ADTN": "ADTRAN Holdings, Inc. Common Stock",
  "ADUR": "Aduro Clean Technologies Inc. Common Stock",
  "ADUS": "Addus HomeCare Corp.",
  "ADV": "Advantage Solutions Inc. Class A Common Stock",
  "ADVB": "Advanced Biomed Inc. Common Stock",
  "ADX": "Adams Diversified Equity Fund, Inc",
  "ADXN": "Addex Therapeutics Ltd ADR",
  "AEAQ": "Activate Energy Acquisition Corp. Class A Ordinary Share",
  "AEBI": "Aebi Schmidt Holding AG Common Stock",
  "AEC": "Anfield Energy Inc. Common Shares",
  "AEE": "Ameren Corporation",
  "AEF": "abrdn Emerging Markets ex-China Fund, Inc.",
  "AEG": "Aegon Ltd.",
  "AEHL": "Antelope Enterprise Holdings Limited Class A",
  "AEHR": "Aehr Test Systems",
  "AEI": "Alset Inc. Common Stock (TX)",
  "AEIS": "Advanced Energy Industries Inc",
  "AEM": "Agnico Eagle Mines Ltd.",
  "AEMD": "AETHLON MEDICAL INC",
  "AENT": "Alliance Entertainment Holding Corporation Class A Common Stock",
  "AEO": "American Eagle Outfitters",
  "AEON": "AEON Biopharma, Inc.",
  "AEP": "American Electric Power Company, Inc.",
  "AER": "Aercap Holdings N.V.",
  "AERO": "Grupo Aeromexico, S.A.B. de C.V. ADR",
  "AERT": "Aeries Technology, Inc. Class A Ordinary Share",
  "AES": "AES Corporation",
  "AESI": "Atlas Energy Solutions Inc.",
  "AESP": "Aeon Acquisition I Corp. Class A",
  "AEVA": "Aeva Technologies, Inc.",
  "AEXA": "American Exceptionalism Acquisition Corp. A",
  "AEYE": "AudioEye, Inc. Common Stock",
  "AFB": "Alliance National Municipal Income Fund, Inc.",
  "AFCG": "Advanced Flower Capital Inc. Common Stock",
  "AFG": "American Financial Group, Inc.",
  "AFJK": "Aimei Health Technology Co., Ltd Ordinary Share",
  "AFL": "Aflac Inc.",
  "AFRI": "Forafric Global PLC",
  "AFRM": "Affirm Holdings, Inc. Class A Common Stock",
  "AFYA": "Afya Limited Class A Common Shares",
  "AG": "FIRST MAJESTIC SILVER CORP",
  "AGBK": "AGI Inc",
  "AGCC": "Agencia Comercial Spirits Ltd Class A",
  "AGCO": "AGCO Corporation",
  "AGD": "abrdn Global Dynamic Dividend Fund",
  "AGEN": "Agenus Inc.",
  "AGI": "Alamos Gold Inc. Class A Common Shares",
  "AGIG": "Abundia Global Impact Group Inc.",
  "AGIO": "Agios Pharmaceuticals, Inc.",
  "AGL": "agilon health, inc.",
  "AGM": "Federal Agricultural Mortgage Corporation",
  "AGM-A": "Federal Agricultural Mortgage Corporation Class A Voting",
  "AGM-P-D": "Federal Agricultural Mortgage Corporation Series D Preferred Stock",
  "AGM-P-E": "Federal Agricultural Mortgage Corporation Series E Preferred Stock",
  "AGM-P-F": "Federal Agricultural Mortgage Corporation Series F Preferred Stock",
  "AGM-P-G": "Federal Agricultural Mortgage Corporation Series G Preferred Stock",
  "AGM-P-H": "Federal Agricultural Mortgage Corporation Series H Preferred Stock",
  "AGM-P-I": "Federal Agricultural Mortgage Corporation Series I Preferred Stock",
  "AGMB": "AgomAb Therapeutics NV ADR",
  "AGMH": "AGM Group Holdings Inc. Class A",
  "AGNC": "AGNC Investment Corp. Common Stock",
  "AGNCL": "AGNC Investment Corp Series G Preferred Stock",
  "AGNCM": "AGNC Investment Corp. Depositary Shares rep Series D Preferred Stock",
  "AGNCN": "AGNC Investment Corp Series C Preferred Stock",
  "AGNCO": "AGNC Investment Corp Series E Preferred Stock",
  "AGNCP": "AGNC Investment Corp Series F Preferred Stock",
  "AGNCZ": "AGNC Investment Corp Series H Preferred Stock",
  "AGNT": "AGNT, Inc. Common Stock",
  "AGO": "Assured Guaranty, LTD",
  "AGPU": "Axe Compute Inc. Common Stock",
  "AGRO": "ADECOAGRO S.A.",
  "AGRZ": "Agroz Inc. Class A",
  "AGX": "Argan, Inc",
  "AGYS": "Agilysys, Inc. Common Stock (DE)",
  "AHCO": "AdaptHealth Corp. Common Stock",
  "AHG": "Akso Health Group ADS",
  "AHL-P-D": "Aspen Insurance Holdings Limited Preference Shares",
  "AHL-P-E": "Aspen Insurance Holdings Limited Preference Shares",
  "AHL-P-F": "Aspen Insurance Holdings Limited Preferred Stock",
  "AHMA": "Ambitions Enterprise Management Co. L.L.C Class A",
  "AHR": "American Healthcare REIT, Inc.",
  "AHRT": "AH Realty Trust, Inc.",
  "AHRT-P-A": "AH Realty Trust, Inc Series A Preferred Stock",
  "AHT": "Ashford Hospitality Trust, Inc.",
  "AHT-P-D": "Ashford Hospitality Trust, Inc. 8.45% Series D",
  "AHT-P-F": "Ashford Hospitality Trust, Inc.",
  "AHT-P-G": "Ashford Hospitality Trust, Inc Series G Preferred Stock",
  "AHT-P-H": "Ashford Hospitality Trust, Inc Series H Preferred Stock",
  "AHT-P-I": "Ashford Hospitality Trust, Inc Series I Preferred Stock",
  "AI": "C3.ai, Inc.",
  "AIAI": "AIAI Holdings Corporation Class A Common Stock",
  "AIB": "AIB Data Centers Inc.",
  "AIBZ": "Bitzero Holdings Inc. Common Shares",
  "AIDX": "20/20 Biolabs, Inc. Common Stock",
  "AIFA": "All In FutureTech Alliance, Inc. Common Stock",
  "AIFC": "AI Financial Corporation Common Stock",
  "AIFF": "Firefly Neuroscience, Inc. Common Stock",
  "AIFU": "AIFU Inc. Class A Ordinary Share",
  "AIG": "American International Group, Inc.",
  "AIHS": "Senmiao Technology Limited Common Stock",
  "AII": "American Integrity Insurance Group, Inc.",
  "AIIA": "AI Infrastructure Acquisition Corp.",
  "AIIO": "Robo.ai Inc. Class B",
  "AIIR": "Air Global PLC",
  "AIM": "AIM ImmunoTech Inc.",
  "AIMD": "Ainos, Inc. Common Stock",
  "AIN": "Albany International Corp Class A",
  "AIO": "Virtus Artificial Intelligence & Technology Opportunities Fund",
  "AIOS": "AIOS Tech Inc. Class A Common Shares",
  "AIOT": "PowerFleet, Inc. Common Stock",
  "AIP": "Arteris, Inc. Common Stock",
  "AIR": "AAR Corp.",
  "AIRE": "reAlpha Tech Corp. Common Stock",
  "AIRG": "Airgain, Inc. Common Stock",
  "AIRI": "Air Industries Group",
  "AIRJ": "AirJoule Technologies Corporation Class A Common Stock",
  "AIRO": "AIRO Group Holdings, Inc. Common Stock",
  "AIRS": "AirSculpt Technologies, Inc. Common Stock",
  "AIRT": "Air T Inc",
  "AIRTP": "Air T, Inc. Air T Funding Alpha Income Trust Preferred Securities",
  "AISP": "Airship AI Holdings, Inc. Class A Common Stock",
  "AIT": "Applied Industrial Technologies, Inc.",
  "AIV": "Apartment Investment and Management Company",
  "AIXC": "AIxCrypto Holdings, Inc. Common Stock",
  "AIXI": "XIAO-I Corporation ADR",
  "AIZ": "Assurant, Inc.",
  "AJG": "Arthur J. Gallagher & Co.",
  "AKA": "a.k.a. Brands Holding Corp.",
  "AKAM": "Akamai Technologies Inc",
  "AKAN": "Akanda Corp. Common Shares",
  "AKBA": "Akebia Therapeutics, Inc.",
  "AKO-A": "Embotelladora Andina S.A. Series A",
  "AKO-B": "Embotelladora Andina S.A. Series B",
  "AKR": "Acadia Realty Trust",
  "AKTS": "Aktis Oncology, Inc. Common stock",
  "AKTX": "Akari Therapeutics plc ADR (0.01 USD)",
  "ALAB": "Astera Labs, Inc. Common Stock",
  "ALAR": "Alarum Technologies Ltd. ADR",
  "ALB": "Albemarle Corporation",
  "ALB-P-A": "Albemarle Corporation Series A Preferred Stock",
  "ALC": "Alcon Inc.",
  "ALCO": "Alico Inc",
  "ALDF": "Aldel Financial II Inc. Class A",
  "ALDX": "Aldeyra Therapeutics, Inc.",
  "ALEC": "Alector, Inc. Common Stock",
  "ALF": "Centurion Acquisition Corp. Class A",
  "ALG": "Alamo Group, Inc.",
  "ALGM": "Allegro MicroSystems, Inc. Common Stock",
  "ALGN": "Align Technology Inc",
  "ALGS": "Aligos Therapeutics, Inc. Common Stock",
  "ALGT": "Allegiant Travel Company",
  "ALH": "Alliance Laundry Holdings Inc.",
  "ALHC": "Alignment Healthcare, Inc. Common Stock",
  "ALIS": "Calisa Acquisition Corp",
  "ALIT": "Alight, Inc.",
  "ALK": "Alaska Air Group, Inc.",
  "ALKS": "Alkermes Inc. plc",
  "ALKT": "Alkami Technology, Inc. Common Stock",
  "ALL": "The Allstate Corporation",
  "ALL-P-H": "The Allstate Corporation",
  "ALL-P-I": "The Allstate Corporation",
  "ALL-P-J": "The Allstate Corporation Series J Preferred Stock",
  "ALLE": "Allegion Public Limited Company",
  "ALLO": "Allogene Therapeutics, Inc. Common Stock",
  "ALLR": "Allarity Therapeutics, Inc. Common Stock",
  "ALLT": "Allot Ltd.",
  "ALLY": "Ally Financial Inc.",
  "ALM": "Almonty Industries Inc. Common Shares",
  "ALMR": "Alamar Biosciences, Inc. Common Stock",
  "ALMS": "Alumis Inc. Common Stock",
  "ALMU": "Aeluma, Inc. Common Stock",
  "ALNT": "Allient Inc. Common Stock",
  "ALNY": "Alnylam Pharmaceuticals, Inc.",
  "ALOT": "AstroNova, Inc. Common Stock",
  "ALOV": "Aldabra 4 Liquidity Opportunity Vehicle, Inc. Class A",
  "ALOY": "REalloys Inc. Common Stock",
  "ALP": "Alpha Compute Corp Common Stock",
  "ALPS": "ALPS Group Inc Ordinary Share",
  "ALPX": "Alpex Acquisition Corporation Class A",
  "ALRM": "Alarm.com Holdings, Inc.",
  "ALRS": "Alerus Financial Corporation Common Stock",
  "ALSN": "ALLISON TRANSMISSION HOLDINGS, INC.",
  "ALT": "Altimmune, Inc. Common Stock",
  "ALTG": "Alta Equipment Group Inc.",
  "ALTG-P-A": "Alta Equipment Group Inc Series A Preferred Stock",
  "ALTI": "AlTi Global, Inc. Class A Common Stock",
  "ALTO": "Alto Ingredients, Inc. Common Stock",
  "ALUB": "Alussa Energy Acquisition Corp. II",
  "ALV": "Autoliv, Inc.",
  "ALVO": "Alvotech",
  "ALX": "Alexander's Inc.",
  "ALXO": "ALX Oncology Holdings Inc. Common Stock",
  "ALZN": "Alzamend Neuro, Inc. Common Stock",
  "AM": "Antero Midstream Corporation Common Stock",
  "AMAL": "Amalgamated Financial Corp. Common Stock (DE)",
  "AMAN": "Amanat Acquisition Corp Class A",
  "AMAT": "Applied Materials Inc",
  "AMBA": "Ambarella, Inc.",
  "AMBO": "Ambow Education Holding Ltd. ADR",
  "AMBP": "Ardagh Metal Packaging S.A.",
  "AMBQ": "Ambiq Micro, Inc.",
  "AMBR": "Amber International Holding Limited ADR",
  "AMC": "AMC ENTERTAINMENT HOLDINGS, INC.",
  "AMCI": "AMC Robotics Corporation Common Stock",
  "AMCR": "Amcor plc",
  "AMCX": "AMC Global Media Inc. Class A Common Stock",
  "AMD": "Advanced Micro Devices",
  "AME": "Ametek, Inc.",
  "AMG": "Affiliated Managers Group",
  "AMGN": "Amgen Inc",
  "AMH": "AMERICAN HOMES 4 RENT",
  "AMH-P-G": "American Homes 4 Rent Series G Series G Preferred Shares",
  "AMH-P-H": "American Homes 4 Rent Series H Series H Preferred Shares",
  "AMIX": "Autonomix Medical, Inc. Common Stock",
  "AMKR": "Amkor Technology Inc",
  "AMLX": "Amylyx Pharmaceuticals, Inc. Common Stock",
  "AMN": "AMN Healthcare Services",
  "AMOD": "Alpha Modus Holdings, Inc. Class A Common Stock",
  "AMP": "Ameriprise Financial, Inc.",
  "AMPG": "AMPLITECH GROUP INC. COM",
  "AMPH": "Amphastar Pharmaceuticals, Inc.",
  "AMPL": "Amplitude, Inc. Class A Common Stock",
  "AMPX": "Amprius Technologies, Inc.",
  "AMPY": "Amplify Energy Corp.",
  "AMR": "Alpha Metallurgical Resources, Inc.",
  "AMRC": "Ameresco, Inc.",
  "AMRN": "Amarin Corp Plc",
  "AMRX": "Amneal Pharmaceuticals, Inc. Class A Common Stock",
  "AMRZ": "Amrize Ltd",
  "AMS": "American Shared Hospital Services",
  "AMSC": "American Superconductor Corp",
  "AMSF": "AMERISAFE, Inc.",
  "AMSS": "AMASS Brands Inc. Common Stock",
  "AMST": "Amesite Inc.",
  "AMT": "American Tower Corporation",
  "AMTB": "Amerant Bancorp Inc.",
  "AMTD": "AMTD IDEA Group ADR",
  "AMTM": "Amentum Holdings, Inc.",
  "AMTX": "Aemetis, Inc. (DE) Common Stock",
  "AMWL": "American Well Corporation",
  "AMX": "America Movil S.A.B de C.V ADR",
  "AMZE": "Amaze Holdings, Inc.",
  "AMZN": "Amazon.Com Inc",
  "AN": "AutoNation, Inc.",
  "ANAB": "AnaptysBio, Inc. Common Stock",
  "ANDE": "Andersons Inc/The",
  "ANDG": "Andersen Group Inc.",
  "ANET": "Arista Networks",
  "ANF": "Abercrombie & Fitch Co.",
  "ANG-P-D": "American National Group Inc Series D Preferred Stock",
  "ANGH": "Anghami Inc.",
  "ANGI": "Angi Inc. Class A Common Stock",
  "ANGO": "AngioDynamics, Inc.",
  "ANGX": "Angel Studios, Inc.",
  "ANIK": "Anika Therapeutics Inc",
  "ANIP": "ANI Pharmaceuticals, Inc.",
  "ANIX": "Anixa Biosciences, Inc.",
  "ANL": "Adlai Nortye Ltd. ADR",
  "ANNA": "AleAnna, Inc. Class A Common Stock",
  "ANNX": "Annexon, Inc. Common Stock",
  "ANPA": "Rich Sparkle Holdings Limited",
  "ANRO": "Alto Neuroscience Inc.",
  "ANSC": "Agriculture & Natural Solutions Acquisition Corporation Class A",
  "ANTA": "Antalpha Platform Holding Company Class A",
  "ANTX": "AN2 Therapeutics, Inc. Common Stock",
  "ANVS": "Annovis Bio, Inc.",
  "ANY": "Sphere 3D Corp. Common Shares",
  "AOD": "abrdn Total Dynamic Dividend Fund",
  "AOMR": "Angel Oak Mortgage REIT, Inc.",
  "AON": "Aon plc Class A",
  "AORT": "Artivion, Inc.",
  "AOS": "A.O. Smith Corporation",
  "AOSL": "Alpha and Omega Semiconductor Limited",
  "AOUT": "American Outdoor Brands, Inc. Common Stock",
  "AP": "Ampco-Pittsburgh Corp.",
  "APA": "APA Corporation Common Stock",
  "APAC": "StoneBridge Acquisition II Corporation Class A",
  "APAM": "ARTISAN PARTNERS ASSET MANAGEMENT INC.",
  "APC": "ARKO Petroleum Corp. Class A Common Stock",
  "APD": "Air Products & Chemicals, Inc.",
  "APEI": "American Public Education, Inc.",
  "APG": "APi Group Corporation",
  "APGE": "Apogee Therapeutics, Inc. Common Stock",
  "APH": "Amphenol Corporation",
  "API": "Agora, Inc. ADR",
  "APLD": "Applied Digital Corporation Common Stock",
  "APLE": "Apple Hospitality REIT, Inc.",
  "APLM": "Apollomics Inc. Class A",
  "APMC": "AmperCap Acquisition Company",
  "APMD": "Apnimed, Inc. Common Stock",
  "APO": "Apollo Global Management, Inc.",
  "APOG": "Apogee Enterprises Inc",
  "APP": "Applovin Corporation Class A Common Stock",
  "APPF": "AppFolio, Inc. Class A",
  "APPN": "Appian Corporation Class A Common Stock",
  "APPS": "Digital Turbine, Inc.",
  "APRE": "Aprea Therapeutics, Inc. Common stock",
  "APT": "Alpha Pro Tech, Ltd.",
  "APTV": "Aptiv PLC",
  "APUR": "Aperture AC Class A",
  "APUS": "Apimeds Pharmaceuticals US, Inc.",
  "APVO": "Aptevo Therapeutics Inc",
  "APWC": "Asia Pacific Wire & Cable Corp",
  "APXT": "Apex Treasury Corporation Class A Ordinary Share",
  "APYX": "Apyx Medical Corporation Common Stock",
  "AQB": "AquaBounty Technologies, Inc.",
  "AQMS": "Aqua Metals, Inc. Common Stock",
  "AQN": "Algonquin Power & Utilities Corp",
  "AQST": "Aquestive Therapeutics, Inc. Common Stock",
  "AR": "ANTERO RESOURCES CORPORATION",
  "ARAI": "Arrive AI Inc. Common Stock",
  "ARAY": "Accuray Incorporated",
  "ARBB": "ARB IOT Group Limited",
  "ARBE": "Arbe Robotics Ltd.",
  "ARBK": "Argo Blockchain plc ADR",
  "ARCB": "ArcBest Corporation",
  "ARCC": "Ares Capital Corporation",
  "ARCI": "Archimedes Tech SPAC Partners III Co. Ordinary Share",
  "ARCL": "ARC Group Acquisition I Corp Class A",
  "ARCO": "ARCOS DORADOS HOLDINGS INC.",
  "ARCT": "Arcturus Therapeutics Holdings Inc. Common Stock",
  "ARDC": "ARES DYNAMIC CREDIT ALLOCATION FUND, INC.",
  "ARDT": "Ardent Health, Inc.",
  "ARDX": "Ardelyx, Inc.",
  "ARE": "Alexandria Real Estate Equities, Inc.",
  "AREC": "AMERICAN RESOURCES CORP",
  "AREN": "The Arena Group Holdings, Inc.",
  "ARES": "Ares Management Corporation Class A Common Stock",
  "ARES-P-B": "Ares Management Corporation Series B Preferred Stock",
  "ARGX": "argenx SE ADR",
  "ARHS": "Arhaus, Inc. Class A Common Stock",
  "ARI": "APOLLO COMMERCIAL REAL ESTATE FINANCE, INC.",
  "ARIS": "Aris Mining Corporation",
  "ARKO": "ARKO Corp. Common Stock",
  "ARKR": "Ark Restaurants Corp",
  "ARL": "American Realty Investors, Inc.",
  "ARLO": "Arlo Technologies, Inc.",
  "ARLP": "Alliance Resource Partners LP",
  "ARM": "Arm Holdings plc ADR",
  "ARMK": "ARAMARK",
  "ARMP": "Armata Pharmaceuticals, Inc. Common Stock",
  "AROC": "Archrock Inc",
  "AROW": "Arrow Financial Corp",
  "ARQ": "Arq, Inc. Common Stock",
  "ARQQ": "Arqit Quantum Inc.",
  "ARQT": "Arcutis Biotherapeutics, Inc. Common Stock",
  "ARR": "ARMOUR Residential REIT, Inc.",
  "ARR-P-C": "ARMOUR Residential REIT, Inc Series C Preferred Stock",
  "ARRY": "Array Technologies, Inc. Common Stock",
  "ARTC": "Art Technology Acquisition Corp. Class A",
  "ARTL": "Artelo Biosciences, Inc. Common Stock",
  "ARTNA": "Artesian Resources Corp",
  "ARTV": "Artiva Biotherapeutics, Inc. Common Stock",
  "ARTW": "Arts-Way Manufacturing Co Inc",
  "ARVN": "Arvinas, Inc",
  "ARW": "Arrow Electronics, Inc.",
  "ARWR": "Arrowhead Research Corporation",
  "ARX": "Accelerant Holdings",
  "ARXS": "Arxis, Inc. Class A Common Stock",
  "AS": "Amer Sports, Inc.",
  "ASA": "ASA GOLD AND PRECIOUS METALS LIMITED",
  "ASAN": "Asana, Inc. Class A Common Stock",
  "ASB": "Associated Banc-Corp",
  "ASB-P-E": "Associated Banc-Corp Series E Preferred Stock",
  "ASB-P-F": "Associated Banc-Corp Series F Preferred Stock",
  "ASBP": "Aspire Biopharma Holdings, Inc. Common Stock",
  "ASC": "ARDMORE SHIPPING CORPORATION",
  "ASG": "LIBERTY ALL-STAR GROWTH FD",
  "ASGI": "abrdn Global Infrastructure Income Fund",
  "ASH": "Ashland Inc.",
  "ASIC": "Ategrity Specialty Insurance Company Holdings",
  "ASIX": "AdvanSix Inc.",
  "ASLE": "AerSale Corporation Common Stock",
  "ASM": "Avino Silver & Gold Mines Ltd. (Canada)",
  "ASMB": "Assembly Biosciences, Inc",
  "ASML": "ASML Holding NV",
  "ASND": "Ascendis Pharma A/S Ordinary Share",
  "ASO": "Academy Sports and Outdoors, Inc.",
  "ASPC": "A SPAC III Acquisition Corp. Class A",
  "ASPI": "ASP Isotopes Inc. Common Stock",
  "ASPN": "Aspen Aerogels, Inc.",
  "ASPS": "Altisource Portfolio Solutions S.A.",
  "ASR": "Grupo Aeroportuario del Sureste, S.A. de C.V. ADR",
  "ASRV": "AmeriServ Financial Inc",
  "ASST": "Strive, Inc. Class A Common Stock",
  "ASTC": "Astrotech Corporation (DE) Common Stock",
  "ASTE": "Astec Industries Inc",
  "ASTH": "Astrana Health Inc. Common Stock",
  "ASTI": "Ascent Solar Technologies, Inc. Common Stock",
  "ASTL": "Algoma Steel Group Inc. Common Shares",
  "ASTS": "AST SpaceMobile, Inc. Class A Common Stock",
  "ASUR": "Asure Software, Inc",
  "ASX": "ASE Technology Holding Co., Ltd.",
  "ASYS": "Amtech Systems Inc",
  "ATAI": "AtaiBeckley Inc. Common Stock",
  "ATAT": "Atour Lifestyle Holdings Limited ADR",
  "ATCH": "AtlasClear Holdings, Inc.",
  "ATCX": "Atlas Critical Minerals Corporation Common Stock",
  "ATEC": "Alphatec Holdings, Inc.",
  "ATEN": "A10 NETWORKS INC",
  "ATER": "Aterian, Inc. Common Stock",
  "ATEX": "Anterix Inc. Common Stock",
  "ATGL": "Alpha Technology Group Limited Class A",
  "ATH-P-A": "Athene Holding Ltd Series A Preferred Stock",
  "ATH-P-B": "Athene Holding Ltd Series B Preferred Stock",
  "ATH-P-D": "Athene Holding Ltd Series D Preferred Stock",
  "ATH-P-E": "Athene Holding Ltd Series E Preferred Stock",
  "ATHE": "Alterity Therapeutics Limited ADR",
  "ATHM": "Autohome Inc. ADR",
  "ATHR": "Aether Holdings, Inc. Common Stock",
  "ATI": "ATI Inc.",
  "ATII": "Archimedes Tech SPAC Partners II Co.",
  "ATKR": "Atkore Inc.",
  "ATLC": "Atlanticus Holdings Corporation",
  "ATLCP": "Atlanticus Holdings Corporation Series B Preferred Stock",
  "ATLO": "AMES National Corp",
  "ATLX": "Atlas Lithium Corporation Common Stock",
  "ATMU": "Atmus Filtration Technologies Inc.",
  "ATNI": "ATN International, Inc",
  "ATNM": "Actinium Pharmaceuticals, Inc",
  "ATO": "Atmos Energy Corporation",
  "ATOM": "Atomera Incorporated Common Stock",
  "ATOS": "Atossa Therapeutics, Inc. Common Stock",
  "ATPC": "Agape ATP Corporation Common Stock",
  "ATR": "AptarGroup, Inc.",
  "ATRA": "Atara Biotherapeutics, Inc",
  "ATRC": "AtriCure, Inc.",
  "ATRO": "Astronics Corp",
  "ATS": "ATS Corporation",
  "ATTO": "Attovia Therapeutics, Inc. Common Stock",
  "ATXG": "Addentax Group Corp. Common Stock",
  "ATYR": "aTyr Pharma, Inc. Common Stock",
  "AU": "AngloGold Ashanti plc",
  "AUB": "Atlantic Union Bankshares Corporation",
  "AUB-P-A": "Atlantic Union Bankshares Corporation Series A Preferred Stock",
  "AUBN": "Auburn National Bancorporation",
  "AUC": "ATIF Holdings Limited",
  "AUDC": "AudioCodes Ltd",
  "AUGO": "Aura Minerals Inc. Common Shares",
  "AUID": "authID Inc. Common Stock",
  "AUNA": "Auna S.A.",
  "AUPH": "Aurinia Pharmaceuticals Inc",
  "AUR": "Aurora Innovation, Inc. Class A Common Stock",
  "AURA": "Aura Biosciences, Inc. Common Stock",
  "AURE": "Aurelion Inc. Class A",
  "AUST": "Austin Gold Corp.",
  "AUTL": "Autolus Therapeutics plc ADR",
  "AUUD": "Auddia Inc. Common Stock",
  "AVA": "Avista Corporation",
  "AVAH": "Aveanna Healthcare Holdings Inc. Common Stock",
  "AVAL": "GRUPO AVAL ACCIONES Y VALORES S.A.",
  "AVAT": "Avalanche Treasury Corporation Class A Common Stock",
  "AVAV": "AeroVironment, Inc.",
  "AVB": "AvalonBay Communities, Inc.",
  "AVBC": "Avidia Bancorp, Inc.",
  "AVBH": "Avidbank Holdings, Inc. Common stock",
  "AVBP": "ArriVent BioPharma, Inc. Common Stock",
  "AVD": "American Vanguard Corporation",
  "AVEX": "AEVEX Corp.",
  "AVGO": "Broadcom Inc. Common Stock",
  "AVIR": "Atea Pharmaceuticals, Inc. Common Stock",
  "AVK": "Advent Convertible and Income Fund",
  "AVLN": "Avalyn Pharma Inc. Common Stock",
  "AVNT": "Avient Corporation",
  "AVNW": "Aviat Networks, Inc.",
  "AVO": "Mission Produce, Inc. Common Stock",
  "AVPT": "AvePoint, Inc. Class A Common Stock",
  "AVR": "Anteris Technologies Global Corp. Common Stock",
  "AVT": "Avnet, Inc.",
  "AVTR": "Avantor, Inc.",
  "AVTX": "Avalo Therapeutics, Inc. Common Stock",
  "AVX": "Avax One Technology Ltd. Common Shares",
  "AVXL": "Anavex Life Sciences",
  "AVY": "Avery Dennison Corp.",
  "AWF": "ALLIANCEBERSTEIN GLOBAL HIGH INCOME FUND, INC.",
  "AWI": "Armstrong World Industries, Inc.",
  "AWK": "American Water Works Company, Inc",
  "AWP": "abrdn Global Premier Properties Fund",
  "AWR": "American States Water Company",
  "AWRE": "Aware Inc",
  "AWX": "Avalon Holdings Corp.",
  "AX": "Axos Financial, Inc. Common Stock",
  "AXG": "Solowin Holdings Class A Ordinary Share",
  "AXGN": "Axogen, Inc. Common Stock",
  "AXIL": "AXIL Brands, Inc.",
  "AXIN": "Axiom Intelligence Acquisition Corp 1 Class A",
  "AXON": "Axon Enterprise, Inc. Common Stock",
  "AXP": "American Express Company",
  "AXR": "AMREP Corporation",
  "AXS": "Axis Capital Holders Limited",
  "AXS-P-E": "AXIS Capital Holdings Limited Series E Preferred Shares",
  "AXSM": "Axsome Therapeutics, Inc",
  "AXTA": "Axalta Coating Systems Ltd.",
  "AXTI": "AXT Inc",
  "AYA": "Aya Gold & Silver Inc. Common Shares",
  "AYI": "Acuity Inc.",
  "AYTU": "AYTU BioPharma, Inc. Common Stock",
  "AZ": "A2Z Cust2Mate Solutions Corp. Common Shares",
  "AZI": "Autozi Internet Technology (Global) Ltd. Class A",
  "AZIO": "Azio AI Holdings, Inc. Common Stock",
  "AZN": "AstraZeneca PLC",
  "AZO": "AutoZone, Inc.",
  "AZTA": "Azenta, Inc.",
  "AZTR": "Azitra Inc",
  "AZUL": "Azul S.A. ADR",
  "AZZ": "AZZ Inc.",
  "B": "Barrick Mining Corporation",
  "BA": "Boeing Company",
  "BA-P-A": "The Boeing Company Series A Preferred Stock",
  "BABA": "Alibaba Group Holding Limited ADR",
  "BAC": "Bank of America Corporation",
  "BAC-P-B": "Bank of America Corporation Preferred Stock",
  "BAC-P-E": "Bank of America Corporation Depositary Shares (representing 1/1,000th of a share of Series E Preferred Stock",
  "BAC-P-K": "Bank of America Corporation Preferred Stock",
  "BAC-P-L": "Bank Of America Corporation Series L Preferred Stock",
  "BAC-P-M": "Bank of America Corporation Preferred Stock",
  "BAC-P-N": "Bank of America Corporation Preferred Stock",
  "BAC-P-O": "Bank of America Corporation Preferred Stock",
  "BAC-P-P": "Bank of America Corporation Preferred Stock",
  "BAC-P-Q": "Bank of America Corporation Preferred Stock",
  "BAC-P-S": "Bank of America Corporation Preferred Stock",
  "BACC": "Blue Acquisition Corp. Class A",
  "BAER": "Bridger Aerospace Group Holdings, Inc. Common Stock",
  "BAFN": "BayFirst Financial Corp. Common Stock",
  "BAH": "Booz Allen Hamilton Holding Corporation",
  "BAK": "Braskem S.A. American Class A Preferred Shares",
  "BALL": "Ball Corporation",
  "BALY": "Bally's Corporation",
  "BAM": "Brookfield Asset Management Ltd.",
  "BANC": "Banc of California, Inc.",
  "BANC-P-F": "Banc of California, Inc Series F Preferred Stock",
  "BAND": "Bandwidth Inc. Class A Common Stock",
  "BANF": "Bancfirst Corp",
  "BANFP": "BancFirst Corporation - BFC Capital Trust II Cumulative Trust Pfd Secs",
  "BANL": "CBL International Limited Class B",
  "BANR": "Banner Corp.",
  "BANX": "ArrowMark Financial Corp. Common Stock",
  "BAOS": "Baosheng Media Group Holdings Limited",
  "BAP": "Credicorp LTD",
  "BARK": "BARK, Inc.",
  "BATL": "Battalion Oil Corporation",
  "BATRA": "Atlanta Braves Holdings, Inc. Series A Common Stock",
  "BATRK": "Atlanta Braves Holdings, Inc. Series C Common Stock",
  "BAX": "Baxter International Inc.",
  "BB": "BlackBerry Limited",
  "BBAI": "BigBear.ai Holdings, Inc.",
  "BBAR": "Banco BBVA Argentina S.A.",
  "BBBY": "Bed Bath & Beyond, Inc.",
  "BBCP": "Concrete Pumping Holdings, Inc. Common Stock",
  "BBCQ": "Bleichroeder Acquisition Corp. II Class A",
  "BBD": "Banco Bradesco S.A. American Preferred Shares",
  "BBDC": "Barings BDC, Inc.",
  "BBDO": "Banco Bradesco S.A. ADR",
  "BBGI": "Beasley Broadcasting Group Inc",
  "BBIO": "BridgeBio Pharma, Inc. Common Stock",
  "BBLG": "Bone Biologics Corp Common Stock",
  "BBN": "BlackRock Taxable Municipal Bond Trust",
  "BBNX": "Beta Bionics, Inc. Common Stock",
  "BBOT": "BridgeBio Oncology Therapeutics, Inc. Common Stock",
  "BBSI": "Barrett Business Services",
  "BBT": "Beacon Financial Corporation",
  "BBUC": "Brookfield Business Corporation Class A Subordinate Voting Shares",
  "BBVA": "Banco Bilbao Vizcaya Argentaria, S.A.",
  "BBW": "Build-A-Bear Workshop, Inc.",
  "BBWI": "Bath & Body Works, Inc.",
  "BBY": "Best Buy Company, Inc.",
  "BC": "Brunswick Corporation",
  "BCAB": "BioAtla, Inc. Common Stock",
  "BCAL": "California BanCorp Common Stock",
  "BCAR": "D. Boral ARC Acquisition I Corp. Class A",
  "BCAT": "BlackRock Capital Allocation Term Trust",
  "BCAX": "Bicara Therapeutics Inc. Common Stock",
  "BCBP": "BCB Bancorp Inc (NJ)",
  "BCC": "Boise Cascade Company",
  "BCCQ": "Bleichroeder Acquisition Corp. III Class A",
  "BCDA": "BioCardia, Inc. Common Stock",
  "BCE": "BCE, Inc.",
  "BCG": "Binah Capital Group, Inc. Common Stock",
  "BCH": "Banco de ChileAmerican Depositary Shares (Each representing 200 shares of Common Stock)",
  "BCHT": "Birchtech Corp.",
  "BCIC": "BCP Investment Corporation Common Stock",
  "BCML": "BayCom Corp Common Stock",
  "BCO": "The Brink's Company",
  "BCPC": "Balchem Corporation",
  "BCRX": "BioCryst Pharmaceuticals Inc",
  "BCS": "Barclays PLC",
  "BCSF": "Bain Capital Specialty Finance, Inc.",
  "BCSS": "Bain Capital GSS Investment Corp.",
  "BCTX": "Briacell Therapeutics Corp. Common Shares",
  "BCV": "Bancroft Fund Ltd.",
  "BCV-P-A": "Bancroft Fund Ltd Series A Preferred Shares",
  "BCX": "BLACKROCK RESOURCES & COMMODITIES STRATEGY TRUST",
  "BCYC": "Bicycle Therapeutics plc ADR",
  "BDC": "Belden Inc.",
  "BDCI": "BTC Development Corp. Class A",
  "BDJ": "BlackRock Enhanced Equity Dividend Trust",
  "BDL": "Flanigan's Enterprises Inc",
  "BDMD": "Baird Medical Investment Holdings Ltd Ordinary Share",
  "BDN": "Brandywine Realty Trust",
  "BDRX": "Biodexa Pharmaceuticals plc American Depositary Shs",
  "BDSX": "Biodesix, Inc. Common Stock",
  "BDTX": "Black Diamond Therapeutics, Inc. Common Stock",
  "BDX": "Becton, Dickinson and Co.",
  "BE": "Bloom Energy Corporation",
  "BEAG": "Bold Eagle Acquisition Corp. Class A",
  "BEAM": "Beam Therapeutics Inc. Common Stock",
  "BEAT": "Heartbeam, Inc. Common Stock",
  "BEBE": "TGE Value Creative Solutions Corp",
  "BEEM": "Beam Global Common Stock",
  "BEEP": "Mobile Infrastructure Corporation Common Stock",
  "BEKE": "KE Holdings Inc. ADR",
  "BELFA": "Bel Fuse Inc",
  "BELFB": "Bel Fuse Inc",
  "BEN": "Franklin Resources, Inc.",
  "BENF": "Beneficient Class A Common Stock",
  "BEP": "Brookfield Renewable Partners L.P.",
  "BEP-P-A": "Brookfield Renewable Partners L.P. 5.25% Class A Preferred Limited Partnership Units, Series 17",
  "BEPC": "Brookfield Renewable Corporation Class A Exchangeable Subordinate Voting Shares",
  "BESS": "Bimergen Energy Corporation",
  "BETA": "Beta Technologies, Inc.",
  "BETR": "Better Home & Finance Holding Company Class A Common Stock",
  "BF-A": "Brown-Forman Corporation Class A",
  "BF-B": "Brown-Forman Corporation Class B",
  "BFAM": "BRIGHT HORIZONS FAMILY SOLUTIONS INC.",
  "BFC": "Bank First Corporation Common Stock",
  "BFH": "Bread Financial Holdings, Inc.",
  "BFH-P-A": "Bread Financial Holdings, Inc Series A Preferred Stock",
  "BFH-P-B": "Bread Financial Holdings, Inc Series B Preferred Stock",
  "BFLY": "Butterfly Network, Inc.",
  "BFRG": "Bullfrog AI Holdings, Inc. Common Stock",
  "BFRI": "Biofrontera Inc. Common Stock",
  "BFS": "Saul Centers, Inc.",
  "BFS-P-D": "Saul Centers, Inc Series D Preferred Stock",
  "BFS-P-E": "Saul Centers, Inc Series E Preferred Stock",
  "BFST": "Business First Bancshares, Inc. Common Stock",
  "BG": "Bunge Global SA",
  "BGB": "Blackstone Strategic Credit 2027 Term Fund",
  "BGC": "BGC Group, Inc. Class A Common Stock",
  "BGDE": "Big Digital Energy, Inc. Common Stock",
  "BGH": "Barings Global Short Duration High Yield Fund",
  "BGI": "Birks Group Inc",
  "BGIN": "Bgin Blockchain Limited Class A",
  "BGL": "Blue Gold Limited Class A",
  "BGLC": "BioNexus Gene Lab Corp Common stock",
  "BGM": "BGM Group Ltd. Class A",
  "BGMS": "Bio Green Med Solution, Inc. Common Stock",
  "BGR": "Blackrock Energy and Resources Trust",
  "BGS": "B&G Foods, Inc.",
  "BGSF": "BGSF, Inc.",
  "BGSI": "Boyd Group Services Inc.",
  "BGT": "BlackRock Floating Rate Income Trust",
  "BGX": "Blackstone Long-Short Credit Income Fund",
  "BGY": "BlackRock Enhanced International Dividend Trust",
  "BH": "Biglari Holdings Inc. Class B Common Stock",
  "BH-A": "Biglari Holdings Inc. Class A Common Stock",
  "BHAV": "BHAV Acquisition Corp Class A",
  "BHB": "Bar Harbor Bankshares",
  "BHC": "Bausch Health Companies Inc",
  "BHE": "Benchmark Electronics",
  "BHF": "Brighthouse Financial, Inc.",
  "BHFAM": "Brighthouse Financial, Inc Series D Preferred Stock",
  "BHFAN": "Brighthouse Financial, Inc Series C Preferred Stock",
  "BHFAO": "Brighthouse Financial, Inc. Depositary Shares 6.75% Non-Cum Pfd Series B",
  "BHFAP": "Brighthouse Financial, Inc. Depositary Shares Series A Preferred Stock",
  "BHK": "BLACKROCK CORE BD TR",
  "BHM": "Bluerock Homes Trust, Inc.",
  "BHP": "BHP Group Limited ADR",
  "BHR": "Braemar Hotels & Resorts Inc. Common Stock",
  "BHR-P-B": "Braemar Hotels & Resorts Inc Series B Preferred Stock",
  "BHR-P-D": "Braemar Hotels & Resorts Inc Series D Preferred Stock",
  "BHRB": "Burke & Herbert Financial Services Corp. Common Stock",
  "BHST": "BioHarvest Sciences Inc. Common Stock",
  "BHV": "BlackRock Virginia Muni Bond Trust",
  "BHVN": "Biohaven Ltd.",
  "BIAF": "bioAffinity Technologies, Inc. Common Stock",
  "BID": "Tribeca Strategic Acquisition Corp. Class A",
  "BIDU": "Baidu, Inc.",
  "BIIB": "Biogen Inc. Common Stock",
  "BIII": "Black Spade Acquisition III Co",
  "BILI": "Bilibili Inc. ADR",
  "BILL": "BILL Holdings, Inc.",
  "BIO": "Bio-Rad Laboratories, Inc.Class A",
  "BIO-B": "Bio-Rad Laboratories, Inc. Class B",
  "BIOA": "BioAge Labs, Inc. Common Stock",
  "BIOT": "Instinct Bio Technical Company Holdings Inc.",
  "BIOX": "Bioceres Crop Solutions Corp.",
  "BIP": "Brookfield Infrastructure Partners L.P. Limited Partnership Units",
  "BIP-P-A": "Brookfield Infrastructure Partners L.P. 5.125% Class A Preferred Limited Partnership Units, Series 13",
  "BIP-P-B": "Brookfield Infrastructure Partners L.P. 5.000% Class A Preferred Limited Partnership Units, Series 14",
  "BIPC": "Brookfield Infrastructure Corporation Class A Exchangeable Subordinate Voting Shares",
  "BIRD": "Smartbird, Inc. Class A Common Stock",
  "BIRK": "Birkenstock Holding plc",
  "BIT": "BLACKROCK MULTI-SECTOR INCOME TRUST",
  "BIVI": "BioVie, Inc. Common Stock",
  "BIXI": "Bitcoin Infrastructure Acquisition Corp Ltd. Class A",
  "BIYA": "Baiya International Group Inc Class A",
  "BJ": "BJs Wholesale Club Holdings, Inc. Common Stock",
  "BJDX": "Bluejay Diagnostics, Inc. Common Stock",
  "BJRI": "BJ's Restaurants, Inc.",
  "BKD": "Brookdale Senior Living, Inc.",
  "BKE": "The Buckle, Inc.",
  "BKH": "Black Hills Corporation",
  "BKHA": "Black Hawk Acquisition Corporation Class A",
  "BKKT": "Bakkt, Inc.",
  "BKNG": "Booking Holdings Inc. Common Stock",
  "BKR": "Baker Hughes Company",
  "BKSY": "BlackSky Technology Inc.",
  "BKT": "BlackRock Income Trust Inc.",
  "BKTI": "BK Technologies Corporation",
  "BKU": "Bankunited, Inc.",
  "BKV": "BKV Corporation",
  "BKYI": "BIO-key International, Inc. Common Stock",
  "BL": "BlackLine, Inc. Common Stock",
  "BLBD": "Blue Bird Corporation Common Stock",
  "BLCO": "Bausch + Lomb Corporation",
  "BLDP": "Ballard Power Systems Inc.",
  "BLDR": "Builders FirstSource, Inc.",
  "BLFS": "BioLife Solutions Inc.",
  "BLIN": "Bridgeline Digital Inc.",
  "BLIV": "BeLive Holdings Ordinary Share",
  "BLK": "Blackrock, Inc.",
  "BLKB": "Blackbaud, Inc.",
  "BLLN": "BillionToOne, Inc. Class A Common Stock",
  "BLMN": "Bloomin' Brands, Inc. Common Stock",
  "BLND": "Blend Labs, Inc.",
  "BLNE": "Beeline Holdings, Inc. Common Stock",
  "BLNK": "Blink Charging Co. Common Stock",
  "BLRK": "Bluerock Acquisition Corp. Class A",
  "BLRX": "BioLineRX Ltd",
  "BLSH": "Bullish",
  "BLSM": "BlossomHill Therapeutics, Inc. Common Stock",
  "BLTE": "Belite Bio, Inc ADR",
  "BLUW": "Blue Water Acquisition Corp. III Class A",
  "BLW": "Blackrock Limited Duration Income Trust",
  "BLX": "Bladex, Inc.",
  "BLZE": "Backblaze, Inc. Class A Common Stock",
  "BLZR": "Trailblazer Acquisition Corp. Class A",
  "BMA": "Banco Macro S.A.",
  "BMBL": "Bumble Inc. Class A Common Stock",
  "BME": "Blackrock Health Sciences Trust",
  "BMEA": "Biomea Fusion, Inc. Common Stock",
  "BMEZ": "BlackRock Health Sciences Term Trust",
  "BMGL": "Basel Medical Group Ltd",
  "BMHL": "Bluemount Holdings Limited Class B",
  "BMI": "Badger Meter, Inc.",
  "BML-P-G": "Bank Of America Corporation Preferred Stock",
  "BML-P-H": "Bank Of America Corporation Preferred Stock",
  "BML-P-J": "Bank of America Preferred Stock",
  "BML-P-L": "Bank of America Preferred Stock",
  "BMM": "Blue Moon Metals Inc. Common Shares",
  "BMN": "BlackRock 2037 Municipal Target Term Trust",
  "BMNP": "BitMine Immersion Technologies, Inc Series A Preferred Stock",
  "BMNR": "BitMine Immersion Technologies, Inc.",
  "BMO": "Bank of Montreal",
  "BMR": "Beamr Imaging Ltd. Ordinary Share",
  "BMRA": "BIOMERICA INC",
  "BMRC": "Bank of Marin Bancorp",
  "BMRN": "BioMarin Pharmaceuticals Inc",
  "BMY": "Bristol-Myers Squibb Co.",
  "BN": "Brookfield Corporation",
  "BNAI": "Brand Engagement Network Inc. Common Stock",
  "BNC": "CEA Industries Inc. Common Stock",
  "BNED": "Barnes & Noble Education, Inc",
  "BNGO": "Bionano Genomics, Inc. Common Stock",
  "BNKK": "Bonk, Inc. Common Stock",
  "BNL": "Broadstone Net Lease, Inc.",
  "BNR": "Burning Rock Biotech Limited ADR",
  "BNRG": "Brenmiller Energy Ltd",
  "BNS": "Bank of Nova Scotia",
  "BNT": "Brookfield Wealth Solutions Ltd.",
  "BNTC": "Benitec Biopharma Inc. Common Stock",
  "BNTX": "BioNTech SE ADR",
  "BNY": "Bank of New York Mellon Corporation",
  "BNY-P-K": "The Bank of New York Mellon Corporation Series K Preferred Stock",
  "BOBS": "Bobs Discount Furniture, Inc.",
  "BOC": "Boston Omaha Corporation",
  "BODI": "The Beachbody Company, Inc. Class A Common Stock",
  "BOE": "BlackRock Enhanced Global Dividend Trust",
  "BOF": "BranchOut Food Inc. Common Stock",
  "BOH": "Bank of Hawaii Corp.",
  "BOH-P-A": "Bank of Hawaii Corporation Series A Preferred Stock",
  "BOH-P-B": "Bank of Hawaii Corporation Series B Preferred Stock",
  "BOKF": "BOK Financial Corp",
  "BOLD": "Boundless Bio, Inc. Common Stock",
  "BOLT": "Bolt Biotherapeutics, Inc. Common Stock",
  "BON": "Bon Natural Life Limited Class A",
  "BOOM": "DMC Global Inc. Common Stock",
  "BOOT": "Boot Barn Holdings, Inc.",
  "BORR": "Borr Drilling Limited",
  "BOSC": "B.O.S. Better On-Line Solutions Ltd.",
  "BOT": "RoboStrategy, Inc. Common Stock",
  "BOTJ": "Bank of the James Financial Group, Inc",
  "BOW": "Bowhead Specialty Holdings Inc.",
  "BOX": "BOX, INC.",
  "BOXL": "Boxlight Corporation Class A Common Stock",
  "BP": "BP p.l.c.",
  "BPAC": "Blueport Acquisition Ltd Class A",
  "BPOP": "Popular Inc",
  "BPOPM": "Popular, Inc. Popular Capital Tr II 6.125%",
  "BPRE": "Bluerock Private Real Estate Fund",
  "BPRN": "Princeton Bancorp, Inc. Common Stock (PA)",
  "BQ": "Boqii Holding Limited",
  "BR": "Broadridge Financial Solutions Inc",
  "BRAG": "Bragg Gaming Group Inc. Common Shares",
  "BRAI": "Braiin Limited Common Stock",
  "BRBI": "BRBI BR Partners S.A. ADSs",
  "BRBR": "BellRing Brands, Inc.",
  "BRBS": "Blue Ridge Bankshares, Inc.",
  "BRC": "Brady Corporation",
  "BRCB": "Black Rock Coffee Bar, Inc. Class A Common Stock",
  "BRCC": "BRC Inc.",
  "BREZ": "Breeze Acquisition Corp. II",
  "BRFH": "Barfresh Food Group Inc. Common Stock",
  "BRIA": "BrilliA Inc",
  "BRID": "Bridgford Foods Corp",
  "BRK-A": "Berkshire Hathaway Inc.",
  "BRK-B": "BERKSHIRE HATHAWAY Class B",
  "BRKH": "Burtech Acquisition Corp II Class A",
  "BRKR": "Bruker Corporation",
  "BRKRP": "Bruker Corporation Series A Preferred Stock",
  "BRLS": "Borealis Foods Inc. Class A Common Shares",
  "BRLT": "Brilliant Earth Group, Inc. Class A Common Stock",
  "BRN": "Barnwell Industries, Inc.",
  "BRNS": "Barinthus Biotherapeutics plc ADR",
  "BRO": "Brown & Brown, Inc.",
  "BROS": "Dutch Bros Inc.",
  "BRR": "ProCap Financial, Inc. Common Stock",
  "BRSL": "Brightstar Lottery PLC",
  "BRSP": "BrightSpire Capital, Inc.",
  "BRT": "BRT Apartments Corp",
  "BRTX": "BioRestorative Therapies, Inc. Common Stock (NV)",
  "BRUN": "Boost Run Inc. Class A Common Stock",
  "BRVE": "Braveheart Bio, Inc. Common Stock",
  "BRW": "Saba Capital Income & Opportunities Fund",
  "BRX": "BRIXMOR PROPERTY GROUP INC.",
  "BRZE": "Braze, Inc. Class A Common Stock",
  "BSAA": "BEST SPAC I Acquisition Corp. Class A",
  "BSAC": "Banco Santander-Chile",
  "BSBK": "Bogota Financial Corp. Common Stock",
  "BSBR": "BANCO SANTANDER (BRASIL) SA",
  "BSEM": "BioStem Technologies, Inc. Common Stock",
  "BSET": "Bassett Furniture Industries I",
  "BSIN": "Big Sky Industrial Inc. Common Stock",
  "BSL": "Blackstone Senior Floating Rate 2027 Term Fund",
  "BSM": "Black Stone Minerals, L.P.",
  "BSP": "Bending Spoons S.p.A.",
  "BSRR": "Sierra Bancorp",
  "BST": "BlackRock Science and Technology Trust",
  "BSTZ": "BlackRock Science and Technology Term Trust",
  "BSVN": "Bank7 Corp. Common stock",
  "BSX": "Boston Scientific Corp.",
  "BSY": "Bentley Systems, Incorporated Class B Common Stock",
  "BTAI": "BioXcel Therapeutics, Inc. Common Stock",
  "BTBD": "BT Brands, Inc. Common Stock",
  "BTBT": "Bit Digital, Inc.",
  "BTCS": "BTCS Inc. Common Stock",
  "BTCT": "BTC Digital Ltd.",
  "BTDR": "Bitdeer Technologies Group Class A",
  "BTE": "Baytex Energy Corp.",
  "BTG": "B2Gold Corp.",
  "BTGO": "BitGo Holdings, Inc.",
  "BTI": "British American Tobacco p.l.c. ADR",
  "BTMD": "Biote Corp. Class A Common Stock",
  "BTO": "John Hancock Financial Opportunities Fund",
  "BTOC": "Armlogi Holding Corp. common stock",
  "BTOG": "Bit Origin Limited Class A",
  "BTQ": "BTQ Technologies Corp. Common Stock",
  "BTSG": "BrightSpring Health Services, Inc. Common Stock",
  "BTT": "BlackRock Municipal 2030 Target Term Trust",
  "BTTC": "Black Titan Corporation",
  "BTU": "Peabody Energy Corporation",
  "BTX": "BlackRock Technology and Private Equity Term Trust",
  "BTZ": "BlackRock Credit Allocation Income Trust",
  "BUD": "Anheuser-Busch INBEV SA/NV",
  "BUDA": "Buda Juice, Inc.",
  "BUI": "BlackRock Utilities, Infrastructure & Power Opportunities Trust",
  "BULL": "Webull Corporation Class A",
  "BUR": "Burford Capital Limited",
  "BURL": "BURLINGTON STORES, INC.",
  "BUSE": "First Busey Corporation Class A Common Stock",
  "BUSEP": "First Busey Corporation Series B Preferred Stock",
  "BUUU": "BUUU Group Limited Class A Ordinary Share",
  "BV": "BrightView Holdings, Inc. Common Stock",
  "BVC": "BitVentures Limited",
  "BVFL": "BV Financial, Inc. Common Stock",
  "BVN": "Compania de Minas Buenaventura S.A.",
  "BVS": "Bioventus Inc. Class A Common Stock",
  "BW": "Babcock & Wilcox Enterprises, Inc.",
  "BW-P-A": "Babcock & Wilcox Enterprises, Inc Series A Preferred Stock",
  "BWA": "BorgWarner Inc.",
  "BWAY": "Brainsway Ltd. ADR",
  "BWB": "Bridgewater Bancshares, Inc. Common Stock",
  "BWBBP": "Bridgewater Bancshares, Inc Series A Preferred Stock",
  "BWEN": "Broadwind, Inc. Common Stock",
  "BWFG": "Bankwell Financial Group Inc",
  "BWG": "BrandywineGLOBAL Global Income Opportunities Fund Inc.",
  "BWIN": "The Baldwin Insurance Group, Inc. Class A Common Stock",
  "BWIV": "Blue Water Acquisition Corp. IV",
  "BWLP": "BW LPG Limited",
  "BWMN": "Bowman Consulting Group Ltd. Common Stock",
  "BWMX": "Betterware de Mexico, S.A.P.I. de C.V.",
  "BWXT": "BWX Technologies, Inc.",
  "BX": "Blackstone Inc.",
  "BXBL": "BOXABL, Inc. Common stock",
  "BXC": "BlueLinx Holdings Inc.",
  "BXDC": "Blackstone Digital Infrastructure Trust Inc.",
  "BXMT": "Blackstone Mortgage Trust, Inc. (NEW)",
  "BXP": "BXP, Inc.",
  "BXSL": "Blackstone Secured Lending Fund",
  "BY": "Byline Bancorp, Inc. Common Stock",
  "BYAH": "Park Ha Biological Technology Co., Ltd.",
  "BYD": "Boyd Gaming Corporation",
  "BYFC": "Broadway Financial Corp/Del",
  "BYND": "Beyond Meat, Inc. Common Stock",
  "BYRN": "Byrna Technologies, Inc. Common Stock",
  "BYSI": "BeyondSpring Inc.",
  "BZ": "KANZHUN LIMITED ADR",
  "BZAI": "Blaize Holdings, Inc. Common Stock",
  "BZFD": "BuzzFeed, Inc. Class A Common Stock",
  "BZH": "Beazer Homes USA, Inc. New",
  "BZUN": "Baozun Inc. ADR",
  "C": "Citigroup Inc.",
  "C-P-N": "Citigroup Capital XIII 7.875% Fixed Rate/Floating Rate Trust Preferred Securities",
  "C-P-R": "Citigroup Inc Preferred Stock",
  "CAAP": "Corporacion America Airports S.A.",
  "CAAS": "China Automotive Systems, Inc. Ordinary Share",
  "CABA": "Cabaletta Bio, Inc. Common Stock",
  "CABO": "Cable One, Inc.",
  "CABR": "Caring Brands, Inc. Common Stock",
  "CAC": "Camden National Corporation",
  "CACC": "Credit Acceptance Corp",
  "CACI": "CACI INTERNATIONAL CLA",
  "CADL": "Candel Therapeutics, Inc. Common Stock",
  "CAE": "CAE Inc. Common Shares",
  "CAES": "Cantor Equity Partners VII, Inc. Class A",
  "CAF": "MORGAN STANLEY CHINA A SHARE FUND, INC",
  "CAG": "Conagra Brands, Inc.",
  "CAH": "Cardinal Health, Inc.",
  "CAI": "Caris Life Sciences, Inc. Common Stock",
  "CAII": "Collective Acquisition Corp. II Class A",
  "CAKE": "Cheesecake Factory (The)",
  "CAL": "Caleres Inc",
  "CALC": "CalciMedica, Inc. Common Stock",
  "CALM": "Cal-Maine Foods Inc",
  "CALX": "CALIX, INC.",
  "CALY": "Callaway Golf Company",
  "CAMP": "CAMP4 Therapeutics Corporation Common Stock",
  "CAMT": "Camtek Ltd",
  "CAN": "Canaan Inc. ADR",
  "CANF": "Can-Fite BioPharma Ltd. ADR",
  "CANG": "Cango Inc.",
  "CAPL": "CrossAmerica Partners LP Common units representing limited partner interests",
  "CAPN": "Cayson Acquisition Corp",
  "CAPR": "Capricor Therapeutics Inc",
  "CAPS": "Capstone Holding Corp. Common Stock",
  "CAQ": "Cambridge Acquisition Corp. Class A",
  "CAR": "Avis Budget Group, Inc.",
  "CARE": "Carter Bankshares, Inc. Common Stock",
  "CARG": "CarGurus, Inc. Class A Common Stock",
  "CARL": "Carlsmed, Inc. Common Stock",
  "CARR": "Carrier Global Corporation",
  "CARS": "Cars.com Inc. Common Stock",
  "CART": "Maplebear Inc. Common Stock",
  "CASH": "Pathward Financial, Inc. Common Stock",
  "CASS": "Cass Information Systems Inc",
  "CAST": "FreeCast, Inc. Class A Common Stock",
  "CASY": "Casey's General Stores Inc",
  "CAT": "Caterpillar Inc.",
  "CATO": "CATO CORP",
  "CATX": "Perspective Therapeutics, Inc.",
  "CATY": "Cathay General Bancorp",
  "CAVA": "CAVA Group, Inc.",
  "CB": "Chubb Limited",
  "CBAN": "Colony Bankcorp Inc.",
  "CBAT": "CBAK Energy Technology Limited",
  "CBC": "Central Bancompany, Inc. Class A Common Stock",
  "CBFV": "CB Financial Services, Inc. (PA)",
  "CBIO": "Crescent Biopharma, Inc. Common Stock",
  "CBK": "Commercial Bancgroup, Inc. Common Stock",
  "CBL": "CBL & Associates Properties, Inc.",
  "CBLL": "CeriBell, Inc. Common Stock",
  "CBNA": "Chain Bridge Bancorp, Inc.",
  "CBNK": "Capital Bancorp, Inc.",
  "CBOE": "Cboe Global Markets, Inc.",
  "CBRE": "CBRE GROUP, INC.",
  "CBRL": "Cracker Barrel Old Country Store, Inc,.",
  "CBRS": "Cerebras Systems Inc. Class A Common Stock",
  "CBSH": "Commerce Bancshares Inc",
  "CBT": "Cabot Corporation",
  "CBU": "Community Financial System, Inc.",
  "CBUS": "Cibus, Inc. Class A Common Stock",
  "CBZ": "CBIZ, Inc.",
  "CC": "The Chemours Company",
  "CCAP": "Crescent Capital BDC, Inc. Common stock",
  "CCAQ": "Collective Acquisition Corp. Class A",
  "CCB": "Coastal Financial Corporation",
  "CCBG": "Capital City Bank Group Inc",
  "CCC": "CCC Intelligent Solutions Holdings Inc. Common Stock",
  "CCCC": "C4 Therapeutics, Inc.",
  "CCCT": "Columbus Circle Capital Corp III Class A",
  "CCD": "Calamos Dynamic Convertible & Income Fund",
  "CCEC": "Capital Clean Energy Carriers Corp. Common Share",
  "CCEL": "Cryo-Cell International Inc.",
  "CCEP": "Coca-Cola Europacific Partners plc",
  "CCG": "Cheche Group Inc. Class A",
  "CCHH": "CCH Holdings Ltd Class A",
  "CCI": "Crown Castle Inc.",
  "CCID": "Carlyle Credit Income Fund Series D Preferred Shares",
  "CCIF": "Carlyle Credit Income Fund Shares of Beneficial Interest",
  "CCII": "Cohen Circle Acquisition Corp. II Class A",
  "CCJ": "Cameco Corporation",
  "CCK": "Crown Holdings Inc.",
  "CCL": "Carnival Corporation Ltd.",
  "CCLD": "CareCloud, Inc. Common Stock",
  "CCM": "Concord Medical Services Holding Limited",
  "CCNE": "CNB Financial Corp/PA",
  "CCNEP": "CNB Financial Corporation Series A Preferred Stock",
  "CCO": "Clear Channel Outdoor Holdings, Inc. Common Stock",
  "CCOI": "Cogent Communications Holdings, Inc.",
  "CCS": "CENTURY COMMUNITIES, INC.",
  "CCSI": "Consensus Cloud Solutions, Inc. Common Stock",
  "CCTG": "CCSC Technology International Holdings Limited Class A",
  "CCU": "Compania Cervecerias Unidas S.A.",
  "CCXI": "Churchill Capital Corp XI Class A",
  "CCZ": "Comcast Holdings Corp. Subordinated Debentures due 2029",
  "CD": "Chaince Digital Holdings Inc.",
  "CDE": "Coeur Mining, Inc.",
  "CDIO": "Cardio Diagnostics Holdings Inc. Common stock",
  "CDLR": "Cadeler A/S ADR",
  "CDLX": "Cardlytics, Inc. Common Stock",
  "CDNA": "CareDx, Inc.",
  "CDNL": "Cardinal Infrastructure Group Inc. Class A Common Stock",
  "CDNS": "Cadence Design Systems",
  "CDP": "COPT Defense Properties",
  "CDR-P-B": "CEDAR REALTY TRUST, INC Series B Preferred Stock",
  "CDR-P-C": "Cedar Realty Trust, Inc Series C Preferred Stock",
  "CDRE": "Cadre Holdings, Inc.",
  "CDRO": "Codere Online Luxembourg, S.A.",
  "CDT": "CDT Equity Inc. Common Stock",
  "CDTG": "CDT Environmental Technology Investment Holdings Limited ordinary shares",
  "CDW": "CDW Corporation",
  "CDXS": "Codexis, Inc.",
  "CDZI": "CADIZ, Inc.",
  "CDZIP": "Cadiz, Inc. Depositary Shares",
  "CE": "Celanese Corporation Common Stock",
  "CECO": "Ceco Environmental Corp",
  "CEE": "The Central and Eastern Europe Fund, Inc.",
  "CEG": "Constellation Energy Corporation Common Stock",
  "CELC": "Celcuity Inc. Common Stock",
  "CELH": "Celsius Holdings, Inc. Common Stock",
  "CELU": "Celularity Inc. Class A Common Stock",
  "CELZ": "Creative Medical Technology Holdings, Inc. Common Stock",
  "CENN": "Cenntro Inc. Common Stock",
  "CENT": "Central Garden and Pet Co",
  "CENTA": "Central Garden & Pet Company",
  "CENX": "Century Aluminum Co",
  "CEPF": "Cantor Equity Partners IV, Inc. Class A",
  "CEPL": "Capstone Energy Plus, Inc. Common Stock",
  "CEPO": "Cantor Equity Partners I, Inc. Class A",
  "CEPS": "Cantor Equity Partners VI, Inc. Class A",
  "CEPU": "Central Puerto S.A. ADR",
  "CEPV": "Cantor Equity Partners V, Inc. Class A",
  "CERS": "Cerus Corp",
  "CERT": "Certara, Inc. Common Stock",
  "CET": "Central Securities Corp.",
  "CETX": "CEMTREX INC.",
  "CETY": "Clean Energy Technologies, Inc. Common Stock",
  "CEV": "Eaton Vance California Municipal Income Trust",
  "CEVA": "CEVA Inc.",
  "CF": "CF Industries Holding, Inc.",
  "CFBK": "CF Bankshares Inc. Common Stock",
  "CFFI": "C&F Financial Corp",
  "CFFN": "Capitol Federal Financial, Inc.",
  "CFG": "Citizens Financial Group, Inc.",
  "CFG-P-E": "Citizens Financial Group, Inc Series E Preferred Stock",
  "CFG-P-H": "Citizens Financial Group, Inc Series H Preferred Stock",
  "CFG-P-I": "Citizens Financial Group, Inc Series I Preferred Stock",
  "CFND": "C1 Fund Inc.",
  "CFR": "Cullen/Frost Bankers Inc.",
  "CFR-P-B": "Cullen/Frost Bankers, Inc Series B Preferred Stock",
  "CFTR-P-A": "Cantor Fitzgerald Income Trust, Inc Series A Preferred Stock",
  "CG": "The Carlyle Group Inc. Common Stock",
  "CGAU": "Centerra Gold Inc.",
  "CGBD": "Carlyle Secured Lending, Inc. Common Stock",
  "CGC": "Canopy Growth Corporation Common Shares",
  "CGEM": "Cullinan Therapeutics, Inc. Common Stock",
  "CGEN": "Compugen Ltd",
  "CGNT": "Cognyte Software Ltd.",
  "CGNX": "Cognex Corp",
  "CGO": "Calamos Global Total Return Fund",
  "CGON": "CG Oncology, Inc. Common stock",
  "CGTL": "Creative Global Technology Holdings Limited Class A",
  "CGTX": "Cognition Therapeutics, Inc. Common Stock",
  "CHA": "Chagee Holdings Limited ADR",
  "CHAI": "Core AI Holdings, Inc. Common Shares",
  "CHAR": "Charlton Aria Acquisition Corporation Class A",
  "CHCI": "Comstock Holding Companies, Inc. Class A",
  "CHCO": "City Holding Co",
  "CHCT": "Community Healthcare Trust Incorporated Common Stock, $0.01 par value per share",
  "CHD": "Church & Dwight Co., Inc.",
  "CHDN": "Churchill Downs Inc",
  "CHE": "Chemed Corporation",
  "CHEC": "Chenghe Acquisition III Co. Class A Ordinary Share",
  "CHEF": "The Chef's Warehouse Inc",
  "CHGA": "Change Agents Corporation Common Stock",
  "CHGG": "CHEGG, INC.",
  "CHH": "Choice Hotels Intnl.",
  "CHI": "Calamos Convertible Opportunities and Income Fund",
  "CHKP": "Check Point Software Technologies Ltd",
  "CHMG": "Chemung Financial Corp",
  "CHMI": "CHERRY HILL MORTGAGE INVESTMENT CORPORATION",
  "CHMI-P-A": "Cherry Hill Mortgage Investment Corporation Series A Preferred Stock",
  "CHMI-P-B": "Cherry Hill Mortgage Investment Corporation Series B Preferred Stock",
  "CHNR": "China Natural Resources, Inc.",
  "CHOW": "ChowChow Cloud International Holdings Limited",
  "CHPG": "ChampionsGate Acquisition Corporation Class A Ordinary Share",
  "CHPT": "ChargePoint Holdings, Inc.",
  "CHR": "Cheer Holding, Inc. Class A Ordinary Share",
  "CHRD": "Chord Energy Corporation Common Stock",
  "CHRN": "ChronoScale Holdings Corporation Common Stock",
  "CHRS": "Coherus Oncology, Inc. Common Stock",
  "CHRW": "C.H. Robinson Worldwide, Inc.",
  "CHSCL": "CHS Inc Class B Class B Preferred Stock",
  "CHSCM": "CHS Inc Class B Class B Preferred Stock",
  "CHSCN": "CHS Inc Preferred Class B Series 2 Reset Rate",
  "CHSCO": "CHS Inc. Class B Class B Preferred Stock",
  "CHSCP": "CHS Inc. 8% Cumulative Redeemable Pfd",
  "CHSN": "Chanson International Holding Class A",
  "CHT": "CHUNGHWA TELECOM CO., LTD",
  "CHTR": "Charter Comm Inc Del CL A New",
  "CHW": "Calamos Global Dynamic Income Fund",
  "CHWY": "Chewy, Inc.",
  "CHY": "Calamos Convertible and High Income Fund",
  "CHYM": "Chime Financial, Inc. Class A Common Stock",
  "CI": "The Cigna Group",
  "CIA": "Citizens, Inc.",
  "CIB": "Grupo Cibest S.A. American Preferred Shares",
  "CIEN": "Ciena Corporation",
  "CIFR": "Cipher Digital Inc. Common Stock",
  "CIG": "Companhia Energetica De Minas Gerais-CEMIG",
  "CIG-C": "Companhia Energetica De Minas Gerais-CEMIG",
  "CIGI": "Colliers International Group Inc. Subordinate Voting Shares",
  "CIGL": "Concorde International Group Ltd Class A",
  "CII": "BlackRock Enhanced Large Cap Core Fund, Inc.",
  "CIIT": "Tianci International, Inc. Common Stock",
  "CIK": "Credit Suisse Asset Management Income Fund Inc.",
  "CIM": "Chimera Investment Corp.",
  "CIM-P-A": "Chimera Investment Corporation Series A Preferred Stock",
  "CIM-P-B": "Chimera Investment Corporation Series B Preferred Stock",
  "CIM-P-C": "Chimera Investment Corporation Series C Preferred Stock",
  "CIM-P-D": "Chimera Investment Corporation Series D Preferred Stock",
  "CINF": "Cincinnati Financial Corp",
  "CING": "Cingulate Inc. Common Stock",
  "CINT": "CI&T Inc",
  "CION": "CION Investment Corporation",
  "CIRC": "Circle8 Group, Inc. Common Stock",
  "CISO": "CISO Global, Inc. Common Stock",
  "CISS": "C3is Inc. Common Stock",
  "CITR": "CitroTech Inc.",
  "CIVB": "Civista Bancshares, Inc.",
  "CIX": "Comp X International Inc.",
  "CJMB": "Callan JMB Inc. Common Stock",
  "CKX": "CKX Lands, Inc.",
  "CL": "Colgate-Palmolive Company",
  "CLAR": "Clarus Corporation Common Stock",
  "CLB": "Core Laboratories Inc.",
  "CLBK": "Columbia Financial, Inc. Common Stock",
  "CLBR": "Colombier Acquisition Corp. III",
  "CLBT": "Cellebrite DI Ltd. Class A",
  "CLDI": "Calidi Biotherapeutics, Inc.",
  "CLDT": "CHATHAM LODGING TRUST",
  "CLDT-P-A": "Chatham Lodging Trust Series A Preferred Shares",
  "CLDX": "Celldex Therapeutics, Inc",
  "CLF": "Cleveland-Cliffs Inc.",
  "CLFD": "Clearfield, Inc.",
  "CLGN": "CollPlant Biotechnologies Ltd",
  "CLH": "Clean Harbors, Inc",
  "CLIK": "Click Holdings Limited Class A Ordinary Share",
  "CLIR": "ClearSign Technologies Corporation Common Stock (DE)",
  "CLLS": "Cellectis S.A. ADR",
  "CLM": "Cornerstone Strategic Investment Fund, Inc.",
  "CLMB": "Climb Global Solutions, Inc. Common Stock",
  "CLMT": "Calumet, Inc. Common Stock",
  "CLNE": "Clean Energy Fuels Corp.",
  "CLNN": "Clene Inc. Common Stock",
  "CLOV": "Clover Health Investments, Corp",
  "CLPR": "Clipper Realty Inc. Common Stock",
  "CLPS": "CLPS Incorporation Common Stock",
  "CLPT": "ClearPoint Neuro, Inc. Common Stock",
  "CLRB": "Cellectar Biosciences INC NEW",
  "CLRO": "ClearOne, Inc. Common Stock",
  "CLS": "Celestica, Inc.",
  "CLSK": "CLEANSPARK INC",
  "CLST": "Catalyst Bancorp, Inc. Common Stock",
  "CLVT": "Clarivate Plc",
  "CLW": "Clearwater Paper Corporation",
  "CLWT": "Euro Tech Holdings Co Ltd. New",
  "CLX": "Clorox Company",
  "CLYM": "Climb Bio, Inc. Common Stock",
  "CM": "Canadian Imperial Bank of Commerce",
  "CMBT": "CMB.TECH NV",
  "CMC": "Commercial Metals Company",
  "CMCL": "Caledonia Mining Corporation Plc",
  "CMCM": "Cheetah Mobile Inc. ADR",
  "CMCO": "Columbus McKinnon Corp/NY",
  "CMCSA": "Comcast Corp",
  "CMCT": "Creative Media & Community Trust Corporation Common stock",
  "CMDB": "Costamare Bulkers Holdings Limited",
  "CME": "CME Group Inc.",
  "CMG": "Chipotle Mexican Grill, Inc.",
  "CMI": "Cummins Inc.",
  "CMII": "Columbus Circle Capital Corp II Class A",
  "CMMB": "Chemomab Therapeutics Ltd. ADR",
  "CMND": "Clearmind Medicine Inc. Common Shares",
  "CMP": "Compass Minerals International, Inc.",
  "CMPR": "Cimpress PLC Ordinary Shares (Ireland)",
  "CMPS": "COMPASS Pathways Plc ADR",
  "CMPX": "Compass Therapeutics, Inc. Common Stock",
  "CMRC": "Commerce.com, Inc. Series 1 Common Stock",
  "CMRE": "Costamare Inc.",
  "CMRE-P-B": "Costamare Inc Series B Preferred Stock",
  "CMRE-P-C": "COSTAMARE INC Series C Preferred Stock",
  "CMRE-P-D": "Costamare Inc Series D Preferred Stock",
  "CMS": "CMS Energy Corporation",
  "CMS-P-B": "Consumers Energy Company $4.50 Cumulative Preferred",
  "CMS-P-C": "CMS Energy Corporation Series C Preferred Stock",
  "CMT": "Core Molding Technologies, Inc.",
  "CMTG": "Claros Mortgage Trust, Inc.",
  "CMTL": "Comtech Telecommunications",
  "CMTV": "Community Bancorp. Common Stock",
  "CNA": "CNA Financial Corporation",
  "CNC": "Centene Corporation",
  "CNCK": "Coincheck Group N.V.",
  "CNDT": "Conduent Incorporated Common Stock",
  "CNET": "ZW Data Action Technologies Inc. Common Stock",
  "CNEY": "CN Energy Group Inc. Class A",
  "CNF": "CNFinance Holdings Limited ADR",
  "CNH": "CNH INDUSTRIAL N.V.",
  "CNI": "Canadian National Railway",
  "CNK": "Cinemark Holdings, Inc.",
  "CNL": "Collective Mining Ltd.",
  "CNM": "Core & Main, Inc.",
  "CNMD": "CONMED Corporation",
  "CNNE": "Cannae Holdings, Inc. Common Stock",
  "CNO": "CNO Financial Group, Inc.",
  "CNOB": "Center Bancorp Inc",
  "CNOBP": "ConnectOne Bancorp, Inc Series A Preferred Stock",
  "CNP": "CenterPoint Energy, Inc.",
  "CNQ": "Canadian Natural Resources Limited",
  "CNR": "Core Natural Resources, Inc.",
  "CNS": "Cohen & Steers Inc.",
  "CNSP": "CNS Pharmaceuticals, Inc. Common Stock",
  "CNSY": "Cerenome, Inc. Common Stock",
  "CNTB": "Connect Biopharma Holdings Limited",
  "CNTN": "Canton Strategic Holdings, Inc. Common Stock",
  "CNTX": "Context Therapeutics Inc. Common Stock",
  "CNTY": "Century Casinos Inc",
  "CNVS": "Cineverse Corp. Class A Common Stock",
  "CNX": "CNX Resources Corporation",
  "CNXC": "Concentrix Corporation Common Stock",
  "CNXN": "PC Connection Inc",
  "CNXU": "Conexeu Sciences Inc. Common Stock",
  "COAG": "Hemab Therapeutics Holdings, Inc. Common Stock",
  "COCH": "Envoy Medical, Inc. Class A Common Stock",
  "COCO": "The Vita Coco Company, Inc. Common Stock",
  "COCP": "Cocrystal Pharma, Inc. Common Stock",
  "CODA": "Coda Octopus Group, Inc. Common stock",
  "CODI": "Compass Diversified",
  "CODI-P-A": "Compass Diversified Holdings Series A Preferred Shares",
  "CODI-P-B": "Compass Diversified Holdings Series B Preferred Shares",
  "CODI-P-C": "Compass Diversified Holdings Series C Preferred Shares",
  "CODX": "Co-Diagnostics, Inc. Common Stock",
  "COE": "51Talk Online Education Group ADR",
  "COF": "Capital One Financial",
  "COF-P-I": "Capital One Financial Corporation Series I Preferred Stock",
  "COF-P-J": "Capital One Financial Corporation Series J Preferred Stock",
  "COF-P-K": "Capital One Financial Corporation Series K Preferred Stock",
  "COF-P-L": "Capital One Financial Corporation Series L Preferred Stock",
  "COF-P-N": "Capital One Financial Corporation Series N Preferred Stock",
  "COFS": "CHOICEONE FINANCIAL",
  "COGT": "Cogent Biosciences, Inc. Common Stock",
  "COHN": "Cohen & Company Inc",
  "COHR": "Coherent Corp.",
  "COHU": "Cohu Inc",
  "COIN": "Coinbase Global, Inc. Class A Common Stock",
  "COKE": "Coca-Cola Consolidated, Inc. Common Stock",
  "COLA": "Columbus Acquisition Corp",
  "COLB": "Columbia Banking Systems Inc",
  "COLD": "Americold Realty Trust, Inc.",
  "COLL": "Collegium Pharmaceutical, Inc. Common Stock",
  "COLM": "Columbia Sportswear Co",
  "COMP": "Compass, Inc.",
  "CON": "Concentra Group Holdings Parent, Inc.",
  "COO": "The Cooper Companies, Inc. Common Stock",
  "COOK": "Traeger, Inc.",
  "COOT": "Australian Oilseeds Holdings Limited",
  "COP": "ConocoPhillips",
  "COPL": "Copley Acquisition Corp",
  "COPR": "Idaho Copper Corporation",
  "COR": "Cencora, Inc.",
  "CORT": "Corcept Therapeutics Inc.",
  "CORZ": "Core Scientific, Inc. Common Stock",
  "COSM": "Cosmos Holdings Inc. Common Stock",
  "COSO": "CoastalSouth Bancshares, Inc.",
  "COST": "Costco Wholesale Corp",
  "COTY": "COTY INC",
  "COUR": "Coursera, Inc.",
  "COYA": "Coya Therapeutics, Inc. Common Stock",
  "CP": "Canadian Pacific Kansas City Limited",
  "CPA": "Copa Holdings, S.A.",
  "CPAC": "CEMENTOS PACASMAYO S.A.A.",
  "CPAY": "Corpay, Inc.",
  "CPB": "The Campbell's Company Common Stock",
  "CPBI": "Central Plains Bancshares, Inc. Common Stock",
  "CPF": "Central Pacific Financial Corporation",
  "CPHC": "Canterbury Park Holding Corporation 'New' Common Stock",
  "CPHI": "China Pharma Holdings, Inc.",
  "CPIX": "Cumberland Pharmaceuticals Inc",
  "CPK": "Chesapeake Utilities",
  "CPNG": "Coupang, Inc.",
  "CPOP": "Pop Culture Group Co., Ltd Class A",
  "CPRI": "Capri Holdings Limited",
  "CPRT": "Copart Inc",
  "CPS": "Cooper-Standard Automotive Inc.",
  "CPSH": "CPS Technologies Corp. Common Stock",
  "CPSS": "Consumer Portfolio Services",
  "CPT": "Camden Property Trust",
  "CPZ": "Calamos Long/Short Equity & Dynamic Income Trust Common Stock",
  "CQP": "Cheniere Energy Partners, LP",
  "CR": "Crane Company",
  "CRAC": "Crown Reserve Acquisition Corp. I Class A",
  "CRAI": "CRA International, Inc.",
  "CRAN": "Crane Harbor Acquisition Corp. II Class A",
  "CRAQ": "Cal Redwood Acquisition Corp. Class A",
  "CRBG": "Corebridge Financial, Inc.",
  "CRBP": "Corbus Pharmaceuticals Holdings, Inc.",
  "CRBU": "Caribou Biosciences, Inc. Common Stock",
  "CRC": "California Resources Corporation",
  "CRCL": "Circle Internet Group, Inc.",
  "CRCT": "Cricut, Inc. Class A Common Stock",
  "CRD-A": "Crawford & Company Class A",
  "CRD-B": "Crawford & Company Class B",
  "CRDF": "Cardiff Oncology, Inc. Common Stock",
  "CRDL": "Cardiol Therapeutics Inc. Class A Common Shares",
  "CRDO": "Credo Technology Group Holding Ltd",
  "CRE": "Cre8 Enterprise Limited Class A",
  "CRESY": "Cresud SA",
  "CREX": "CREATIVE REALITIES, INC.",
  "CRF": "Cornerstone Total Return Fund, Inc",
  "CRGO": "Freightos Limited",
  "CRGY": "Crescent Energy Company",
  "CRH": "CRH Public Limited Company",
  "CRI": "Carter's Inc.",
  "CRIS": "Curis Inc",
  "CRK": "Comstock Resources, Inc.",
  "CRL": "Charles River Laboratories International, Inc.",
  "CRM": "Salesforce, Inc.",
  "CRMD": "CorMedix Inc.",
  "CRML": "Critical Metals Corp.",
  "CRMT": "America's Car Mart Inc",
  "CRNC": "Cerence Inc. Common Stock",
  "CRNT": "Ceragon Networks Ltd",
  "CRNX": "Crinetics Pharmaceuticals, Inc.",
  "CRON": "Cronos Group Inc. Common Share",
  "CROX": "Crocs, Inc.",
  "CRS": "Carpenter Technology Corp",
  "CRSP": "CRISPR Therapeutics AG",
  "CRSR": "Corsair Gaming, Inc. Common Stock",
  "CRT": "Cross Timbers Royalty Trust",
  "CRTO": "Criteo S.A.",
  "CRUS": "Cirrus Logic Inc",
  "CRVL": "Corvel Corp",
  "CRVO": "CervoMed Inc. Common Stock",
  "CRVS": "Corvus Pharmaceuticals, Inc.",
  "CRWD": "CrowdStrike Holdings, Inc. Class A Common Stock",
  "CRWS": "Crown Crafts Inc",
  "CRWV": "CoreWeave, Inc. Class A Common Stock",
  "CSAI": "Cloudastructure, Inc. Class A Common Stock",
  "CSAN": "Cosan S.A. ADR",
  "CSBR": "Champions Oncology, Inc.",
  "CSCO": "Cisco Systems, Inc. Common Stock (DE)",
  "CSGP": "CoStar Group Inc",
  "CSHR": "CoinShares PLC",
  "CSIQ": "Canadian Solar Inc. Common Shares (ON)",
  "CSL": "Carlisle Companies, Inc.",
  "CSPI": "CSP Inc.",
  "CSQ": "Calamos Strategic Total Return Fund",
  "CSQR": "Csquare, Inc.",
  "CSR": "Centerspace",
  "CSTE": "Caesarstone Ltd.",
  "CSTL": "Castle Biosciences, Inc. Common Stock",
  "CSTM": "Constellium SE Class A",
  "CSV": "Carriage Services, Inc.",
  "CSW": "CSW Industrials, Inc.",
  "CSWC": "Capital Southwest Corp",
  "CSX": "CSX Corporation",
  "CTA-P-A": "EIDP, Inc. Preferred Stock $3.50 Series",
  "CTA-P-B": "EIDP, Inc. Preferred Stock $4.50 Series",
  "CTAA": "ClearThink 1 Acquisition Corp. Class A",
  "CTAS": "Cintas Corp",
  "CTBI": "Community Trust Bancorp Inc",
  "CTEV": "Claritev Corporation",
  "CTGO": "Contango Silver & Gold Inc.",
  "CTKB": "Cytek Biosciences, Inc. Common Stock",
  "CTM": "Castellum, Inc.",
  "CTMX": "CytomX Therapeutics, Inc.",
  "CTNM": "Contineum Therapeutics, Inc. Class A Common Stock",
  "CTNT": "Cheetah Net Supply Chain Service Inc. Class A Common Stock",
  "CTO": "CTO Realty Growth, Inc.",
  "CTO-P-A": "CTO Realty Growth, Inc Series A Preferred Stock",
  "CTOR": "Citius Oncology, Inc. Common Stock",
  "CTOS": "Custom Truck One Source, Inc.",
  "CTRE": "CareTrust REIT, Inc",
  "CTRI": "Centuri Holdings, Inc.",
  "CTRM": "Castor Maritime Inc. Common Stock",
  "CTRN": "Citi Trends, Inc.",
  "CTS": "CTS Corporation",
  "CTSH": "Cognizant Technology Solutions",
  "CTSO": "Cytosorbents Corp.",
  "CTVA": "Corteva, Inc. Common Stock",
  "CTW": "CTW Class A",
  "CTXR": "Citius Pharmaceuticals Inc. Common",
  "CUB": "Lionheart Holdings Class A",
  "CUBE": "CubeSmart",
  "CUBI": "CUSTOMERS BANCORP INC",
  "CUE": "Cue Biopharma, Inc.",
  "CULP": "Culp, Inc. Common Stock",
  "CUPR": "Cuprina Holdings (Cayman) Limited Class A",
  "CURB": "Curbline Properties Corp.",
  "CURI": "CuriosityStream Inc. Class A Common Stock",
  "CURR": "Currenc Group Inc.",
  "CURV": "Torrid Holdings Inc.",
  "CURX": "Curanex Pharmaceuticals Inc Common Stock",
  "CUVL": "Clinuvel Pharmaceuticals Limited ADR",
  "CUZ": "Cousins Properties Inc.",
  "CV": "CapsoVision, Inc. Common Stock",
  "CVBF": "CVB Financial Corp",
  "CVCO": "Cavco Industries Inc.",
  "CVE": "Cenovus Energy Inc.",
  "CVEO": "Civeo Corporation",
  "CVGI": "Commercial Vehicle Group, Inc.",
  "CVI": "CVR ENERGY, INC.",
  "CVKD": "Cadrenal Therapeutics, Inc. Common Stock",
  "CVLG": "Covenant Logistics Group, Inc.",
  "CVLT": "Commault Systems, Inc.",
  "CVM": "Cel-Sci Corporation",
  "CVNA": "Carvana Co.",
  "CVR": "Chicago Rivet & Machine Co.",
  "CVRX": "CVRx, Inc. Common Stock",
  "CVS": "CVS HEALTH CORPORATION",
  "CVSA": "Covista Inc.",
  "CVU": "CPI Aerostructures, Inc.",
  "CVV": "CVD Equipment Corp.",
  "CVX": "Chevron Corporation",
  "CW": "Curtiss-Wright Corp.",
  "CWBC": "Community West Bancshares Common Stock",
  "CWCO": "Consolidated Water Co Inc",
  "CWD": "CaliberCos Inc. Class A Common Stock",
  "CWEN": "Clearway Energy, Inc. Class C Common Stock",
  "CWH": "Camping World Holdings, Inc.",
  "CWK": "Cushman & Wakefield Ltd.",
  "CWST": "Casella Waste Systems Inc",
  "CWT": "California Water Service",
  "CX": "Cemex S.A.B. de C.V.",
  "CXAI": "CXApp Inc. Class A Common Stock",
  "CXDO": "CREXENDO INC",
  "CXII": "Churchill Capital Corp XII Class A",
  "CXM": "Sprinklr, Inc.",
  "CXT": "Crane NXT, Co.",
  "CXW": "CoreCivic, Inc.",
  "CYAB": "Cyabra, Inc. Common Stock",
  "CYCN": "Cyclerion Therapeutics, Inc. Common Stock",
  "CYCU": "Cycurion, Inc. Common Stock",
  "CYD": "China Yuchai International Ltd.",
  "CYH": "Community Health Systems, Inc.",
  "CYN": "Cyngn Inc. Common Stock",
  "CYPH": "Cypherpunk Technologies Inc. Common Stock",
  "CYRX": "CryoPort, Inc. Common Stock",
  "CYTK": "Cytokinetics Inc.",
  "CZFS": "Citizens Financial Services, Inc. Common Stock",
  "CZNC": "Citizens & Northern Corporation",
  "CZR": "Caesars Entertainment, Inc. Common Stock",
  "CZWI": "Citizens Community Bancorp, Inc.",
  "D": "Dominion Energy, Inc Common Stock",
  "DAAQ": "Digital Asset Acquisition Corp. Class A",
  "DAC": "Danaos Corporation",
  "DAIC": "CID HoldCo, Inc. Common Stock",
  "DAIO": "Data I/O Corp",
  "DAKT": "Daktronics Inc",
  "DAL": "Delta Air Lines, Inc.",
  "DAN": "Dana Incorporated",
  "DAO": "Youdao, Inc. ADR",
  "DAR": "DARLING INGREDIENTS INC.",
  "DARE": "Dare Bioscience, Inc. Common Stock",
  "DASH": "DoorDash, Inc. Class A Common Stock",
  "DAVA": "Endava plc ADR",
  "DAVE": "Dave Inc. Class A Common Stock",
  "DB": "Deutsche Bank Aktiengesellschaft",
  "DBCA": "D. Boral Acquisition I Corp. Class A",
  "DBD": "Diebold Nixdorf, Incorporated",
  "DBGI": "Digital Brands Group, Inc. Common Stock",
  "DBI": "Designer Brands Inc.",
  "DBL": "DOUBLELINE OPPORTUNISTIC CREDIT FUND",
  "DBRG": "DigitalBridge Group, Inc.",
  "DBRG-P-H": "DigitalBridge Group, Inc Series H Preferred Stock",
  "DBRG-P-I": "DigitalBridge Group, Inc Series I Preferred Stock",
  "DBRG-P-J": "DigitalBridge Group, Inc Series J Preferred Stock",
  "DBVT": "DBV Technologies S.A.",
  "DBX": "Dropbox, Inc. Class A",
  "DC": "Dakota Gold Corp.",
  "DCBO": "Docebo Inc. Common Shares",
  "DCGO": "DocGo Inc. Common Stock",
  "DCH": "Dauch Corporation",
  "DCI": "Donaldson Company, Inc.",
  "DCO": "Ducommun Incorporated",
  "DCOM": "Dime Commercial Bancshares, Inc.",
  "DCOM-P": "Dime Commercial Bancshares, Inc. Preferred Stock, Series A",
  "DCOY": "Decoy Therapeutics Inc. Common Stock",
  "DCTH": "Delcath Systems Inc",
  "DCX": "Digital Currency X Technology Inc. Class A",
  "DD": "DuPont de Nemours, Inc. Common Stock",
  "DDC": "DDC Enterprise Limited",
  "DDD": "3D Systems Corporation",
  "DDI": "DoubleDown Interactive Co., Ltd. ADR",
  "DDL": "Dingdong (Cayman) Limited ADR",
  "DDOG": "Datadog, Inc. Class A Common Stock",
  "DDS": "Dillards Inc.",
  "DDT": "Dillard's Capital Trust I 7.50% Capital Securities",
  "DE": "Deere & Company",
  "DEA": "Easterly Government Properties, Inc.",
  "DEC": "Diversified Energy Company",
  "DECK": "Deckers Outdoor Corp",
  "DEFT": "Defi Technologies, Inc.",
  "DEI": "Douglas Emmett, Inc.",
  "DELL": "Dell Technologies Inc.",
  "DEO": "Diageo plc",
  "DERM": "Journey Medical Corporation Common Stock",
  "DETX": "Liberty Defense Holdings, Ltd. Common Shares",
  "DFDV": "DeFi Development Corp. Common Stock",
  "DFH": "Dream Finders Homes, Inc.",
  "DFIN": "Donnelley Financial Solutions, Inc.",
  "DFLI": "Dragonfly Energy Holdings Corp. Common Stock (NV)",
  "DFNS": "T3 Defense Inc. Common Stock",
  "DFP": "FLAHERTY & CRUMRINE DYNAMIC PREFERRED AND INCOME FUND INCORPORATED",
  "DFSC": "DEFSEC Technologies Inc. Common Stock",
  "DFTX": "Definium Therapeutics, Inc. Common Shares",
  "DG": "Dollar General Corp.",
  "DGAC": "Disciplined Growth Acquisition Corporation",
  "DGICA": "Donegal Group Inc",
  "DGICB": "Donegal Group Inc",
  "DGII": "Digi International Inc",
  "DGNX": "Diginex Limited",
  "DGX": "Quest Diagnostics Inc.",
  "DGXX": "Digi Power X Inc. Subordinate Voting Shares",
  "DH": "Definitive Healthcare Corp. Class A Common Stock",
  "DHC": "Diversified Healthcare Trust",
  "DHF": "BNY Mellon High Yield Strategies Fund",
  "DHI": "D.R. Horton Inc.",
  "DHR": "Danaher Corporation",
  "DHT": "DHT HOLDINGS, INC.",
  "DHX": "DHI Group, Inc.",
  "DHY": "Credit Suisse High Yield Credit Fund",
  "DIBS": "1stdibs.com, Inc. Common Stock",
  "DIN": "Dine Brands Global, Inc.",
  "DINO": "HF Sinclair Corporation",
  "DIOD": "Diodes Inc",
  "DIS": "The Walt Disney Company",
  "DIT": "AMCON Distributing Co.",
  "DJCO": "Daily Journal Corp",
  "DJT": "Trump Media & Technology Group Corp. Common Stock",
  "DK": "Delek US Holdings, Inc.",
  "DKI": "DarkIris Inc. Class A",
  "DKL": "DELEK LOGISTICS PARTNERS, LP",
  "DKNG": "DraftKings Inc. Class A Common Stock",
  "DKS": "Dick's Sporting Goods, Inc.",
  "DLB": "Dolby Laboratories, Inc.Class A",
  "DLHC": "DLH Holdings Corp.",
  "DLNG": "DYNAGAS LNG PARNERS LP",
  "DLO": "DLocal Limited Class A Common Shares",
  "DLPN": "Dolphin Entertainment, Inc.",
  "DLR": "Digital Realty Trust, Inc.",
  "DLR-P-J": "Digital Realty Trust, Inc Series J Preferred Stock",
  "DLR-P-K": "Digital Realty Trust, Inc Series K Preferred Stock",
  "DLR-P-L": "Digital Realty Trust, Inc Series L Preferred Stock",
  "DLTH": "Duluth Holdings Inc. Class B Common Stock",
  "DLTR": "Dollar Tree Inc.",
  "DLX": "Deluxe Corporation",
  "DLXY": "Delixy Holdings Limited Class A",
  "DLY": "DoubleLine Yield Opportunities Fund",
  "DMA": "Destra Multi-Alternative Fund",
  "DMAA": "Drugs Made In America Acquisition Corp.",
  "DMAC": "DiaMedica Therapeutics Inc. Common Stock",
  "DMB": "BNY Mellon Municipal Bond Infrastructure Fund, Inc.",
  "DMC": "Del Monte Corporation",
  "DMII": "Drugs Made In America Acquisition II Corp.",
  "DMLP": "Dorchester Minerals LP",
  "DMO": "Western Asset Mortgage Opportunity Fund Inc.",
  "DMRA": "Damora Therapeutics, Inc.",
  "DMRC": "Digimarc Corporation Common Stock",
  "DNA": "Ginkgo Bioworks Holdings, Inc.",
  "DNLI": "Denali Therapeutics Inc. Common Stock",
  "DNMX": "Dynamix Corporation III Class A",
  "DNN": "Denison Mines Corp",
  "DNOW": "DNOW Inc.",
  "DNP": "DNP Select Income Fund Inc.",
  "DNTH": "Dianthus Therapeutics, Inc. Common Stock",
  "DNUT": "Krispy Kreme, Inc. Common Stock",
  "DOC": "Healthpeak Properties, Inc.",
  "DOCN": "DigitalOcean Holdings, Inc.",
  "DOCS": "Doximity, Inc.",
  "DOCU": "DocuSign, Inc. Common Stock",
  "DOGZ": "Dogness (International) Corporation Class A Common Stock",
  "DOLE": "Dole plc",
  "DOMH": "Dominari Holdings Inc. Common Stock",
  "DOMO": "Domo, Inc. Class B Common Stock",
  "DOO": "BRP Inc. Common Subordinate Voting Shares",
  "DORM": "Dorman Products, Inc. New",
  "DOUG": "Douglas Elliman Inc.",
  "DOV": "Dover Corporation",
  "DOW": "Dow Inc.",
  "DOX": "Amdocs Limited",
  "DOYU": "DouYu International Holdings Limited ADS",
  "DPC": "DPC Holdings PLC",
  "DPG": "Duff & Phelps Utility and Infrastructure Fund Inc.",
  "DPRO": "Draganfly Inc. Common Shares",
  "DPU": "Top KingWin Ltd Class A",
  "DPZ": "Domino's Pizza Inc.",
  "DQ": "Daqo New Energy Corp. ADR",
  "DRCT": "Direct Digital Holdings, Inc. Class A Common Stock",
  "DRD": "DRDGOLD Ltd.",
  "DRDB": "Roman DBDR Acquisition Corp. II",
  "DRH": "Diamondrock Hospitality Company Common Stock",
  "DRI": "Darden Restaurants, Inc.",
  "DRIO": "DarioHealth Corp. Common Stock",
  "DRMA": "Dermata Therapeutics, Inc. Common Stock",
  "DRS": "Leonardo DRS, Inc. Common Stock",
  "DRTS": "Alpha Tau Medical Ltd.",
  "DRUG": "Bright Minds Biosciences Inc. Common Stock",
  "DRVN": "Driven Brands Holdings Inc. Common Stock",
  "DSAC": "Daedalus Special Acquisition Corp. Class A",
  "DSC": "DSC Holdings Ltd. ADR",
  "DSGN": "Design Therapeutics, Inc. Common Stock",
  "DSGR": "Distribution Solutions Group, Inc. Common Stock",
  "DSGX": "Descartes Systems Group Inc",
  "DSL": "DOUBLELINE INCOME SOLUTIONS FUND",
  "DSM": "BNY Mellon Strategic Municipal Bond Fund, Inc.",
  "DSP": "Viant Technology Inc. Class A Common Stock",
  "DSS": "DSS, Inc.",
  "DSU": "Blackrock Debt Strategies Fund, Inc.",
  "DSWL": "Deswell Industries Inc",
  "DSX": "Diana Shipping, Inc.",
  "DSX-P-B": "DIANA SHIPPING INC Series B Preferred Shares",
  "DSY": "Big Tree Cloud Holdings Limited Class A",
  "DT": "Dynatrace, Inc.",
  "DTCX": "Datacentrex, Inc. Common Stock",
  "DTE": "DTE Energy Company",
  "DTF": "DTF Tax-Free Income 2028 Term Fund Inc.",
  "DTI": "Drilling Tools International Corporation Common Stock",
  "DTIL": "Precision BioSciences, Inc. Common Stock",
  "DTM": "DT Midstream, Inc.",
  "DTSQ": "DT Cloud Star Acquisition Corporation",
  "DTSS": "Datasea Intelligent Technology Ltd. Class A",
  "DTST": "Data Storage Corporation Common Stock",
  "DUK": "Duke Energy Corporation",
  "DUK-P-A": "Duke Energy Corporation Series A Preferred Stock",
  "DUKR": "DUKE Robotics Corp. Common Stock",
  "DUO": "Fangdd Network Group Ltd. Class A",
  "DUOL": "Duolingo, Inc. Class A Common Stock",
  "DUOT": "Duos Technologies Group, Inc. Common Stock",
  "DV": "DoubleVerify Holdings, Inc.",
  "DVA": "DaVita Inc.",
  "DVLT": "Datavault AI Inc. Common Stock",
  "DVN": "Devon Energy Corporation",
  "DWSN": "Dawson Geophysical Company New Common Stock",
  "DWTX": "Dogwood Therapeutics, Inc. Common Stock",
  "DX": "Dynex Capital, Inc.",
  "DX-P-C": "Dynex Capital, Inc Series C Preferred Stock",
  "DXC": "DXC Technology Company",
  "DXCM": "DexCom, Inc.",
  "DXF": "Eason Technology Limited ADR",
  "DXLG": "Destination XL Group, Inc. Common Stock",
  "DXPE": "DXP Enterprises Inc",
  "DXR": "Daxor Corporation Common Stock",
  "DXST": "Decent Holding Inc Class A",
  "DXYZ": "Destiny Tech100 Inc.",
  "DY": "Dycom Industries, Inc.",
  "DYAI": "Dyadic International, Inc.",
  "DYN": "Dyne Therapeutics, Inc. Common Stock",
  "DYNC": "Dynamix Corporation Class A",
  "DYOR": "Insight Digital Partners II Class A",
  "E": "ENI S.p.A.",
  "EAD": "Allspring Income Opportunities Fund",
  "EAF": "GrafTech International Ltd.",
  "EAI": "Entergy Arkansas, Bonds due 2066",
  "EARN": "Ellington Credit Company",
  "EAT": "Brinker International, Inc.",
  "EBAY": "eBay Inc",
  "EBC": "Eastern Bankshares, Inc. Common Stock",
  "EBF": "Ennis, Inc.",
  "EBMT": "Eagle Bancorp Montana, Inc",
  "EBON": "Ebang International Holdings Inc. Class A",
  "EBS": "Emergent Biosolutions, Inc.",
  "EC": "Ecopetrol S.A",
  "ECAT": "BlackRock ESG Capital Allocation Term Trust",
  "ECBK": "ECB Bancorp, Inc. Common Stock",
  "ECC": "Eagle Point Credit Company",
  "ECC-P-D": "Eagle Point Credit Company Series D Preferred Shares",
  "ECCC": "Eagle Point Credit Company Series C Preferred Shares",
  "ECF": "Ellsworth Growth and Income Fund Ltd",
  "ECF-P-A": "Ellsworth Growth and Income Fund Ltd Series A Preferred Shares",
  "ECG": "Everus Construction Group, Inc.",
  "ECHO": "EchoStar Corporation",
  "ECL": "Ecolab, Inc.",
  "ECO": "Okeanis Eco Tankers Corp.",
  "ECOR": "electroCore, Inc. Common Stock",
  "ECPG": "Encore Capital Group, Inc.",
  "ECVT": "Ecovyst Inc.",
  "ECX": "ECARX Holdings Inc. Class A",
  "ED": "Consolidated Edison, Inc.",
  "EDBL": "Edible Garden AG Incorporated Common Stock",
  "EDD": "Morgan Stanley Emerging Markets Domestic Debt Fund, Inc.",
  "EDF": "Virtus Stone Harbor Emerging Markets Income Fund",
  "EDHL": "Everbright Digital Holding Limited",
  "EDIT": "Editas Medicine, Inc. Common Stock",
  "EDN": "Empresa Distribuidora Y Comercializadora Norte S.A. (Edenor)",
  "EDRY": "EuroDry Ltd. Common Shares",
  "EDSA": "Edesa Biotech, Inc. Common Shares",
  "EDTK": "Skillful Craftsman Education Technology Limited Ordinary Share",
  "EDU": "New Oriental Education and Technology Group, Inc. ADR",
  "EDUC": "Educational Development Corp",
  "EE": "Excelerate Energy, Inc.",
  "EEA": "The European Equity Fund, Inc.",
  "EEFT": "Euronet Worldwide Inc",
  "EEIQ": "EpicQuest Education Group International Limited Common Stock",
  "EFC": "Ellington Financial Inc. Common Stock",
  "EFC-P-B": "Ellington Financial Inc Series B Preferred Stock",
  "EFC-P-C": "Ellington Financial Inc Series C Preferred Stock",
  "EFC-P-D": "Ellington Financial Inc Series D Preferred Stock",
  "EFOI": "Energy Focus, Inc.",
  "EFOR": "Everforth, Inc.",
  "EFR": "Eaton Vance Senior Floating-Rate Fund",
  "EFSC": "Enterprise Financial Services Corporation",
  "EFSCP": "Enterprise Financial Services Corporation Series A Preferred Stock",
  "EFSI": "Eagle Financial Services Inc Common Stock",
  "EFT": "Eaton Vance Floating-Rate Income Trust",
  "EFTY": "Etoiles Capital Group Co., Ltd. Class A",
  "EFX": "Equifax, Incorporated",
  "EFXT": "Enerflex Ltd.",
  "EG": "Everest Group, Ltd.",
  "EGAN": "eGain Corporation",
  "EGBN": "Eagle Bancorp Inc",
  "EGG": "Enigmatig Limited",
  "EGHA": "EGH Acquisition Corp. Class A",
  "EGHT": "8x8, Inc. Common Stock",
  "EGO": "Eldorado Gold Corporation",
  "EGP": "EastGroup Properties Inc.",
  "EGY": "Vaalco Energy, Inc.",
  "EH": "EHang Holdings Limited ADS",
  "EHC": "Encompass Health Corporation Common Stock",
  "EHGO": "Eshallgo Inc. Class A",
  "EHI": "Western Asset Global High Income Fund, Inc",
  "EHLD": "Euroholdings Ltd. Common Stock",
  "EHTH": "eHealth, Inc.",
  "EIC": "Eagle Point Income Company Inc.",
  "EICA": "Eagle Point Income Company Inc Series A Preferred Stock",
  "EIG": "Employers Holdings, Inc.",
  "EIIA": "Eagle Point Institutional Income Fund Series A Preferred Shares",
  "EIKN": "Eikon Therapeutics, Inc. Common Stock",
  "EIM": "Eaton Vance Municipal Bond Fund",
  "EIX": "Edison International",
  "EJH": "E-Home Household Service Holdings Limited",
  "EL": "The Estee Lauder Companies Inc. Class A",
  "ELA": "Envela Corporation",
  "ELAB": "PMGC Holdings Inc. Common Stock",
  "ELAN": "Elanco Animal Health Incorporated Common Stock",
  "ELBM": "Electra Battery Materials Corporation Common Stock",
  "ELC": "Entergy Louisiana, Bonds due 2066",
  "ELDN": "Eledon Pharmaceuticals, Inc. Common Stock",
  "ELE": "Elemental Royalty Corporation Common Stock",
  "ELF": "e.l.f. Beauty, Inc.",
  "ELLO": "Ellomay Capital LTD",
  "ELMD": "Electromed, Inc.",
  "ELME": "Elme Communities",
  "ELMT": "The Elmet Group Co. Common Stock",
  "ELOG": "Eastern International Ltd.",
  "ELOX": "Eloxx Pharmaceuticals, Inc. Common Stock",
  "ELPC": "Companhia Paranaense de Energia - COPEL ADR",
  "ELPW": "Elong Power Holding Limited Class A",
  "ELS": "Equity Lifestyle Properties, Inc.",
  "ELTK": "Eltek Ltd",
  "ELTX": "Elicio Therapeutics, Inc. Common Stock",
  "ELUT": "Elutia Inc. Class A Common Stock",
  "ELV": "Elevance Health, Inc.",
  "ELVA": "Electrovaya Inc. Common Shares",
  "ELVN": "Enliven Therapeutics, Inc. Common Stock",
  "ELVR": "Elevra Lithium Limited ADR",
  "ELWT": "Elauwit Connection, Inc. Common Stock",
  "EMA": "Emera Incorporated",
  "EMAT": "Evolution Metals & Technologies Corp. Common Stock",
  "EMBC": "Embecta Corp. Common Stock",
  "EMBJ": "Embraer S.A. ADR",
  "EMD": "Western Asset Emerging Markets Debt Fund, Inc",
  "EME": "EMCOR Group, Inc.",
  "EMF": "Templeton Emerging Markets Fund",
  "EMIS": "Emmis Acquisition Corp. Class A",
  "EML": "Eastern Company",
  "EMN": "Eastman Chemical Company",
  "EMO": "ClearBridge Energy Midstream Opportunity Fund Inc.",
  "EMP": "Entergy Mississippi, Bonds due 2066",
  "EMPD": "Empery Digital Inc. Common stock",
  "EMR": "Emerson Electric Co.",
  "ENB": "Enbridge, Inc",
  "ENGN": "enGene Therapeutics Inc. Common Stock",
  "ENGS": "Energys Group Limited",
  "ENHA": "Enhanced Group Inc.",
  "ENIC": "Enel Chile S.A. ADR",
  "ENJ": "Entergy New Orleans, Bonds due 2052",
  "ENLT": "Enlight Renewable Energy Ltd.",
  "ENLV": "Enlivex Ltd.",
  "ENO": "Entergy New Orleans, Bonds due 2066",
  "ENOV": "Enovis Corporation",
  "ENPH": "Enphase Energy, Inc.",
  "ENR": "Energizer Holdings, Inc",
  "ENRD": "Einride AB ADR",
  "ENS": "EnerSys, Inc.",
  "ENSC": "Ensysce Biosciences, Inc. Common Stock",
  "ENSG": "The Ensign Group, Inc.",
  "ENTA": "Enanta Pharmaceuticals, Inc",
  "ENTG": "Entegris Inc",
  "ENTX": "Entera Bio Ltd.",
  "ENVA": "Enova International, Inc.",
  "ENVB": "Enveric Biosciences, Inc. Common Stock",
  "ENVX": "Enovix Corporation Common Stock",
  "EOD": "Allspring Global Dividend Opportunity Fund",
  "EOG": "EOG Resources, Inc.",
  "EOI": "Eaton Vance Enhanced Equity Income Fund",
  "EOLS": "Evolus, Inc. Common Stock",
  "EONR": "EON Resources Inc.",
  "EOS": "Eaton Vance Enhance Equity Income Fund II",
  "EOSE": "Eos Energy Enterprises, Inc. Class A Common Stock",
  "EOT": "EATON VANCE NATIONAL MUNICIPAL OPPORTUNITIES TRUST",
  "EP": "Empire Petroleum Corporation",
  "EP-P-C": "El Paso Energy Capital Trust I",
  "EPAC": "Enerpac Tool Group Corp.",
  "EPAM": "EPAM SYSTEMS, INC.",
  "EPC": "Edgewell Personal Care Company",
  "EPD": "Enterprise Products Partners L.P.",
  "EPM": "Evolution Petroleum Corporation",
  "EPOW": "E-Power Inc. Class A",
  "EPR": "EPR Properties",
  "EPR-P-C": "EPR Properties Series C Preferred Shares",
  "EPR-P-E": "EPR Properties Series E Preferred Shares",
  "EPR-P-G": "EPR Properties Series G Preferred Shares",
  "EPRT": "Essential Properties Realty Trust, Inc.",
  "EPRX": "Eupraxia Pharmaceuticals Inc. Common Stock",
  "EPSM": "Epsium Enterprise Limited Class A",
  "EPSN": "Epsilon Energy Ltd.",
  "EQ": "Equillium, Inc. Common Stock",
  "EQBK": "Equity Bancshares, Inc.",
  "EQH": "Equitable Holdings, Inc.",
  "EQH-P-A": "Equitable Holdings, Inc Series A Preferred Stock",
  "EQH-P-C": "Equitable Holdings, Inc Series C Preferred Stock",
  "EQIX": "Equinix, Inc. Common Stock REIT",
  "EQNR": "Equinor ASA ADR",
  "EQPT": "EquipmentShare.com Inc Class A Common Stock",
  "EQR": "Equity Residential",
  "EQS": "Equus Total Return, Inc.",
  "EQT": "EQT CORP",
  "EQX": "Equinox Gold Corp.",
  "ERAS": "Erasca, Inc. Common Stock",
  "ERC": "Allspring Multi-Sector Income Fund",
  "ERH": "Allspring Utilities and High Income Fund",
  "ERIC": "Ericsson ADR",
  "ERIE": "Erie Indemnity Co",
  "ERII": "Energy Recovery, Inc.",
  "ERNA": "Ernexa Therapeutics Inc. Common Stock",
  "ERO": "Ero Copper Corp.",
  "EROC": "ERock, Inc.",
  "EROK": "EagleRock Land, LLC",
  "ES": "Eversource Energy",
  "ESAB": "ESAB Corporation",
  "ESBA": "EMPIRE STATE REALTY OP, L.P.  SERIES ES",
  "ESCA": "Escalade Inc",
  "ESE": "ESCO Technologies, Inc.",
  "ESEA": "Euroseas Ltd.(Marshall Islands)",
  "ESI": "Element Solutions Inc.",
  "ESLA": "Estrella Immunopharma, Inc. Common Stock",
  "ESLT": "Elbit Systems Ltd",
  "ESNT": "Essent Group LTD",
  "ESOA": "Energy Services of America Corporation Common Stock",
  "ESP": "Espey Mfg. & Electronics Corp",
  "ESQ": "Esquire Financial Holdings, Inc. Common Stock",
  "ESRT": "EMPIRE STATE REALTY TRUST, INC.",
  "ESS": "Essex Property Trust, Inc",
  "ESTA": "Establishment Labs Holdings Inc.",
  "ESTC": "Elastic N.V.",
  "ET": "Energy Transfer LP Common Units representing limited partner interests",
  "ETB": "Eaton Vance Tax-Managed Buy-Write Income Fund",
  "ETD": "Ethan Allen Interiors Inc",
  "ETG": "Eaton Vance Tax-Advantaged Global Dividend Income Fund",
  "ETI-P": "Entergy Texas, Inc Series A Preferred Stock",
  "ETJ": "Eaton Vance Risk - Managed Diversified Equity Income Fund",
  "ETN": "Eaton Corporation, plc",
  "ETO": "Eaton Vance Tax-Advantaged Global Div Oppor. Fund",
  "ETON": "Eton Pharmaceutcials, Inc. Common Stock",
  "ETOR": "eToro Group Ltd. Class A Common Shares",
  "ETR": "Entergy Corporation",
  "ETS": "Elite Express Holding Inc. Class A Common Stock",
  "ETSS": "Energy Transition Special Opportunities",
  "ETSY": "Etsy, Inc.",
  "ETV": "Eaton Vance Tax-Managed Buy-Write Opportunities Fund",
  "ETW": "Eaton Vance Tax-Managed Global Buy-Write Opportunities Fund",
  "ETX": "EATON VANCE MUNICIPAL INCOME 2028 TERM TRUST",
  "ETY": "Eaton Vance Tax-Managed Diversified Equity Income Fund",
  "EU": "enCore Energy Corp.",
  "EUDA": "EUDA Health Holdings Limited",
  "EURK": "Eureka Acquisition Corp Class A Ordinary Share",
  "EVAC": "EQV Ventures Acquisition Corp. II",
  "EVAX": "Evaxion A/S ADR",
  "EVC": "Entravision Communication",
  "EVCM": "EverCommerce Inc. Common Stock",
  "EVER": "EverQuote, Inc. Class A Common Stock",
  "EVEX": "Eve Holding, Inc.",
  "EVF": "Eaton Vance Senior Income Trust",
  "EVG": "Eaton Vance Short Duration Diversified Income Fund",
  "EVGN": "EVOGENE LTD.",
  "EVGO": "EVgo Inc. Class A Common Stock",
  "EVH": "Evolent Health, Inc Class A Common Stock",
  "EVI": "EVI Industries, Inc.",
  "EVLV": "Evolv Technologies Holdings, Inc. Class A Common Stock",
  "EVMN": "Evommune, Inc.",
  "EVN": "Eaton Vance Municipal Income Trust",
  "EVO": "Evotec SE ADR",
  "EVOX": "Evolution Global Acquisition Corp Class A",
  "EVR": "Evercore Inc.",
  "EVRG": "Evergy, Inc.",
  "EVT": "Eaton Vance Tax-Advantaged Dividend Income Fund",
  "EVTC": "EVERTEC, INC.",
  "EVTL": "Vertical Aerospace Ltd.",
  "EVV": "Eaton Vance Limited Duration Income Fund",
  "EW": "Edwards Lifesciences Corp",
  "EWBC": "East-West Bancorp Inc",
  "EWTX": "Edgewise Therapeutics, Inc. Common Stock",
  "EXC": "Exelon Corporation",
  "EXE": "Expand Energy Corporation Common Stock",
  "EXEL": "Exelixis Inc",
  "EXFY": "Expensify, Inc. Class A Common Stock",
  "EXG": "Eaton Vance Tax-Managed Global Diversified Equity Income Fund",
  "EXK": "Endeavour Silver Corp.",
  "EXLS": "ExlService Holdings, Inc.",
  "EXOD": "Exodus Movement, Inc.",
  "EXOZ": "eXoZymes Inc. Common Stock",
  "EXP": "Eagle Materials, Inc.",
  "EXPD": "Expeditors International of Washington, Inc.",
  "EXPE": "Expedia Group, Inc. Common Stock",
  "EXPO": "Exponent Inc",
  "EXR": "Extra Space Storage, Inc.",
  "EXTR": "Extreme Networks",
  "EXYN": "Exyn Technologies, Inc. Common Stock",
  "EYE": "National Vision Holdings, Inc. Common Stock",
  "EYPT": "EyePoint, Inc. Common Stock",
  "EZGO": "EZGO Technologies Ltd.",
  "EZPW": "Ezcorp Inc",
  "EZRA": "Reliance Global Group, Inc. Common Stock",
  "F": "Ford Motor Company",
  "FA": "First Advantage Corporation Common Stock",
  "FABC": "Fabric.AI, Inc. Common Stock",
  "FAC": "Factorial Energy Inc. Class A Common Stock",
  "FACT": "FACT II Acquisition Corp. Class A",
  "FAF": "First American Financial Corporation",
  "FAMI": "Farmmi, Inc. Class A",
  "FANG": "Diamondback Energy, Inc.",
  "FAST": "Fastenal Co",
  "FATE": "Fate Therapeutics, Inc.",
  "FATN": "FatPipe, Inc. Common Stock",
  "FAX": "abrdn Asia-Pacific Income Fund, Inc",
  "FBGL": "FBS Global Limited",
  "FBIN": "Fortune Brands Innovations, Inc.",
  "FBIO": "Fortress Biotech, Inc.",
  "FBIOP": "Fortress Biotech, Inc Series A Preferred Stock",
  "FBIZ": "First Business Financial Services, Inc.",
  "FBK": "FB Financial Corporation",
  "FBLA": "FB Bancorp, Inc. Common Stock",
  "FBLG": "FibroBiologics, Inc. Common Stock",
  "FBNC": "First Bancorp/NC",
  "FBP": "First BanCorp.",
  "FBRT": "Franklin BSP Realty Trust, Inc.",
  "FBRT-P-E": "Franklin BSP Realty Trust, Inc Series E Preferred Stock",
  "FBRX": "Forte Biosciences, Inc. Common Stock",
  "FBYD": "Falcon's Beyond Global, Inc. Class A Common Stock",
  "FBYDP": "Falcon's Beyond Global, Inc Series B Preferred Stock",
  "FC": "Franklin Covey Company",
  "FCAP": "First Capital Inc",
  "FCBC": "First Community Bankshares, Inc. (VA)",
  "FCBM": "First Carolina Financial Services, Inc.",
  "FCCO": "First Community Corp",
  "FCEL": "FuelCell Energy Inc  NEW (DE)",
  "FCF": "First Commonwealth Financial Corporation",
  "FCFS": "FirstCash Holdings, Inc. Common Stock",
  "FCHL": "Fitness Champs Holdings Limited Common Stock",
  "FCN": "FTI Consulting, Inc.",
  "FCNCA": "First Citizens BancShares Inc",
  "FCNCN": "First Citizens BancShares, Inc Series E Preferred Stock",
  "FCNCO": "First Citizens BancShares, Inc Series C Preferred Stock",
  "FCNCP": "First Citizens BancShares, Inc Series A Preferred Stock",
  "FCPT": "Four Corners Property Trust, Inc.",
  "FCRS": "FutureCrest Acquisition Corp.",
  "FCT": "First Trust Senior Floating Rate Income Fund II",
  "FCUV": "Focus Universal Inc. Common Stock",
  "FCX": "Freeport-McMoran Inc.",
  "FDBC": "Fidelity D & D Bancorp, Inc. Common Stock",
  "FDMM": "Freedom Metals Acquisition Corp. Class A",
  "FDMT": "4D Molecular Therapeutics, Inc. Common Stock",
  "FDS": "Factset Research Systems",
  "FDSB": "Fifth District Bancorp, Inc. Common Stock",
  "FDUS": "Fidus Investment Corp.",
  "FDX": "FedEx Corporation",
  "FDXF": "FedEx Freight Holding Company, Inc.",
  "FE": "FirstEnergy Corp.",
  "FEAM": "5E Advanced Materials, Inc. Common Stock",
  "FEBO": "Fenbo Holdings Limited Class A",
  "FEDU": "Four Seasons Education (Cayman) Inc. American depositary shares, each representing ten (10)",
  "FEED": "ENvue Medical, Inc. Common Stock",
  "FEIM": "Frequency Electronics, Inc.",
  "FELE": "Franklin Electric Co Inc",
  "FEMY": "Femasys Inc. Common Stock",
  "FENC": "Fennec Pharmaceuticals Inc. Common Stock",
  "FENG": "Phoenix New Media Limited ADR",
  "FER": "Ferrovial N.V.",
  "FERA": "Fifth Era Acquisition Corp I Class A",
  "FERG": "Ferguson Enterprises Inc.",
  "FET": "Forum Energy Technologies, Inc.",
  "FF": "Future Fuel Corporation",
  "FFA": "First Trust Enhanced Equity Income Fund.",
  "FFAI": "Faraday Future Intelligent Electric Inc. Common Stock",
  "FFBC": "First Financial Bancorp",
  "FFC": "Flaherty & Crumrine Preferred and Income Securities Fund Incorporated",
  "FFIN": "First Financial Bankshares Inc",
  "FFIV": "F5, Inc. Common Stock",
  "FG": "F&G Annuities & Life, Inc.",
  "FGBI": "FIRST GUARANTY BANCSHARES INC",
  "FGBIP": "First Guaranty Bancshares, Inc Series A Preferred Stock",
  "FGI": "FGI Industries Ltd.",
  "FGII": "FG Imperii Acquisition Corp. Class A",
  "FGL": "Founder Group Limited Class A",
  "FGNX": "FG Nexus Inc. Common Stock",
  "FGNXP": "FG Nexus Inc Preferred Stock",
  "FHB": "First Hawaiian, Inc. Common Stock",
  "FHI": "Federated Hermes, Inc.",
  "FHN": "First Horizon Corporation",
  "FHN-P-E": "First Horizon Corporation Series E Preferred Stock",
  "FHN-P-F": "First Horizon Corporation Series F Preferred Stock",
  "FHN-P-H": "First Horizon Corporation Series H Preferred Stock",
  "FHTX": "Foghorn Therapeutics Inc. Common Stock",
  "FIBK": "First Interstate BancSystem, Inc. Common Stock (DE)",
  "FICO": "Fair Isaac Corporation",
  "FIEE": "FiEE, Inc Common Stock",
  "FIG": "Figma, Inc.",
  "FIGR": "Figure Technology Solutions, Inc. Class A Common Stock",
  "FIGS": "FIGS, Inc.",
  "FIGX": "FIGX Capital Acquisition Corp. Class A Ordinary Share",
  "FINS": "Angel Oak Financial Strategies Income Term Trust",
  "FINV": "FinVolution Group American depositary shares, each representing five Class A ordinary shares",
  "FINW": "FinWise Bancorp Common",
  "FIP": "FTAI Infrastructure Inc. Common Stock",
  "FIRY": "Firy Inc.",
  "FIS": "Fidelity National Information Services, Inc.",
  "FISI": "Financial Institutions Inc",
  "FISK": "Empire State Realty OP, L.P. Series 250",
  "FISN": "Deep Fission, Inc. Common Stock",
  "FISV": "Fiserv, Inc. Common Stock",
  "FITB": "Fifth Third Bancorp",
  "FITB-P-A": "Fifth Third Bancorp Depositary Shares Representing a 1/40th Ownership Interest in a Share of Class B Preferred Stock",
  "FITB-P-I": "Fifth Third Bancorp Depositary Shares Representing a 1/1000th Ownership Interest in a Share of Series I Preferred Stock",
  "FITB-P-K": "Fifth Third Bancorp Depositary Shares Representing a 1/1000th Ownership Interest in a Share of Series K Preferred Stock",
  "FITB-P-M": "Fifth Third Bancorp Depositary Shares Representing a 1/40th Ownership Interest in a Share of Series M Preferred Stock",
  "FIVE": "Five Below, Inc. Common Stock",
  "FIVN": "FIVE9, INC.",
  "FIX": "Comfort Systems USA, Inc.",
  "FIZZ": "National Beverage Corp.",
  "FJET": "Starfighters Space, Inc.",
  "FKWL": "Franklin Wireless Corp. Common Stock",
  "FLC": "Flaherty & Crumrine Total Return Fund Incorporated",
  "FLD": "Fold Holdings, Inc. Class A Common Stock",
  "FLEX": "Flex Ltd.",
  "FLG": "Flagstar Bank, National Association",
  "FLG-P-A": "Flagstar Bank, National Association Series A Preferred Stock",
  "FLGT": "Fulgent Genetics, Inc. Common Stock",
  "FLL": "Full House Resorts, Inc.",
  "FLNA": "Filana Therapeutics, Inc. Common Stock",
  "FLNC": "Fluence Energy, Inc. Class A Common Stock",
  "FLNG": "FLEX LNG Ltd.",
  "FLNT": "Fluent, Inc. Common Stock",
  "FLO": "Flowers Foods, Inc.",
  "FLOC": "Flowco Holdings Inc.",
  "FLR": "Fluor Corporation",
  "FLS": "Flowserve Corporation",
  "FLUT": "Flutter Entertainment plc",
  "FLUX": "Flux Power Holdings, Inc. Common Stock",
  "FLWS": "1-800-FLOWERS.COM Inc",
  "FLX": "BingEx Limited ADR",
  "FLXS": "Flexsteel Industries",
  "FLY": "Firefly Aerospace Inc. Common Stock",
  "FLYE": "Fly-E Group, Inc. Common Stock",
  "FLYW": "Flywire Corporation Voting Common Stock",
  "FLYX": "flyExclusive, Inc.",
  "FLZH": "Flash Sports & Media Holdings, Inc. Common Stock",
  "FMAC": "Future Money Acquisition Corporation",
  "FMAO": "Farmers & Merchants Bancorp, Inc.",
  "FMBH": "First Mid Bancshares, Inc. Common Stock",
  "FMC": "FMC Corporation",
  "FMFC": "Kandal M Venture Limited Class A",
  "FMN": "Federated Hermes Premier Municipal Income Fund",
  "FMNB": "Farmers National Banc Corp",
  "FMS": "Fresenius Medical Care AG",
  "FMST": "Foremost Clean Energy Ltd. Common stock",
  "FMX": "FOMENTO ECONOMICO MEXICANO, S.A.B. DE C.V.",
  "FMY": "FIRST TRUST MORTGAGE INCOME FUND",
  "FN": "Fabrinet",
  "FNB": "F.N.B. Corp",
  "FND": "Floor & Decor Holdings, Inc.",
  "FNF": "Fidelity National Financial, Inc.",
  "FNGR": "FingerMotion, Inc. Common Stock",
  "FNKO": "Funko, Inc. Class A Common Stock",
  "FNLC": "First Bancorp, Inc. (ME)",
  "FNRN": "First Northern Community Bancorp Common stock",
  "FNUC": "Frontier Nuclear and Minerals Inc. Common Shares",
  "FNV": "Franco-Nevada Corporation",
  "FNWB": "First Northwest Bancorp Common Stock",
  "FNWD": "Finward Bancorp Common Stock",
  "FOA": "Finance of America Companies Inc.",
  "FOCL": "EDAP TMS S.A. ADR",
  "FOF": "Cohen & Steers Closed End Opportunity Fund",
  "FOFO": "Hang Feng Technology Innovation Co., Ltd.",
  "FOR": "Forestar Group Inc.",
  "FORM": "FormFactor Inc.",
  "FORR": "Forrester Research Inc",
  "FORTY": "Formula Systems 1985 Ltd",
  "FOSL": "Fossil Group, Inc.",
  "FOUR": "Shift4 Payments, Inc.",
  "FOUR-P-A": "Shift4 Payments, Inc Series A Preferred Stock",
  "FOX": "Fox Corporation Class B Common Stock",
  "FOXA": "Fox Corporation Class A Common Stock",
  "FOXF": "Fox Factory Holding Corp. Common Stock",
  "FOXX": "Foxx Development Holdings Inc. Common Stock",
  "FPF": "FIRST TRUST INTERMEDIATE DURATION PREFERRED & INCOME FUND",
  "FPH": "Five Point Holdings, LLC Class A Common Shares",
  "FPI": "Farmland Partners Inc.",
  "FPS": "Forgent Power Solutions, Inc.",
  "FR": "First Industrial Realty Trust, Inc.",
  "FRA": "Blackrock Floating Rate Income Strategies Fund, Inc.",
  "FRAF": "Franklin Financial Services Corporation Common Stock",
  "FRBA": "First Bank",
  "FRBT": "Forbright, Inc. Class A Common Stock",
  "FRD": "Friedman Industries Inc. Common Stock",
  "FRGT": "Freight Technologies, Inc.",
  "FRHC": "Freedom Holding Corp.",
  "FRME": "First Merchants Corp",
  "FRMEP": "First Merchants Corporation Depository Shares",
  "FRMI": "Fermi Inc. Common Stock",
  "FRMM": "Forum Markets, Incorporated Common Stock",
  "FRNM": "Freenome, Inc. Common stock",
  "FRO": "Frontline Plc",
  "FROG": "JFrog Ltd.",
  "FRPH": "FRP Holdings, Inc.",
  "FRPT": "Freshpet, Inc.",
  "FRSH": "Freshworks Inc. Class A Common Stock",
  "FRST": "Primis Financial Corp. Common Stock",
  "FRSX": "Foresight Autonomous Holdings Ltd. ADR",
  "FRT": "Federal Realty Investment Trust",
  "FRT-P-C": "Federal Realty Investment Trust Series C Preferred Stock",
  "FRTT": "Fort Technology Inc. Common Shares",
  "FRVO": "Fervo Energy Company Class A common stock",
  "FSBC": "Five Star Bancorp Common Stock",
  "FSBW": "FS Bancorp, Inc. Common Stock",
  "FSCO": "FS Credit Opportunities Corp.",
  "FSEA": "First Seacoast Bancorp, Inc. Common Stock",
  "FSHP": "Flag Ship Acquisition Corp.",
  "FSI": "Flexible Solutions International, Inc.",
  "FSK": "FS KKR Capital Corp. Common Stock",
  "FSLR": "First Solar, Inc.",
  "FSLY": "Fastly, Inc. Class A Common Stock",
  "FSM": "Fortuna Mining Corp.",
  "FSP": "Franklin Street Properties Corp",
  "FSS": "Federal Signal Corp.",
  "FSSL": "FS Specialty Lending Fund",
  "FSTR": "Foster (Lb) Co",
  "FSUN": "FirstSun Capital Bancorp Common Stock",
  "FSV": "FirstService Corporation Common Shares",
  "FT": "Franklin Universal Trust Shares of Beneficial Interest",
  "FTAI": "FTAI Aviation Ltd. Common Stock",
  "FTAIM": "FTAI Aviation Ltd Series D Preferred Shares",
  "FTCI": "FTC Solar, Inc. Common Stock",
  "FTDR": "Frontdoor, Inc. Common Stock",
  "FTEK": "Fuel Tech, Inc.",
  "FTF": "Franklin Limited Duration Income Trust Common Shrs. of Beneficial Interest",
  "FTFT": "Future FinTech Group Inc.",
  "FTH": "Faeth Therapeutics, Inc. Common Stock",
  "FTHA": "Forefront Tech Holdings Acquisition Corp Class A",
  "FTHM": "Fathom Holdings Inc. Common Stock",
  "FTHY": "First Trust High Yield Opportunities 2027 Term Fund",
  "FTI": "TechnipFMC plc Ordinary Share",
  "FTK": "Flotek Industries, Inc.",
  "FTLF": "FitLife Brands, Inc. Common Stock",
  "FTNT": "Fortinet, Inc.",
  "FTRA": "FutureCorp Space Acquisition 1",
  "FTRE": "Fortrea Holdings Inc. Common Stock",
  "FTRK": "FAST TRACK GROUP",
  "FTS": "Fortis Inc. Common Shares",
  "FTV": "Fortive Corporation",
  "FTW": "Presidio Production Company",
  "FUBO": "FuboTV Inc.",
  "FUFU": "BitFuFu Inc. Class A",
  "FUL": "H.B. Fuller Company",
  "FULC": "Fulcrum Therapeutics, Inc. Common Stock",
  "FULT": "Fulton Financial Corp",
  "FULTP": "Fulton Financial Corporation Series A Preferred Stock",
  "FUN": "Six Flags Entertainment Corporation",
  "FUNC": "First United Corp",
  "FUND": "Sprott Focus Trust, Inc.",
  "FURY": "Fury Gold Mines Limited",
  "FUSB": "First US Bancshares, Inc. Common Stock",
  "FUSE": "Fusemachines Inc. Common stock",
  "FUTU": "Futu Holdings Limited ADR",
  "FVAV": "Fortress Value Acquisition Corp. V Class A",
  "FVCB": "FVCBankcorp, Inc. Common Stock",
  "FVN": "Future Vision II Acquisition Corporation",
  "FVR": "FrontView REIT, Inc.",
  "FVRR": "Fiverr International Ltd.",
  "FWAC": "Futurewave Acquisition Corporation",
  "FWDI": "Forward Industries, Inc. Common Stock",
  "FWONA": "Liberty Media Corporation Series A Liberty Formula One Common Stock",
  "FWONK": "Liberty Media Corporation Series C Liberty Formula One Common Stock",
  "FWRD": "Forward Air Corp",
  "FWRG": "First Watch Restaurant Group, Inc. Common Stock",
  "FXAC": "FortuneX Acquisition Corporation",
  "FXHO": "UTime Limited Class A",
  "FXNC": "FIRST NATL CORP STRASBURG VA",
  "G": "GENPACT LIMITED",
  "GAB": "The Gabelli Equity Trust Inc.",
  "GAB-P-G": "The Gabelli Equity Trust Inc. Series G Cumulative Preferred",
  "GAB-P-H": "THE GABELLI EQUITY TRUST INC Series H Preferred Stock",
  "GAB-P-K": "The Gabelli Equity Trust Inc Series K Preferred Stock",
  "GABC": "German American Bancorp, Inc.",
  "GAIA": "Gaia, Inc. Class A Common Stock",
  "GAIN": "Gladstone Investment Corporation",
  "GALT": "Galectin Therapeutics Inc.",
  "GAM": "General American Investors Company, Inc.",
  "GAM-P-B": "General American Investors Company, Inc  5.95% Cumul Pfd Stock, Ser B",
  "GAME": "GameSquare Holdings, Inc. Common Stock",
  "GANX": "Gain Therapeutics, Inc. Common Stock",
  "GAP": "The Gap, Inc.",
  "GASS": "StealthGas, Inc.",
  "GATX": "GATX Corporation",
  "GAU": "Galiano Gold Inc.",
  "GAUZ": "Gauzy Ltd.",
  "GBAB": "Guggenheim Taxable Municipal Bond & Investment Grade Debt Trust",
  "GBCI": "Glacier Bancorp Inc",
  "GBDC": "Golub Capital BDC, Inc.",
  "GBFH": "GBank Financial Holdings Inc. Common Stock",
  "GBLI": "Global Indemnity Group, LLC Class A Common Stock",
  "GBR": "New Concept Energy Inc",
  "GBTG": "Global Business Travel Group, Inc.",
  "GBX": "The Greenbrier Companies, Inc.",
  "GCBC": "Greene County Bancorp Inc",
  "GCDT": "Green Circle Decarbonize Technology Limited",
  "GCGR": "General Catalyst Global Resilience Merger Corp. Class A",
  "GCL": "GCL Global Holdings Ltd",
  "GCMG": "GCM Grosvenor Inc. Class A Common Stock",
  "GCO": "Genesco Inc.",
  "GCT": "GigaCloud Technology Inc Class A",
  "GCTK": "GlucoTrack, Inc. Common Stock",
  "GCTS": "GCT Semiconductor Holding, Inc.",
  "GCV": "The Gabelli Convertible and Income Securities Fund, Inc.",
  "GD": "General Dynamics Corporation",
  "GDC": "GD Culture Group Limited Common Stock",
  "GDDY": "GoDaddy Inc",
  "GDEV": "GDEV Inc.",
  "GDHG": "Golden Heaven Group Holdings Ltd. Class A",
  "GDL": "The GDL Fund",
  "GDO": "Western Asset Global Corporate Opportunity Fund Inc.",
  "GDOT": "Green Dot Corporation",
  "GDRX": "GoodRx Holdings, Inc. Class A Common Stock",
  "GDS": "GDS Holdings Limited ADS",
  "GDTC": "CytoMed Therapeutics Limited",
  "GDV": "The Gabelli Dividend & Income Trust",
  "GDV-P-H": "The Gabelli Dividend & Income Trust Series H Preferred Shares",
  "GDV-P-K": "The Gabelli Dividend & Income Trust Series K Preferred Shares",
  "GDYN": "Grid Dynamics Holdings, Inc. Class A Common Stock",
  "GE": "GE Aerospace",
  "GECC": "Great Elm Capital. Corp. Common Stock",
  "GEF": "Greif, Inc.",
  "GEF-B": "Greif, Inc. Class B",
  "GEG": "Great Elm Group, Inc. Common Stock",
  "GEHC": "GE HealthCare Technologies Inc. Common Stock",
  "GEL": "Genesis Energy, L.P.",
  "GELS": "Gelteq Limited",
  "GEMI": "Gemini Space Station, Inc. Class A Common Stock",
  "GEN": "Gen Digital Inc. Common Stock",
  "GENB": "Generate Biomedicines, Inc. Common Stock",
  "GENC": "Gencor Industries, Inc.",
  "GENI": "Genius Sports Limited",
  "GENK": "GEN Restaurant Group, Inc. Class A Common Stock",
  "GEO": "The GEO Group, Inc.",
  "GEOS": "Geospace Technologies Corporation Common Stock",
  "GERN": "Geron Corp",
  "GETY": "Getty Images Holdings, Inc.",
  "GEV": "GE Vernova Inc.",
  "GEVO": "Gevo, Inc.",
  "GF": "NEW GERMANY FUND Inc",
  "GFAI": "Guardforce AI Co., Limited",
  "GFF": "Griffon Corp",
  "GFI": "Gold Fields Ltd ADR",
  "GFL": "GFL Environmental Inc. Subordinate Voting Shares",
  "GFR": "Greenfire Resources Ltd.",
  "GFS": "GlobalFoundries Inc.",
  "GFUZ": "General Fusion Group Ltd. Common Shares",
  "GGAL": "Grupo Financiero Galicia SA",
  "GGB": "Gerdau S.A.",
  "GGG": "Graco Inc",
  "GGN": "GAMCO Global Gold, Natural Resources & Income Trust",
  "GGN-P-B": "GAMCO Global Gold Natural Resources & Income Trust 5.00% Series B",
  "GGR": "Gogoro Inc.",
  "GGRP": "The Glimpse Group, Inc. Common Stock",
  "GGT": "THE GABELLI MULTIMEDIA TRUST INC.",
  "GGT-P-E": "The Gabelli Multimedia Trust Inc Series E Preferred Stock",
  "GGT-P-G": "The Gabelli Multimedia Trust Inc Series G Preferred Shares",
  "GGZ": "The Gabelli Global Small and Mid Cap Value Trust",
  "GH": "Guardant Health, Inc. Common Stock",
  "GHC": "GRAHAM HOLDINGS COMPANY",
  "GHG": "GreenTree Hospitality Group Ltd. American depositary shares, each representing one Class A ordinary share",
  "GHI": "Greystone Housing Impact Investors LP Beneficial Unit Certificates representing assignments of limited partnership interests",
  "GHM": "Graham Corporation",
  "GHRS": "GH Research PLC",
  "GHY": "PGIM Global High Yield Fund, Inc.",
  "GIB": "CGI Inc.",
  "GIBO": "GIBO Holdings Limited Class A",
  "GIC": "Global Industrial Company",
  "GIFT": "Giftify, Inc. Common Stock",
  "GIGM": "GigaMedia Ltd",
  "GIII": "G-Iii Apparel Group Ltd",
  "GIL": "Gildan Activewear Inc.",
  "GILD": "Gilead Sciences Inc",
  "GILT": "Gilat Satellite Networks Ltd",
  "GIPR": "Generation Income Properties Inc. Common Stock",
  "GIS": "General Mills, Inc.",
  "GITS": "Global Interactive Technologies, Inc. Common Stock",
  "GIW": "GigCapital8 Corp. Class A",
  "GIX": "GigCapital9 Corp. Class A Ordinary Share",
  "GJH": "Synthetic Fixed-Income Sec STRATS 2004-06, 6.375% US Cellular Corp.",
  "GJO": "Synthetic Fixed-Income Securities, Inc. 4.65% Floating Rate STRATS Certificates, Series 2005-4",
  "GJP": "Synthetic Fixed Income Securities on the behalf of STRATS for Dominion Resources  Series 2005-6",
  "GJR": "Synthetic Fixed Income Securities, Inc. Floating Rate Structured Repackaged Asset-Backed Trust Securities (STRATS)",
  "GJS": "Synthetic Fixed-Income Securities STRATS 2006-2 Goldman Sachs Group",
  "GJT": "Synthetic Fixed-Income Securities STRATS 2006-3 AllState Corporation",
  "GKOS": "Glaukos Corporation",
  "GL": "Globe Life Inc.",
  "GLAD": "Gladstone Capital Corp",
  "GLAS": "Glass House Brands Inc.",
  "GLBE": "Global-E Online Ltd.",
  "GLBS": "Globus Maritime Limited",
  "GLDG": "GoldMining Inc.",
  "GLE": "Global Engine Group Holding Limited Class A",
  "GLED": "GalaxyEdge Acquisition Corporation",
  "GLIBA": "Liberty Capital Corporation Series A GCI Group Common Stock",
  "GLIBK": "Liberty Capital Corporation Series C GCI Group Common Stock",
  "GLMD": "Galmed Pharmaceuticals Ltd.",
  "GLND": "Greenland Energy Company Common Stock",
  "GLNG": "Golar LNG Ltd",
  "GLO": "Clough Global Opportunities Fund",
  "GLOB": "GLOBANT S.A.",
  "GLOO": "Gloo Holdings, Inc. Class A Common Stock",
  "GLOP-P-A": "GasLog Partners LP Series A Preferred Stock",
  "GLOP-P-B": "GasLog Partners LP Series B Preferred Stock",
  "GLOP-P-C": "GasLog Partners LP Series C Preferred Stock",
  "GLP": "Global Partners LP",
  "GLPI": "Gaming and Leisure Properties, Inc.",
  "GLQ": "Clough Global Equity Fund",
  "GLRE": "Greenlight Captial RE, LTD. Class A",
  "GLSI": "Greenwich LifeSciences, Inc.",
  "GLU": "The Gabelli Utility & Income Trust",
  "GLU-P-A": "The Gabelli Global Utility & Income Trust Series A",
  "GLU-P-B": "The Gabelli Global Utility & Income Trust Series B Series B Preferred Shares",
  "GLUE": "Monte Rosa Therapeutics, Inc. Common Stock",
  "GLV": "Clough Global Dividend and Income Fund",
  "GLW": "Corning Incorporated",
  "GLXG": "Galaxy Payroll Group Limited Class A",
  "GLXY": "Galaxy Digital Inc. Class A Common Stock",
  "GM": "General Motors Company",
  "GMAB": "Genmab A/S ADS",
  "GME": "GameStop Corp. Class A",
  "GMED": "GLOBUS MEDICAL INC",
  "GMEX": "GMEX ROBOTICS CORPORATION Class A",
  "GMHS": "Gamehaus Holdings Inc. Class A",
  "GMM": "Global Mofy AI Limited Class A",
  "GMRS": "GMR Solutions Inc.",
  "GMTL": "Guardian Metal Resources PLC ADR",
  "GNE": "GENIE ENERGY LTD",
  "GNK": "GENCO SHIPPING & TRADING LTD",
  "GNL": "Global Net Lease, Inc.",
  "GNL-P-A": "Global Net Lease, Inc Series A Preferred Stock",
  "GNL-P-B": "Global Net Lease, Inc Series B Preferred Stock",
  "GNL-P-D": "Global Net Lease, Inc Series D Preferred Stock",
  "GNL-P-E": "Global Net Lease, Inc Series E Preferred Stock",
  "GNLN": "Greenlane Holdings, Inc. Class A Common Stock",
  "GNLX": "Genelux Corporation Common Stock",
  "GNPX": "Genprex, Inc. Common Stock",
  "GNRC": "GENERAC HOLDINGS INC",
  "GNS": "Genius Group Limited",
  "GNSS": "Genasys Inc. Common Stock",
  "GNT": "GAMCO Natural Resources, Gold & Income Trust",
  "GNT-P-A": "GAMCO Natural Resources, Gold & Income Trust Series A Preferred Shares",
  "GNTA": "Genenta Science S.p.A. ADR",
  "GNTX": "Gentex Corp",
  "GNW": "Genworth Financial, Inc.",
  "GO": "Grocery Outlet Holding Corp. Common Stock",
  "GOAI": "Eva Live Inc. Common Stock",
  "GOF": "Guggenheim Strategic Opportunities Fund",
  "GOGO": "Gogo Inc.",
  "GOLD": "Gold.com, Inc.",
  "GOLF": "Acushnet Holdings Corp.",
  "GOOD": "Gladstone Commercial Corporation - REIT",
  "GOODN": "Gladstone Commercial Corporation Series E Preferred Stock",
  "GOODO": "Gladstone Commercial Corporation Series G Preferred Stock",
  "GOOG": "Alphabet Inc. Class C Capital Stock",
  "GOOGL": "Alphabet Inc. Class A Common Stock",
  "GOOGM": "Alphabet Inc. Depositary Shares representing a 1/20th Interest in a Share of Series A Mandatory Convertible Preferred Stock",
  "GOOGN": "Alphabet Inc. Depositary Shares representing a 1/20th Interest in a Share of Series B Mandatory Convertible Preferred Stock",
  "GOOS": "Canada Goose Holdings Inc.",
  "GORO": "Goldgroup Mining Inc.",
  "GOSS": "Gossamer Bio, Inc. Common Stock",
  "GOTU": "Gaotu Techedu Inc. ADR",
  "GOVX": "GeoVax Labs, Inc. New",
  "GP": "GreenPower Motor Company Inc. Common Shares",
  "GPAC": "General Purpose Acquisition Corp. Class A",
  "GPAT": "GP-Act III Acquisition Corp. Class A Ordinary Share",
  "GPC": "Genuine Parts Company",
  "GPCR": "Structure Therapeutics Inc. ADR",
  "GPGI": "GPGI, Inc.",
  "GPI": "Group 1 Automotive, Inc.",
  "GPK": "Graphic Packaging Holding Company",
  "GPMT": "Granite Point Mortgage Trust Inc. Common Stock",
  "GPMT-P-A": "Granite Point Mortgage Trust Inc Series A Preferred Stock",
  "GPN": "Global Payments, Inc.",
  "GPOR": "Gulfport Energy Corporation",
  "GPRE": "Green Plains, Inc.",
  "GPRK": "GEOPARK LIMITED",
  "GPRO": "GoPro, Inc.",
  "GPUS": "Hyperscale Data, Inc.",
  "GPUS-P-D": "Hyperscale Data, Inc Series D Preferred Stock",
  "GRAB": "Grab Holdings Limited Class A",
  "GRAL": "GRAIL, Inc. Common Stock",
  "GRAN": "Grande Group Limited Class A",
  "GRBK": "Green Brick Partners, Inc",
  "GRBK-P-A": "Green Brick Partners, Inc Series A Preferred Stock",
  "GRC": "The Gorman-Rupp Company Common Shares",
  "GRCE": "Grace Therapeutics, Inc. Common Stock",
  "GRDN": "Guardian Pharmacy Services, Inc.",
  "GRDX": "GridAI Technologies Corp. Common Stock",
  "GRF": "Eagle Capital Growth Fund, Inc.",
  "GRFS": "Grifois, S.A.",
  "GRI": "GRI Bio, Inc. Common Stock",
  "GRML": "Greenland Mines Ltd. Common Stock",
  "GRMN": "Garmin Ltd",
  "GRND": "Grindr Inc.",
  "GRNQ": "Greenpro Capital Corp. Common Stock",
  "GRNT": "Granite Ridge Resources, Inc.",
  "GRO": "Brazil Potash Corp.",
  "GROV": "Grove Collaborative Holdings, Inc.",
  "GROW": "US Global Investors Inc",
  "GROY": "Gold Royalty Corp.",
  "GRPN": "Groupon, Inc.Common Stock",
  "GRRR": "Gorilla Technology Group Inc.",
  "GRSD": "Grandstand Limited",
  "GRVY": "GRAVITY Co., Ltd.",
  "GRWG": "GROW GENERATION CORP",
  "GRX": "The Gabelli Healthcare & Wellness Trust",
  "GS": "Goldman Sachs Group Inc.",
  "GS-P-A": "Goldman Sachs Group, Inc. (The) Depositary shares",
  "GS-P-C": "Goldman Sachs Group Dep. Shares (1/1000 Int. of Floating Rate Non-Cum. Prfrd. Stk., Ser. C)",
  "GS-P-D": "Goldman Sachs Group, Inc. (Each representing 1/1000th Interest in a Share of Series D Preferred Stock",
  "GSAT": "Globalstar, Inc. Common Stock",
  "GSBC": "Great Southern Bancorp Inc",
  "GSBD": "Goldman Sachs BDC, Inc.",
  "GSHD": "Goosehead Insurance, Inc. Class A Common Stock",
  "GSHR": "Gesher Acquisition Corp. II Class A",
  "GSIT": "GSI Technology",
  "GSIW": "Garden Stage Limited Class A",
  "GSK": "GSK plc ADR",
  "GSL": "Global Ship Lease, Inc.",
  "GSL-P-B": "GLOBAL SHIP LEASE, INC. 8.75%  SER B",
  "GSM": "Ferroglobe PLC",
  "GSRF": "GSR IV Acquisition Corp. Class A ordinary share",
  "GSRV": "GSR V Acquisition Corp. Class A ordinary shares",
  "GSUN": "Golden Sun Technology Group Limited Class A",
  "GT": "Goodyear Tire & Rubber",
  "GTBP": "GT Biopharma Inc. Common Stock",
  "GTE": "Gran Tierra Energy Inc.",
  "GTEC": "Greenland Technologies Holding Corporation Class A",
  "GTEN": "Gores Holdings X, Inc. Class A ordinary shares",
  "GTERA": "Globa Terra Acquisition Corporation Class A",
  "GTES": "Gates Industrial Corporation Ltd.",
  "GTIM": "Good Times Restaurants Inc.",
  "GTLB": "GitLab Inc. Class A Common Stock",
  "GTM": "ZoomInfo Technologies Inc Common Stock",
  "GTN": "Gray Media, Inc.",
  "GTN-A": "Gray Media, Inc. Class A",
  "GTX": "Garrett Motion Inc. Common Stock",
  "GTY": "Getty Realty Corp.",
  "GUAC": "Berto Acquisition Corp. II",
  "GUG": "Guggenheim Active Allocation Fund",
  "GURE": "Gulf Resources, Inc. (NV) Common Stock",
  "GUT": "GABELLI UTILITY TRUST",
  "GUT-P-C": "Gabelli Utility Trust Series C Preferred Shares",
  "GUTS": "Fractyl Health, Inc. Common Stock",
  "GVA": "Granite Construction Inc.",
  "GVH": "Globavend Holdings Limited",
  "GWAV": "Greenwave Technology Solutions, Inc. Common Stock",
  "GWH": "ESS Tech, Inc.",
  "GWRE": "GUIDEWIRE SOFTWARE, INC.",
  "GWRS": "Global Water Resources, Inc.",
  "GWW": "W.W. Grainger, Inc.",
  "GXAI": "Gaxos.ai Inc. Common Stock",
  "GXO": "GXO Logistics, Inc.",
  "GYGY": "Game Your Game, Inc. Common Stock",
  "GYRE": "Gyre Therapeutics, Inc. Common Stock",
  "GYRO": "Gyrodyne, LLC Common Stock",
  "H": "Hyatt Hotels Corporation",
  "HACQ": "HCM IV Acquisition Corp. Class A Ordinary Share",
  "HAE": "Haemonetics Corporation",
  "HAFC": "Hanmi Financial Corp",
  "HAFN": "Hafnia Limited",
  "HAIN": "Hain Celestial Group Inc",
  "HAL": "Halliburton Company",
  "HALO": "Halozyme Therapeutics, Inc.",
  "HAO": "Haoxi Health Technology Limited Class A",
  "HAPN": "Happen, Inc. Common Stock",
  "HAS": "Hasbro, Inc.",
  "HASI": "HA Sustainable Infrastructure Capital, Inc.",
  "HAVA": "Harvard Ave Acquisition Corporation Class A Ordinary Share",
  "HAWK": "HawkEye 360, Inc.",
  "HAYW": "Hayward Holdings, Inc.",
  "HBAN": "Huntington Bancshares Inc",
  "HBANL": "Huntington Bancshares Incorporated Series J Preferred Stock",
  "HBANM": "Huntington Bancshares Incorporated Series I Preferred Stock",
  "HBANP": "Huntington Bancshares Incorporated Depositary Shares Series H Preferred Stock",
  "HBANZ": "Huntington Bancshares Incorporated Series L Preferred Stock",
  "HBB": "Hamilton Beach Brands Holding Company Class A Common Stock",
  "HBCP": "Home Bancorp, Inc.",
  "HBIO": "Harvard Bioscience Inc",
  "HBM": "Hudbay Minerals Inc.",
  "HBNB": "Hotel101 Global Holdings Corp. Class A",
  "HBNC": "Horizon Bancorp, Inc. Common Stock",
  "HBT": "HBT Financial, Inc. Common Stock",
  "HCA": "HCA Healthcare, Inc.",
  "HCAC": "Hall Chadwick Acquisition Corp Class A",
  "HCAI": "Huachen AI Parking Management Technology Holding Co., Ltd.",
  "HCAT": "Health Catalyst, Inc Common Stock",
  "HCC": "Warrior Met Coal, Inc.",
  "HCHL": "Happy City Holdings Limited Class A",
  "HCI": "HCI Group, Inc.",
  "HCIC": "Hennessy Capital Investment Corp. VIII Class A",
  "HCKT": "Hackett Group Inc (The).",
  "HCM": "HUTCHMED (China) Limited ADR",
  "HCMA": "HCM III Acquisition Corp. Class A Ordinary Share",
  "HCSG": "Healthcare Services Group",
  "HCTI": "Healthcare Triangle, Inc. Common Stock",
  "HCWB": "HCW Biologics Inc. Common Stock",
  "HCWC": "Healthy Choice Wellness Corp.",
  "HD": "Home Depot, Inc.",
  "HDB": "HDFC Bank Limited",
  "HDL": "SUPER HI INTERNATIONAL HOLDING LTD. ADR",
  "HDRN": "Hadron Energy, Inc. Common Stock",
  "HDSN": "Hudson Technologies Inc",
  "HE": "Hawaiian Electric Industries, Inc.",
  "HEI": "HEICO Corporation",
  "HEI-A": "HEICO CORP CL A",
  "HELE": "Helen Of Troy Ltd",
  "HELP": "Cybin Inc. Common Stock",
  "HEPS": "D-Market Electronic Services & Trading ADR",
  "HEQ": "John Hancock Diversified Income Fund",
  "HERE": "Here Group Limited ADR",
  "HERZ": "Herzfeld Credit Income Fund, Inc. Common Stock",
  "HESM": "Hess Midstream LP Class A Share representing a limited partner Interest",
  "HFBL": "Home Federal Bancorp, Inc. of Louisiana",
  "HFFG": "HF Foods Group Inc. Common Stock",
  "HFRO": "Highland Opportunities and Income Fund",
  "HFRO-P-A": "Highland Opportunities and Income Fund Series A Preferred Shares",
  "HFRO-P-B": "Highland Opportunities and Income Fund Series B Preferred Shares",
  "HFWA": "Heritage Financial Corp",
  "HG": "Hamilton Insurance Group, Ltd. Class B Common Shares",
  "HGBL": "HERITAGE GLOBAL INC",
  "HGLB": "Highland Global Allocation Fund",
  "HGTY": "Hagerty, Inc.",
  "HGV": "Hilton Grand Vacations Inc. Common Stock",
  "HHH": "Howard Hughes Holdings Inc.",
  "HHS": "Harte-Hanks, Inc. Common Stock",
  "HIFS": "Hingham Institution for Saving",
  "HIG": "The Hartford Insurance Group, Inc.",
  "HIG-P-G": "The Hartford Insurance Group, Inc Series G Preferred Stock",
  "HIHO": "Highway Holdings Ltd",
  "HII": "Huntington Ingalls Industries, Inc.",
  "HIMS": "Hims & Hers Health, Inc.",
  "HIMX": "Himax Technologies, Inc.",
  "HIND": "Vyome Holdings, Inc. Common Stock",
  "HIO": "Western Asset High Income Opportunity Fund, Inc.",
  "HIPO": "Hippo Holdings Inc.",
  "HIT": "Health In Tech, Inc. Class A Common Stock",
  "HITI": "High Tide Inc. Common Shares",
  "HIVE": "HIVE Digital Technologies Ltd. Common Shares",
  "HIW": "Highwoods Properties Inc.",
  "HIX": "Western Asset High Income Fund II, Inc.",
  "HKD": "AMTD Digital Inc. ADR",
  "HKIT": "Hitek Global Inc. Class A Ordinary Share",
  "HKPD": "Cellyan Biotechnology Co., Ltd Class A",
  "HL": "Hecla Mining Company",
  "HL-P-B": "Hecla Mining Company Series B Cumulative Convertible Preferred",
  "HLF": "Herbalife Ltd.",
  "HLI": "Houlihan Lokey, Inc.",
  "HLIO": "Helios Technologies, Inc.",
  "HLIT": "Harmonic Inc",
  "HLLY": "Holley Inc.",
  "HLMN": "Hillman Solutions Corp. Common Stock",
  "HLN": "Haleon plc ADR",
  "HLNE": "Hamilton Lane Incorporated Class A Common Stock",
  "HLP": "Hongli Group Inc. Class A",
  "HLT": "Hilton Worldwide Holdings Inc.",
  "HLX": "Helix Energy Solutions Group, Inc.",
  "HLXC": "Helix Acquisition Corp. III Class A",
  "HMC": "Honda Motor Co., Ltd. ADR",
  "HMH": "HMH Holding Inc. Class A Common Stock",
  "HMN": "Horace Mann Educators Corporation",
  "HMR": "Heidmar Maritime Holdings Corp. Common Stock",
  "HMY": "Harmony Gold Mining Company Limited",
  "HNGE": "Hinge Health, Inc.",
  "HNI": "HNI Corporation",
  "HNNA": "Hennessy Advisors, Inc.",
  "HNRG": "Hallador Energy Company",
  "HNST": "The Honest Company, Inc. Common Stock",
  "HNVR": "Hanover Bancorp, Inc. Common Stock",
  "HODO": "House of Doge Inc. Common Stock",
  "HOFT": "Hooker Furnishings Corporation Common Stock",
  "HOG": "Harley-Davidson, Inc.",
  "HOLO": "MicroCloud Hologram Inc.",
  "HOMB": "Home BancShares, Inc.",
  "HON": "Honeywell International, Inc.",
  "HONA": "Honeywell Aerospace Inc. Common Stock",
  "HOOD": "Robinhood Markets, Inc. Class A Common Stock",
  "HOPE": "Hope Bancorp, Inc.",
  "HOUR": "Hour Loop, Inc. Common Stock",
  "HOV": "Hovnanian Enterprises, Inc. Class A",
  "HOVNP": "Hovnanian Enterprises Inc. Dep Shr Srs A Pfd",
  "HOVR": "New Horizon Aircraft Ltd. Class A Ordinary Share",
  "HOWL": "Werewolf Therapeutics, Inc. Common Stock",
  "HP": "Helmerich & Payne, Inc.",
  "HPAI": "Helport AI Limited",
  "HPE": "Hewlett Packard Enterprise Company",
  "HPE-P-C": "Hewlett Packard Enterprise Company Series C Preferred Stock",
  "HPF": "John Hancock Preferred Income Fund II",
  "HPI": "John Hancock Preferred Income Fund",
  "HPK": "HighPeak Energy, Inc. Common Stock",
  "HPP": "Hudson Pacific Properties, Inc.",
  "HPP-P-C": "Hudson Pacific Properties, Inc Series C Preferred Stock",
  "HPQ": "HP Inc.",
  "HPS": "John Hancock Preferred Income Fund III",
  "HQ": "Horizon Quantum Holdings Ltd. Class A",
  "HQH": "abrdn Healthcare Investors",
  "HQI": "HireQuest, Inc. Common Stock (DE)",
  "HQL": "abrdn Life Sciences Investors",
  "HQY": "HealthEquity, Inc",
  "HR": "Healthcare Realty Trust Incorporated",
  "HRB": "H&R Block, Inc.",
  "HRI": "Herc Holdings Inc.",
  "HRL": "Hormel Foods Corporation",
  "HRMY": "Harmony Biosciences Holdings, Inc. Common Stock",
  "HROW": "Harrow, Inc. Common Stock",
  "HRTG": "HERITAGE INSURANCE HOLDINGS INC",
  "HRTX": "Heron Therapeutics, Inc.",
  "HRZN": "Horizon Technology Finance Corporation",
  "HSAI": "Hesai Group ADR",
  "HSBC": "HSBC Holdings PLC",
  "HSCS": "HeartSciences Inc. Common Stock",
  "HSDT": "Solana Company Class A Common Stock (DE)",
  "HSHP": "Himalaya Shipping Ltd.",
  "HSIC": "Henry Schein Inc",
  "HSLV": "Highlander Silver Corp.",
  "HST": "Host Hotels & Resorts, Inc.",
  "HSTM": "HealthStream Inc",
  "HSY": "The Hershey Company",
  "HTB": "HomeTrust Bancshares, Inc.",
  "HTCO": "High-Trend International Group Class A",
  "HTCR": "Heartcore Enterprises, Inc. Common Stock",
  "HTD": "John Hancock Tax-Advantaged Dividend Income Fund",
  "HTFL": "Heartflow, Inc. Common Stock",
  "HTGC": "Hercules Capital, Inc.",
  "HTH": "HILLTOP HOLDINGS INC.",
  "HTHT": "H World Group Limited ADR",
  "HTLD": "Heartland Express Inc",
  "HTLM": "HomesToLife Ltd",
  "HTO": "H2O America Common Stock",
  "HTOO": "Fusion Fuel Green PLC Class A",
  "HTT": "High Templar Tech Limited",
  "HTZ": "Hertz Global Holdings, Inc Common Stock",
  "HUBB": "Hubbell Incorporated",
  "HUBC": "Hub Cyber Security Ltd.",
  "HUBG": "HUB Group Inc",
  "HUBS": "HUBSPOT, INC.",
  "HUDI": "Huadi International Group Co., Ltd.",
  "HUHU": "HUHUTECH International Group Inc.",
  "HUIZ": "Huize Holding Limited ADR",
  "HUM": "Humana Inc.",
  "HUMA": "Humacyte, Inc. Common Stock",
  "HUN": "Huntsman Corporation",
  "HURA": "TuHURA Biosciences, Inc. Common Stock",
  "HURC": "Hurco Cos Inc",
  "HURN": "Huron Consulting Group Inc.",
  "HUT": "Hut 8 Corp. Common Stock",
  "HUYA": "HUYA Inc.",
  "HVII": "Hennessy Capital Investment Corp. VII",
  "HVMC": "Highview Merger Corp. Class A Ordinary Share",
  "HVT": "Haverty Furniture Companies, Inc.",
  "HVT-A": "Haverty Furniture Companies, Inc. Class A",
  "HWBK": "Hawthorn Bancshars Inc.",
  "HWC": "Hancock Whitney Corporation Common Stock",
  "HWH": "HWH International Inc. Common Stock",
  "HWKN": "Hawkins Inc",
  "HWM": "Howmet Aerospace Inc.",
  "HXHX": "Haoxin Holdings Limited Class A",
  "HXL": "Hexcel Corporation",
  "HY": "Hyster-Yale, Inc.",
  "HYFM": "Hydrofarm Holdings Group, Inc. Common Stock",
  "HYFT": "MindWalk Holdings Corp. Common Stock",
  "HYI": "Western Asset High Yield Opportunity Fund Inc.",
  "HYLN": "Hyliion Holdings Corp.",
  "HYMC": "Hycroft Mining Holding Corporation Class A Common Stock",
  "HYNE": "Hoyne Bancorp, Inc. Common Stock",
  "HYPD": "Hyperion DeFi, Inc. Common Stock",
  "HYPR": "Hyperfine, Inc. Class A Common Stock",
  "HYT": "BLACKROCK CORPORATE HIGH YIELD FUND INC.",
  "HZO": "MarineMax, Inc.",
  "IACO": "Idea Acquisition Corp. Class A",
  "IACQ": "Irenic Acquisition Corp. Class A",
  "IAE": "VOYA ASIA PACIFIC HIGH DIVIDEND EQUITY INCOME FUND",
  "IAF": "abrdn Australia Equity Fund, Inc.",
  "IAG": "IAMGold Corporation",
  "IART": "Integra LifeSciences Holdings",
  "IAUX": "i-80 Gold Corp.",
  "IBAC": "IB Acquisition Corp. Common Stock",
  "IBCP": "Independent Bank Corp.",
  "IBEX": "IBEX Limited Common Shares",
  "IBG": "Innovation Beverage Group Limited",
  "IBIO": "iBio, Inc. Common Stock",
  "IBKR": "Interactive Brokers Group, Inc. Class A Common Stock",
  "IBM": "International Business Machines Corporation",
  "IBN": "ICICI Bank Limited",
  "IBO": "Impact BioMedical, Inc.",
  "IBOC": "International Bancshares Corp",
  "IBP": "INSTALLED BUILDING PRODUCTS, INC.",
  "IBRX": "ImmunityBio, Inc. Common Stock",
  "IBTA": "Ibotta, Inc.",
  "ICCC": "Immucell Corp",
  "ICCM": "IceCure Medical Ltd.",
  "ICE": "Intercontinental Exchange  Inc.",
  "ICFI": "ICF International, Inc.",
  "ICG": "Intchains Group Limited ADR",
  "ICHR": "Ichor Holdings",
  "ICL": "ICL Group Ltd.",
  "ICLR": "Icon Plc",
  "ICMB": "Investcorp Credit Management BDC, Inc. Common Stock",
  "ICON": "Icon Energy Corp. Common stock",
  "ICR-P-A": "InPoint Commercial Real Estate Income, Inc Series A Preferred Stock",
  "ICU": "SeaStar Medical Holding Corporation Common Stock",
  "ICUI": "ICU Medical Inc",
  "IDA": "IDACORP, Inc.",
  "IDAC": "Iron Dome Acquisition I Corp. Class A",
  "IDAI": "T Stamp Inc. Class A Common Stock",
  "IDCC": "InterDigital, Inc.",
  "IDE": "VOYA INFRASTRUCTURE, INDUSTRIALS AND MATERIALS FUND",
  "IDN": "Intellicheck, Inc. Common Stock",
  "IDR": "Idaho Strategic Resources, Inc.",
  "IDT": "IDT Corporation Class B",
  "IDXX": "Idexx Laboratories Inc",
  "IDYA": "IDEAYA Biosciences, Inc. Common Stock",
  "IE": "Ivanhoe Electric Inc.",
  "IEAG": "Infinite Eagle Acquisition Corp. Class A",
  "IEP": "Icahn Enterprises L.P",
  "IESC": "IES Holdings, Inc. Common Stock",
  "IEX": "IDEX Corporation",
  "IFBD": "Infobird Co., Ltd",
  "IFF": "International Flavors & Fragrances Inc.",
  "IFN": "Aberdeen India Fund, Inc.",
  "IFRX": "InflaRx N.V. Common Stock",
  "IFS": "Intercorp Financial Services Inc.",
  "IGA": "VOYA GLOBAL ADVANTAGE AND PREMIUM OPPORTUNITY FUND",
  "IGAC": "Invest Green Acquisition Corporation Class A",
  "IGC": "IGC Pharma, Inc.",
  "IGD": "VOYA GLOBAL EQUITY DIVIDEND AND PREMIUM OPPORTUNITY FUND",
  "IGI": "Western Asset Investment Grade Defined Opportunity Trust Inc.",
  "IGIC": "International General Insurance Holdings Ltd. Ordinary Share",
  "IGR": "CBRE Global Real Estate Income Fund",
  "IH": "iHuman Inc. American depositary shares, each representing five Class A ordinary shares",
  "IHD": "VOYA EMERGING MARKETS HIGH INCOME DIVIDEND EQUITY FUND",
  "IHG": "InterContinental Hotels Group Plc",
  "IHRT": "iHeartMedia, Inc. Class A Common Stock",
  "IHS": "IHS Holding Limited",
  "IHT": "InnSuites Hospitality Trust",
  "IIF": "Morgan Stanley India Investment Fund, Inc.",
  "III": "Information Services Group, Inc.",
  "IIIN": "Insteel Industries, Inc.",
  "IIIV": "i3 Verticals, Inc. Class A Common Stock",
  "IIM": "INVESCO VALUE MUNICIPAL INCOME TRUST",
  "IIPR": "Innovative Industrial Properties, Inc. Common stock",
  "IIPR-P-A": "Innovative Industrial Properties, Inc Series A Preferred Stock",
  "IKT": "Inhibikase Therapeutics, Inc. Common Stock",
  "ILAG": "Intelligent Living Application Group Inc.",
  "ILLR": "Triller Group Inc. Common Stock",
  "ILLU": "Illumination Acquisition Corp I Class A",
  "ILMN": "Illumina Inc",
  "ILPT": "Industrial Logistics Properties Trust",
  "IMA": "ImageneBio, Inc. Common Stock",
  "IMAX": "Imax Corp",
  "IMC": "IMC Rare Earths Ltd",
  "IMCC": "IM Cannabis Corp. Common Shares",
  "IMCR": "Immunocore Holdings plc ADR",
  "IMDX": "Insight Molecular Diagnostics Inc. Common Stock",
  "IMKTA": "Ingles Markets Inc",
  "IMMP": "Immutep Limited ADR",
  "IMMR": "Immersion Corp",
  "IMMX": "Immix Biopharma, Inc. Common Stock",
  "IMNM": "Immunome, Inc.",
  "IMNN": "Imunon, Inc. Common Stock",
  "IMO": "Imperial Oil Limited",
  "IMOS": "ChipMOS TECHNOLOGIES INC",
  "IMPP": "Imperial Petroleum Inc. Common Shares",
  "IMPPP": "Imperial Petroleum Inc Series A Preferred Shares",
  "IMRN": "Immuron Limited ADR",
  "IMRX": "Immuneering Corporation Class A Common Stock",
  "IMSR": "Terrestrial Energy Inc. Common Stock",
  "IMTE": "Integrated Media Technology Limited",
  "IMTX": "Immatics N.V.",
  "IMUX": "Immunic, Inc. Common Stock",
  "IMVT": "Immunovant, Inc. Common Stock",
  "IMXI": "International Money Express, Inc.",
  "INAB": "IN8bio, Inc. Common Stock",
  "INAC": "Indigo Acquisition Corp.",
  "INBK": "First Internet Bancorp",
  "INBS": "Intelligent Bio Solutions Inc. Common Stock",
  "INBX": "Inhibrx Biosciences, Inc. Common Stock",
  "INCR": "Intercure Ltd.",
  "INCY": "Incyte Genomics Inc",
  "INDB": "Independent Bank Corp/MA",
  "INDI": "indie Semiconductor, Inc. Class A Common Stock",
  "INDO": "Indonesia Energy Corporation Limited",
  "INDP": "Indaptus Therapeutics, Inc. Common Stock",
  "INDV": "Indivior Pharmaceuticals, Inc. Common Stock",
  "INEO": "INNEOVA Holdings Limited Class A",
  "INFQ": "Infleqtion, Inc.",
  "INFU": "InfuSystem Holdings, Inc.",
  "INFY": "Infosys Limited ADR",
  "ING": "ING Groep N.V. ADR",
  "INGM": "Ingram Micro Holding Corporation",
  "INGN": "Inogen Inc",
  "INGR": "Ingredion Incorporated",
  "INHD": "Inno Holdings Inc. Common Stock",
  "INIO": "INNIO N.V.",
  "INKT": "MiNK Therapeutics, Inc. Common Stock",
  "INLF": "INLIF LIMITED Class A",
  "INLX": "Intellinetics, Inc.",
  "INM": "InMed Pharmaceuticals Inc. Common Shares",
  "INMB": "INmune Bio Inc. Common stock",
  "INMD": "InMode Ltd.",
  "INN": "Summit Hotel Properties, Inc.",
  "INN-P-E": "Summit Hotel Properties, Inc Series E Preferred Stock",
  "INN-P-F": "Summit Hotel Properties, Inc Series F Preferred Stock",
  "INNV": "InnovAge Holding Corp. Common Stock",
  "INO": "Inovio Pharmaceuticals, Inc.",
  "INOD": "Innodata Inc.",
  "INR": "Infinity Natural Resources, Inc.",
  "INSE": "Inspired Entertainment, Inc.",
  "INSG": "Inseego Corp. Common Stock",
  "INSM": "Insmed, Inc.",
  "INSP": "Inspire Medical Systems, Inc.",
  "INSW": "International Seaways, Inc. Common Stock",
  "INTA": "Intapp, Inc. Common Stock",
  "INTC": "Intel Corp",
  "INTG": "Intergroup Corporation (The)",
  "INTJ": "Intelligent Group Limited Class A",
  "INTR": "Inter & Co. Inc. Class A Common Shares",
  "INTS": "Intensity Therapeutics, Inc. Common stock",
  "INTT": "inTEST Corporation",
  "INTU": "Intuit Inc",
  "INTZ": "Intrusion Inc New",
  "INUV": "Inuvo, Inc.",
  "INV": "Innventure, Inc. Common Stock",
  "INVA": "Innoviva, Inc. Common Stock",
  "INVE": "Identive, Inc.",
  "INVH": "Invitation Homes Inc. Common Stock",
  "INVX": "Innovex International, Inc.",
  "INVZ": "Innoviz Technologies Ltd.",
  "IOND": "Ionic Digital Inc. Class A Common Stock",
  "IONQ": "IonQ, Inc.",
  "IONR": "ioneer Ltd ADR",
  "IONS": "Ionis Pharmaceuticals, Inc. Common Stock",
  "IOR": "Income Opportunity Realty Investors, Inc.",
  "IOSP": "Innospec Inc.",
  "IOT": "Samsara Inc.",
  "IOTR": "iOThree Limited",
  "IOVA": "Iovance Biotherapeutics, Inc. Common Stock",
  "IP": "International Paper Co.",
  "IPAR": "Interparfums, Inc. Common Stock",
  "IPCX": "Inflection Point Acquisition Corp. III Class A",
  "IPDN": "Professional Diversity Network, Inc.",
  "IPEX": "Inflection Point Acquisition Corp. V Class A",
  "IPFX": "Inflection Point Acquisition Corp. VI Class A",
  "IPGP": "IPG Photonics Corporation",
  "IPHA": "Innate Pharma S.A. ADS",
  "IPI": "Intrepid Potash, Inc",
  "IPM": "Intelligent Protection Management Corp. Common Stock",
  "IPSC": "Century Therapeutics, Inc. Common Stock",
  "IPST": "IP Strategy Holdings, Inc. Common Stock",
  "IPVV": "InterPrivate Investment Partners V, Inc. Class A",
  "IPW": "iPower, Inc. Common Stock",
  "IPWR": "Ideal Power Inc.",
  "IPX": "IperionX Limited ADR",
  "IQ": "iQIYI, Inc. ADR",
  "IQI": "INVESCO QUALITY MUNICIPAL SECURITIES",
  "IQMX": "IQM Quantum Computers Oyj ADR",
  "IQST": "IQSTEL INC. Common Stock",
  "IQV": "IQVIA Holdings Inc.",
  "IR": "Ingersoll Rand Inc. Common Stock",
  "IRAB": "Iris Acquisition Corp II",
  "IRD": "Opus Genetics, Inc. Common Stock",
  "IRDM": "Iridium Communications Inc.",
  "IREN": "IREN Limited",
  "IRHO": "Iron Horse Acquisitions II Corp. Common Stock",
  "IRIX": "Iridex Corp",
  "IRM": "Iron Mountain Inc.",
  "IRMD": "iRadimed Corporation",
  "IRON": "Disc Medicine, Inc. Common Stock",
  "IRS": "IRSA Inversiones y Representaciones S.A. Global Depositary Shares",
  "IRT": "Independence Realty Trust Inc.",
  "IRTC": "iRhythm Holdings, Inc. Common Stock",
  "IRWD": "Ironwood Pharmaceuticals, Inc. - Class A",
  "ISBA": "Isabella Bank Corporation Common stock",
  "ISD": "PGIM High Yield Bond Fund, Inc.",
  "ISNR": "Snow Rothschild Acquisition Corp. Class A",
  "ISOU": "IsoEnergy Ltd.",
  "ISPC": "iSpecimen Inc. Common Stock",
  "ISPR": "Ispire Technology Inc. Common Stock",
  "ISRG": "Intuitive Surgical Inc.",
  "ISSC": "Innovative Solutions & Support",
  "ISTR": "Investar Holding Corporation",
  "IT": "Gartner, Inc.",
  "ITG": "ITG, Inc. Class A Common Stock",
  "ITGR": "Integer Holdings Corporation",
  "ITHA": "ITHAX Acquisition Corp III Class A",
  "ITIC": "Investors Title Co",
  "ITOC": "iTonic Holdings Ltd Class A",
  "ITP": "IT Tech Packaging, Inc.",
  "ITRG": "Integra Resources Corp.",
  "ITRI": "Itron Inc",
  "ITRN": "Ituran Location and Control Ltd.",
  "ITT": "ITT Inc.",
  "ITUB": "Itau Unibanco Holding S.A. ADR",
  "ITW": "Illinois Tool Works Inc.",
  "IVA": "Inventiva S.A. ADR",
  "IVDA": "Iveda Solutions, Inc. Common Stock",
  "IVF": "INVO Fertility, Inc. Common Stock",
  "IVR": "Invesco Mortgage Capital Inc.",
  "IVR-P-C": "Invesco Mortgage Capital Inc Series C Preferred Stock",
  "IVT": "InvenTrust Properties Corp.",
  "IVVD": "Invivyd, Inc. Common Stock",
  "IVZ": "Invesco LTD",
  "IX": "ORIX Corporation ADR",
  "IXHL": "Incannex Healthcare Limited ADR",
  "IZEA": "IZEA Worldwide, Inc. Common Stock",
  "IZM": "ICZOOM Group Inc. Class A",
  "J": "Jacobs Solutions Inc.",
  "JAB": "JAB Acquisition Corp I Class A",
  "JACK": "Jack in the Box Inc.",
  "JACS": "Jackson Acquisition Company II",
  "JAGU": "Jaguar Uranium Corp.",
  "JAGX": "Jaguar Health, Inc.",
  "JAKK": "Jakks Pacific Inc",
  "JAN": "Janus Living, Inc.",
  "JANX": "Janux Therapeutics, Inc. Common Stock",
  "JATT": "JATT II Acquisition Corp",
  "JAZZ": "Jazz Pharmaceuticals, Inc.",
  "JBDI": "JBDI Holdings Limited",
  "JBGS": "JBG SMITH Properties Common Shares",
  "JBHT": "JB Hunt Transport Services Inc",
  "JBI": "Janus International Group, Inc.",
  "JBIO": "Jade Biosciences, Inc. Common Stock",
  "JBK": "Lehman ABS Corp 3.50 Adj Corp Backed Tr Cert Goldman Cap I",
  "JBL": "Jabil Inc.",
  "JBLU": "JetBlue Airways Corp",
  "JBS": "JBS N.V.",
  "JBSS": "John B. Sanfilippo & SON",
  "JBTM": "JBT Marel Corporation",
  "JCAP": "Jefferson Capital, Inc. Common Stock",
  "JCE": "Nuveen Core Equity Alpha Fund",
  "JCI": "Johnson Controls International plc",
  "JCSE": "JE Cleantech Holdings Limited",
  "JCTC": "Jewett-Cameron Trading",
  "JD": "JD.com, Inc.",
  "JDZG": "JIADE LIMITED Class A",
  "JEF": "Jefferies Financial Group Inc.",
  "JELD": "JELD-WEN Holding, Inc.",
  "JEM": "707 Cayman Holdings Limited",
  "JENA": "Jena Acquisition Corporation II",
  "JF": "J and Friends Holdings Limited ADR",
  "JFB": "JFB Construction Holdings Class A Common Stock",
  "JFIN": "Jiayin Group Inc. ADR",
  "JFR": "Nuveen Floating Rate Income Fund",
  "JFU": "9F Inc. ADR",
  "JG": "Aurora Mobile Limited ADR",
  "JGH": "NUVEEN GLOBAL HIGH INCOME FUND",
  "JHI": "John Hancock Investors Trust Capital Stock",
  "JHS": "John Hancock Income Securities Trust Capital Stock",
  "JHX": "James Hardie Industries plc",
  "JILL": "J.Jill, Inc. Common Stock",
  "JJSF": "J&J Snack Foods Corp",
  "JKHY": "Henry (Jack) & Associates",
  "JKS": "JINKOSOLAR HOLDINGS CO",
  "JL": "J-Long Group Limited Class A",
  "JLHL": "Julong Holding Limited Class A",
  "JLL": "Jones Lang LaSalle, Inc.",
  "JLS": "Nuveen Mortgage and Income Fund",
  "JMIA": "Jumia Technologies AG",
  "JMKE": "Jersey Mike's Subs Inc.",
  "JMM": "NUVEEN MULTI-MARKET INCOME FUND, INC",
  "JMSB": "John Marshall Bancorp, Inc. Common Stock",
  "JNJ": "Johnson & Johnson",
  "JOB": "GEE Group Inc.",
  "JOBY": "Joby Aviation, Inc.",
  "JOE": "St. Joe Company",
  "JOF": "JAPAN SMALLER CAPITALIZATION FUND",
  "JOUT": "Johnson Outdoors Inc",
  "JOYY": "JOYY Inc. ADR",
  "JPC": "Nuveen Preferred & Income Opportunities Fund",
  "JPM": "JPMorgan Chase & Co.",
  "JPM-P-C": "JPMorgan Chase & Co Preferred Stock",
  "JPM-P-D": "JPMorgan Chase & Co Preferred Stock",
  "JPM-P-J": "JPMorgan Chase & Co Preferred Stock",
  "JPM-P-K": "JPMorgan Chase & Co Preferred Stock",
  "JPM-P-L": "JPMorgan Chase & Co Preferred Stock",
  "JPM-P-M": "JPMorgan Chase & Co Preferred Stock",
  "JQC": "Nuveen Credit Strategies Income Fund",
  "JRI": "NUVEEN REAL ASSET INCOME AND GROWTH FUND",
  "JRS": "Nuveen Real Estate Income Fund",
  "JRSH": "Jerash Holdings (US), Inc. Common Stock",
  "JRVR": "James River Group Holdings, Inc. Common Stock",
  "JSPR": "Jasper Therapeutics, Inc. Common Stock",
  "JTAI": "Jet.AI Inc. Common Stock",
  "JUNS": "Jupiter Neurosciences, Inc. Common Stock",
  "JVA": "Coffee Holding Co., Inc.",
  "JWEL": "Jowell Global Ltd.",
  "JXG": "JX Luxventure Limited Common Stock",
  "JXN": "Jackson Financial Inc.",
  "JXN-P-A": "Jackson Financial Inc Series A Preferred Stock",
  "JYD": "Jayud Global Logistics Limited Class A",
  "JYNT": "The Joint Corp.",
  "JZ": "Jianzhi Education Technology Group Company Limited ADR",
  "JZXN": "Jiuzi Holdings, Inc.",
  "KAI": "Kadant Inc.",
  "KALA": "KALA BIO, Inc. Common Stock",
  "KALU": "Kaiser Aluminum Corporation",
  "KAPA": "Kairos Pharma, Ltd.",
  "KARD": "Kardigan, Inc. Common Stock",
  "KARO": "Karooooo Ltd.",
  "KAZR": "Skyline Builders Group Holding Limited Class A",
  "KB": "KB Financial Group Inc",
  "KBDC": "Kayne Anderson BDC, Inc.",
  "KBH": "KB Home",
  "KBON": "Karbon Capital Partners Corp. Class A",
  "KBR": "KBR, Inc.",
  "KBSX": "FST Corp.",
  "KC": "Kingsoft Cloud Holdings Limited ADR",
  "KCHV": "Kochav Defense Acquisition Corp. Class A",
  "KD": "Kyndryl Holdings, Inc.",
  "KDK": "Kodiak AI, Inc. Common Stock",
  "KDP": "Keurig Dr Pepper Inc.",
  "KE": "Kimball Electronics, Inc.",
  "KEEL": "Keel Infrastructure Corp. Common Stock",
  "KELYA": "Kelly Services Inc",
  "KELYB": "Kelly Services Inc",
  "KEN": "KENON HOLDINGS LTD.",
  "KEP": "Korea Electric Power Corp",
  "KEQU": "Kewaunee Scientific Corp",
  "KEX": "Kirby Corporation",
  "KEY": "KeyCorp",
  "KEY-P-I": "KeyCorp Series E Preferred Stock",
  "KEY-P-J": "KeyCorp Series F Preferred Stock",
  "KEY-P-K": "KeyCorp Series G Preferred Stock",
  "KEY-P-L": "KeyCorp Series H Preferred Stock",
  "KEYS": "Keysight Technologies, Inc.",
  "KEYY": "Keystone Acquisition Corp. Class A",
  "KF": "KOREA FUND, INC",
  "KFFB": "Kentucky First Federal Bancorp",
  "KFII": "K&F Growth Acquisition Corp. II Class A",
  "KFRC": "Kforce Inc.",
  "KFY": "Korn Ferry",
  "KG": "Kestrel Group, Ltd.",
  "KGC": "Kinross Gold Corporation",
  "KGEI": "Kolibri Global Energy Inc. Common Stock",
  "KGS": "Kodiak Gas Services, Inc.",
  "KHC": "The Kraft Heinz Company Common Stock",
  "KIDS": "OrthoPediatrics Corp. Common Stock",
  "KIDZ": "KIDZ AI Inc. Class B Common Stock",
  "KIM": "Kimco Realty Corp.",
  "KIM-P-L": "Kimco Realty Corporation Class L Depositary Shares, each of which represents a one-one thousandth fractional interest in a share of Class L Preferred Stock",
  "KIM-P-M": "Kimco Realty Corporation Class M Depositary Shares, each of which represents a one-one thousandth fractional interest in a share of Class M Preferred Stock",
  "KIM-P-N": "Kimco Realty Corporation Class N Preferred Stock",
  "KINS": "Kingstone Companies, Inc.",
  "KIO": "KKR INCOME OPPORTUNITIES FUND",
  "KITT": "Nauticus Robotics, Inc. Common stock",
  "KKR": "KKR & Co. Inc.",
  "KKR-P-D": "KKR & Co. Inc Series D Preferred Stock",
  "KLAC": "KLA Corporation Common Stock",
  "KLAR": "Klarna Group plc",
  "KLC": "KinderCare Learning Companies, Inc.",
  "KLIC": "Kulicke & Soffa Industries Inc",
  "KLRA": "Kailera Therapeutics, Inc. Common Stock",
  "KLRS": "Kalaris Therapeutics, Inc. Common Stock",
  "KLTR": "Kaltura, Inc. Common Stock",
  "KLXE": "KLX Energy Services Holdings, Inc. Common Stock",
  "KMB": "Kimberly-Clark Corp.",
  "KMDA": "Kamada Ltd",
  "KMI": "Kinder Morgan, Inc.",
  "KMPR": "Kemper Corporation",
  "KMRK": "K-Tech Solutions Company Limited Class A",
  "KMT": "Kennametal Inc.",
  "KMTS": "Kestra Medical Technologies, Ltd. Common Stock",
  "KMX": "CarMax Inc.",
  "KN": "KNOWLES CORPORATION",
  "KNDI": "Kandi Technologies Group, Inc.",
  "KNF": "Knife River Corporation",
  "KNOP": "KNOT OFFSHORE PARTNERS LP",
  "KNRX": "KNOREX LTD.",
  "KNSA": "Kiniksa Pharmaceuticals International, plc Class A",
  "KNSL": "Kinsale Capital Group, Inc.",
  "KNTK": "Kinetik Holdings Inc.",
  "KNX": "Knight-Swift Transportation Holdings Inc. Class A Common Stock",
  "KO": "Coca-Cola Company",
  "KOD": "Kodiak Sciences Inc Common Stock",
  "KODK": "EASTMAN KODAK COMPANY",
  "KOF": "Coca-Cola FEMSA, S.A.B DE C.V",
  "KOP": "Koppers Holdings, Inc.",
  "KOPN": "Kopin Corp",
  "KOS": "Kosmos Energy Ltd.",
  "KOSS": "Koss Corp",
  "KOYN": "CSLM Digital Asset Acquisition Corp III Class A",
  "KPET": "KPET Ultra Paceline Corporation",
  "KPLT": "Katapult Holdings, Inc. Common Stock",
  "KPRX": "Kiora Pharmaceuticals, Inc. Common Stock",
  "KPTI": "Karyopharm Therapeutics Inc.",
  "KR": "The Kroger Co.",
  "KRAQ": "KRAKacquisition Corp Class A",
  "KRC": "Kilroy Realty Corp.",
  "KREF": "KKR Real Estate Finance Trust Inc.",
  "KREF-P-A": "KKR Real Estate Finance Trust Inc Series A Preferred Stock",
  "KRG": "Kite Realty Group Trust",
  "KRKR": "36Kr Holdings Inc. ADR",
  "KRMD": "KORU Medical Systems, Inc. Common Stock (DE)",
  "KRMN": "Karman Holdings Inc.",
  "KRNT": "Kornit Digital Ltd.",
  "KRNY": "Kearny Financial Corporation",
  "KRO": "Kronos Worldwide, Inc.",
  "KROS": "Keros Therapeutics, Inc. Common Stock",
  "KRP": "Kimbell Royalty Partners, LP Common Units representing Limited Partner Interests",
  "KRRO": "Korro Bio, Inc. Common Stock",
  "KRSP": "Rice Acquisition Corporation 3",
  "KRT": "Karat Packaging Inc. Common Stock",
  "KRUS": "Kura Sushi USA, Inc. Class A Common Stock",
  "KRYS": "Krystal Biotech, Inc. Common Stock",
  "KSCP": "Knightscope, Inc. Class A Common Stock",
  "KSPI": "Joint Stock Company Kaspi.kz ADR",
  "KSS": "Kohls Corporation",
  "KT": "KT Corp.",
  "KTB": "Kontoor Brands, Inc. Common Stock",
  "KTCC": "KEY Tronic Corp",
  "KTF": "DWS Municipal Income Trust",
  "KTH": "Structured Products CorTS PECO Energy Cap Trust III, 8% Cert.",
  "KTN": "Structured Products CorTS Aon Capital A, 8.205% Cert.",
  "KTOS": "Kratos Defense & Security Solutions, Inc.",
  "KTTA": "Pasithea Therapeutics Corp. Common Stock",
  "KTWO": "K2 Capital Acquisition Corporation Class A Ordinary Share",
  "KULR": "KULR Technology Group, Inc.",
  "KURA": "Kura Oncology, Inc.",
  "KUST": "Kustom Entertainment, Inc. Common Stock",
  "KVHI": "KVH Industries Inc",
  "KVUE": "Kenvue Inc.",
  "KVYO": "Klaviyo, Inc.",
  "KWM": "K Wave Media, Ltd.",
  "KWR": "Quaker Houghton",
  "KWY": "Kingsway Corporation",
  "KXIN": "Kaixin Holdings",
  "KYIV": "Kyivstar Group Ltd. Common Shares",
  "KYMR": "Kymera Therapeutics, Inc. Common Stock",
  "KYN": "Kayne Anderson Energy Infrastructure Fund, Inc.",
  "KYNB": "Kyntra Bio, Inc. Common Stock",
  "KYTX": "Kyverna Therapeutics, Inc. Common Stock",
  "KZIA": "Kazia Therapeutics Limited ADR",
  "L": "Loews Corporation",
  "LAB": "Standard BioTools Inc. Common Stock",
  "LABT": "Lakewood-Amedex Biotherapeutics Inc. Common Stock",
  "LAC": "Lithium Americas Corp.",
  "LAD": "Lithia Motors, Inc.",
  "LADR": "LADDER CAPITAL CORP",
  "LAES": "SEALSQ Corp",
  "LAFA": "LaFayette Acquisition Corp. Ordinary Share",
  "LAKE": "Lakeland Industries Inc",
  "LAMR": "Lamar Advertising Co",
  "LAND": "Gladstone Land Corporation",
  "LANDO": "Gladstone Land Corporation Series B Preferred Stock",
  "LANDP": "Gladstone Land Corporation Series C Preferred Stock",
  "LANV": "Lanvin Group Holdings Limited",
  "LAR": "Lithium Argentina AG",
  "LARK": "Landmark Bancorp Inc",
  "LASE": "Laser Photonics Corporation Common Stock",
  "LASR": "nLIGHT, Inc. Common Stock",
  "LATA": "Galata Acquisition Corp. II Class A",
  "LAUR": "Laureate Education, Inc. Common Stock",
  "LAW": "CS Disco, Inc.",
  "LAWR": "Robot Consulting Co., Ltd. ADS",
  "LAZ": "Lazard, Inc.",
  "LB": "LandBridge Company LLC",
  "LBGJ": "Li Bang International Corporation Inc. Class A",
  "LBRDA": "Liberty Broadband Corporation Class A",
  "LBRDK": "Liberty Broadband Corporation Class C",
  "LBRDP": "Liberty Broadband Corporation Series A Series A Preferred Stock",
  "LBRT": "Liberty Energy Inc.",
  "LBRX": "LB Pharmaceuticals Inc Common Stock",
  "LBTYA": "Liberty Global Ltd. Class A Common Shares",
  "LBTYB": "Liberty Global Ltd. Class B Common Shares",
  "LBTYK": "Liberty Global Ltd. Class C Common Shares",
  "LCCC": "Lakeshore Acquisition III Corp.",
  "LCFY": "Locafy Limited Ordinary Share",
  "LCID": "Lucid Group, Inc. Common Stock",
  "LCII": "LCI Industries",
  "LCLN": "Lincoln International, Inc.",
  "LCNB": "LCNB Corporation",
  "LCTX": "Lineage Cell Therapeutics, Inc.",
  "LCUT": "Lifetime Brands, Inc.",
  "LDI": "loanDepot, Inc.",
  "LDOS": "Leidos Holdings, Inc.",
  "LDP": "COHEN & STEERS LIMITED DURATION PREFERRED AND INCOME FUND INC",
  "LE": "Lands' End, Inc. Common Stock",
  "LEA": "Lear Corporation",
  "LECO": "Lincoln Electric Holdings Inc",
  "LEDS": "SemiLEDS Corporation",
  "LEE": "Lee Enterprises, Inc.",
  "LEG": "Leggett & Platt, Inc.",
  "LEGH": "Legacy Housing Corporation Common Stock",
  "LEGN": "Legend Biotech Corporation ADR",
  "LEGO": "Legato Merger Corp. IV",
  "LEN": "Lennar Corporation Class A",
  "LEN-B": "Lennar Corporation Class B",
  "LENZ": "LENZ Therapeutics, Inc. Common Stock",
  "LEO": "BNY Mellon Strategic Municipals, Inc.",
  "LESL": "Leslie's, Inc. Common Stock",
  "LEU": "Centrus Energy Corp.",
  "LEVI": "Levi Strauss & Co. Class A Common Stock",
  "LEXX": "Lexaria Bioscience Corp. Common Stock",
  "LFAC": "Leapfrog Acquisition Corporation Class A",
  "LFCR": "Lifecore Biomedical, Inc. Common Stock",
  "LFMD": "LifeMD, Inc. Common Stock",
  "LFMDP": "LifeMD, Inc Series A Preferred Stock",
  "LFS": "LEIFRAS Co., Ltd. ADR",
  "LFST": "LifeStance Health Group, Inc. Common Stock",
  "LFT": "Lument Finance Trust, Inc.",
  "LFT-P-A": "Lument Finance Trust, Inc Series A Preferred Stock",
  "LFTO": "Liftoff Mobile, Inc. Common Stock",
  "LFUS": "Littelfuse Inc",
  "LFVN": "Lifevantage Corporation Common Stock (Delaware)",
  "LFWD": "Lifeward Ltd.",
  "LGCL": "Lucas GC Limited",
  "LGCY": "Legacy Education Inc.",
  "LGHL": "Lion Group Holding Ltd. ADR",
  "LGI": "Lazard Global Total Return & Income Fund",
  "LGIH": "LGI Homes, Inc.",
  "LGL": "The LGL Group, Inc.",
  "LGN": "Legence Corp. Class A Common stock",
  "LGND": "Ligand Pharmaceuticals Inc.",
  "LGO": "Largo Inc. Common Shares",
  "LGPS": "LogProstyle Inc.",
  "LGVN": "Longeveron Inc. Common Stock",
  "LH": "Labcorp Holdings Inc.",
  "LHAI": "Linkhome Holdings Inc. Common stock",
  "LHSW": "Lianhe Sowell International Group Ltd Class A",
  "LHX": "L3Harris Technologies, Inc.",
  "LI": "Li Auto Inc. ADR",
  "LICN": "Lichen China Limited Class A",
  "LIDR": "AEye, Inc. Class A Common Stock",
  "LIEN": "Chicago Atlantic BDC, Inc. Common Stock",
  "LIF": "Life360, Inc. Common Stock",
  "LIFE": "Ethos Technologies Inc. Class A Common Stock",
  "LII": "Lennox International Inc.",
  "LILA": "Liberty Latin America Ltd. Class A Common Stock",
  "LILAK": "Liberty Latin America Ltd. Class C Common Stock",
  "LILAP": "Liberty Latin America Ltd Series A Preference Shares",
  "LIME": "Neutron Holdings, Inc. Common Stock",
  "LIMN": "Liminatus Pharma, Inc. Class A Common Stock",
  "LIN": "Linde plc Ordinary Share",
  "LINC": "Lincoln Educational Services",
  "LIND": "Lindblad Expeditions Holdings Inc. Common Stock",
  "LINE": "Lineage, Inc. Common Stock",
  "LINK": "Interlink Electronics, Inc. Common Stock",
  "LION": "Lionsgate Studios Corp.",
  "LIQT": "LiqTech International, Inc.",
  "LITB": "LightInTheBox Holding Co., Ltd. ADR",
  "LITE": "Lumentum Holdings Inc. Common Stock",
  "LITS": "Lite Strategy, Inc. Common Stock",
  "LIVE": "Live Ventures Inc",
  "LIVN": "LivaNova PLC",
  "LKFN": "Lakeland Financial Corp",
  "LKFT": "Lakefront Biotherapeutics ADR",
  "LKQ": "LKQ Corporation",
  "LKSP": "Lake Superior Acquisition Corp. Class A",
  "LLY": "Eli Lilly & Co.",
  "LLYVA": "Liberty Live Holdings, Inc. Series A Liberty Live Group Common Stock",
  "LLYVK": "Liberty Live Holdings, Inc. Series C Liberty Live Group Common Stock",
  "LMAT": "LeMaitre Vascular, Inc.",
  "LMB": "Limbach Holdings, Inc Common Stock",
  "LMND": "Lemonade, Inc.",
  "LMNR": "Limoneira Co",
  "LMRI": "Lumexa Imaging Holdings, Inc. Common Stock",
  "LMT": "Lockheed Martin Corp.",
  "LNAI": "Lunai Bioworks Inc. Common Stock",
  "LNC": "Lincoln National Corp.",
  "LNC-P-D": "Lincoln National Corporation Series D Preferred Stock",
  "LND": "BrasilAgro - Companhia Brasileira de Propriedades Agra­colas",
  "LNG": "Cheniere Energy Inc",
  "LNKS": "Linkers Industries Limited Class A",
  "LNN": "Lindsay Corporation",
  "LNSR": "LENSAR, Inc. Common Stock",
  "LNT": "Alliant Energy Corporation Common Stock",
  "LNTH": "Lantheus Holdings, Inc",
  "LNZA": "LanzaTech Global, Inc. Common Stock",
  "LOAN": "Manhattan Bridge Capital, Inc",
  "LOAR": "Loar Holdings Inc.",
  "LOB": "Live Oak Bancshares, Inc.",
  "LOB-P-A": "Live Oak Bancshares, Inc Series A Preferred Stock",
  "LOBO": "LOBO TECHNOLOGIES LTD. Class A",
  "LOCL": "Local Bounti Corporation",
  "LOCO": "El Pollo Loco Holdings, Inc.",
  "LODE": "Comstock Inc.",
  "LOGI": "Logitech International SA",
  "LOMA": "Loma Negra Compañía Industrial Argentina Sociedad Anónima ADR",
  "LONA": "LeonaBio, Inc. Common Stock",
  "LOOP": "Loop Industries, Inc. Common Stock",
  "LOPE": "Grand Canyon Education, Inc",
  "LOT": "Lotus Technology Inc. ADR",
  "LOVE": "The Lovesac Company Common Stock",
  "LOW": "Lowe's Companies Inc.",
  "LPA": "Logistic Properties of the Americas",
  "LPAA": "Launch One Acquisition Corp. Class A",
  "LPBB": "Launch Two Acquisition Corp. Class A",
  "LPCN": "Lipocine Inc.",
  "LPCV": "Launchpad Cadenza Acquisition Corp I Class A Ordinary Share",
  "LPG": "DORIAN LPG LTD",
  "LPL": "LG Display Co. Ltd.",
  "LPLA": "LPL Financial Holdings Inc.",
  "LPSN": "LivePerson Inc",
  "LPTH": "Lightpath Technologies Inc",
  "LPX": "Louisiana-Pacific Corp.",
  "LQDA": "Liquidia Corporation Common Stock",
  "LQDT": "Liquidity Services, Inc.",
  "LRCX": "Lam Research Corp",
  "LRE": "Lead Real Estate Co., Ltd ADR",
  "LRHC": "La Rosa Holding Corp. Common Stock",
  "LRMR": "Larimar Therapeutics, Inc. Common Stock",
  "LRN": "Stride, Inc.",
  "LSAK": "Lesaka Technologies, Inc. Common Stock",
  "LSBK": "Lake Shore Bancorp, Inc.",
  "LSCC": "Lattice Semiconductor Corp",
  "LSE": "Leishen Energy Holding Co., Ltd. Class A",
  "LSF": "Laird Superfood, Inc.",
  "LSPD": "Lightspeed Commerce Inc.",
  "LSTA": "Lisata Therapeutics, Inc. Common Stock",
  "LSTR": "Landstar System Inc",
  "LTBR": "Lightbridge Corp.",
  "LTC": "LTC Properties, Inc.",
  "LTGO": "Latigo Biotherapeutics, Inc. Common Stock",
  "LTGR": "Long Table Growth Corp. Class A",
  "LTH": "Life Time Group Holdings, Inc.",
  "LTM": "LATAM Airlines Group S.A. ADR",
  "LTRN": "Lantern Pharma Inc. Common Stock",
  "LTRX": "Lantronix Inc",
  "LU": "Lufax Holding Ltd. ADR",
  "LUCD": "Lucid Diagnostics Inc. Common Stock",
  "LUCK": "Lucky Strike Entertainment Corporation",
  "LUCY": "Innovative Eyewear, Inc. Common Stock",
  "LUD": "Luda Technology Group Limited",
  "LULU": "lululemon athletica inc.",
  "LUMN": "Lumen Technologies, Inc.",
  "LUNG": "Pulmonx Corporation Common Stock",
  "LUNR": "Intuitive Machines, Inc. Class A Common Stock",
  "LUV": "Southwest Airlines Co.",
  "LUXE": "LuxExperience B.V. ADR",
  "LVLU": "Lulu's Fashion Lounge Holdings, Inc. Common Stock",
  "LVO": "LiveOne, Inc. Common Stock",
  "LVS": "Las Vegas Sands Corp.",
  "LVWR": "LiveWire Group, Inc.",
  "LW": "Lamb Weston Holdings, Inc.",
  "LWAC": "LightWave Acquisition Corp. Class A",
  "LWAY": "Lifeway Foods Inc",
  "LWLG": "Lightwave Logic, Inc. Common Stock",
  "LX": "LexinFintech Holdings Ltd. ADR",
  "LXEH": "Lixiang Education Holding Co., Ltd. ADR",
  "LXEO": "Lexeo Therapeutics, Inc. Common Stock",
  "LXFR": "Luxfer Holdings PLC",
  "LXP": "LXP Industrial Trust",
  "LXP-P-C": "LXP Industrial Trust Series C Preferred Stock",
  "LXRX": "Lexicon Pharmaceuticals, Inc.",
  "LXU": "LSB INDUSTRIES INC",
  "LYB": "LyondellBasell Industries N.V. Class A",
  "LYEL": "Lyell Immunopharma, Inc. Common Stock",
  "LYFT": "Lyft, Inc. Class A Common Stock",
  "LYG": "Lloyds Banking Group PLC",
  "LYTS": "LSI Industries Inc",
  "LYV": "Live Nation Entertainment Inc.",
  "LZ": "LegalZoom.com, Inc. Common Stock",
  "LZB": "La-Z-Boy Incorporated",
  "LZM": "Lifezone Metals Limited",
  "LZMH": "LZ Technology Holdings Limited Class B",
  "M": "Macy's Inc.",
  "MA": "Mastercard Incorporated",
  "MAA": "Mid-America Apartment Communities, Inc.",
  "MAA-P-I": "Mid-America Apartment Communities, Inc Series I Preferred Stock",
  "MAAS": "Maase Inc. Class A",
  "MAC": "The Macerich Company",
  "MACI": "Melar Acquisition Corp. I Class A",
  "MAGH": "Magnitude International Ltd",
  "MAGN": "Magnera Corporation",
  "MAIA": "MAIA Biotechnology, Inc.",
  "MAIN": "Main Street Capital Corporation",
  "MAIR": "Madison Air Solutions Corporation",
  "MAKO": "Mako Mining Corp Common Stock",
  "MAMA": "Mama's Creations, Inc. Common Stock",
  "MAMK": "MaxsMaking Inc. Class A",
  "MAMO": "Massimo Group Common Stock",
  "MAN": "ManpowerGroup",
  "MANE": "Veradermics, Incorporated",
  "MANH": "Manhattan Associates Inc",
  "MANU": "MANCHESTER UNITED PLC",
  "MAR": "Marriott International Class A Common Stock",
  "MARA": "MARA Holdings, Inc. Common Stock",
  "MAS": "Masco Corporation",
  "MASK": "3 E Network Technology Group Ltd Class A",
  "MASS": "908 Devices Inc. Common Stock",
  "MAT": "Mattel, Inc.",
  "MATH": "Metalpha Technology Holding Limited",
  "MATV": "Mativ Holdings, Inc.",
  "MATW": "Matthews International Corp",
  "MATX": "Matsons, Inc.",
  "MAX": "MediaAlpha, Inc.",
  "MAYS": "Mays (J.W.) Inc",
  "MAZE": "Maze Therapeutics, Inc. Common Stock",
  "MB": "MasterBeef Group",
  "MBAI": "Check-Cap Ltd.",
  "MBBC": "Marathon Bancorp, Inc. Common Stock",
  "MBC": "MasterBrand, Inc.",
  "MBGL": "Mobility Global Inc.",
  "MBI": "MBIA Inc.",
  "MBIN": "Merchants Bancorp Common Stock",
  "MBINL": "Merchants Bancorp Series E Preferred Stock",
  "MBINM": "Merchants Bancorp Series D Preferred Stock",
  "MBINN": "Merchants Bancorp Depositary Shares Preferred Series C",
  "MBIO": "Mustang Bio, Inc.",
  "MBLY": "Mobileye Global Inc. Class A Common Stock",
  "MBNKO": "Medallion Bank Series G Preferred Stock",
  "MBOT": "Microbot Medical, Inc. Common Stock",
  "MBRX": "Moleculin Biotech, Inc.",
  "MBUU": "Malibu Boats, Inc. Class A",
  "MBVI": "M3-Brigade Acquisition VI Corp. Class A",
  "MBWM": "Mercantile Bank Corp",
  "MBX": "MBX Biosciences, Inc. Common Stock",
  "MC": "MOELIS & COMPANY",
  "MCAH": "Mountain Crest Acquisition 6 Corp.",
  "MCB": "Metropolitan Bank Holding Corp. Common Stock, $0.01 par value per share",
  "MCBS": "METROCITY BANKSHARES INC",
  "MCD": "McDonald's Corporation",
  "MCFT": "MasterCraft Boat Holdings, Inc. Common Stock",
  "MCGA": "Yorkville Acquisition Corp. Class A Ordinary Share",
  "MCHB": "Mechanics Bancorp Class A Common Stock",
  "MCHP": "Microchip Technology Inc",
  "MCHPP": "Microchip Technology Incorporated Series A Preferred Stock",
  "MCHX": "Marchex, Inc. Class B",
  "MCI": "Barings Corporate Investors",
  "MCK": "McKesson Corporation",
  "MCN": "XAI Madison Equity Premium Income Fund",
  "MCO": "Moody's Corporation",
  "MCRB": "Seres Therapeutics, Inc.",
  "MCRI": "Monarch Casino & Resort Inc",
  "MCRP": "Micropolis AI Robotics",
  "MCS": "The Marcus Corporation",
  "MCTA": "Charming Medical Limited Class A",
  "MCY": "Mercury General Corp.",
  "MD": "Pediatrix Medical Group, Inc.",
  "MDA": "MDA Space Ltd.",
  "MDAI": "Spectral AI, Inc. Class A Common Stock",
  "MDB": "MongoDB, Inc. Class A",
  "MDBH": "MDB Capital Holdings, LLC Class A common",
  "MDCX": "Medicus Pharma Ltd. Common Stock",
  "MDGL": "Madrigal Pharmaceuticals, Inc. Common Stock",
  "MDIA": "Mediaco Holding Inc. Class A Common Stock",
  "MDLN": "Medline Inc. Class A common stock",
  "MDLZ": "Mondelez International, Inc. Class A",
  "MDRR": "Medalist Diversified, Inc. Common Stock",
  "MDT": "Medtronic plc",
  "MDU": "MDU Resources Group, Inc.",
  "MDV": "Modiv Industrial, Inc.",
  "MDV-P-A": "Modiv Industrial, Inc Series A Preferred Stock",
  "MDWD": "MediWound Ltd.",
  "MDXG": "MiMedx Group, Inc",
  "MDXH": "MDxHealth SA",
  "MEC": "Mayville Engineering Company, Inc.",
  "MED": "Medifast, Inc.",
  "MEDP": "Medpace Holdings, Inc. Common Stock",
  "MEDS": "DataMeds AI, Inc. Common Stock",
  "MEGI": "NYLI CBRE Global Infrastructure Megatrends Term Fund",
  "MEGL": "Magic Empire Global Limited Class A",
  "MEI": "Methode Electronics",
  "MELI": "Mercado Libre, Inc",
  "MENS": "Jyong Biotech Ltd.",
  "MEOH": "Methanex Corp",
  "MERC": "Mercer International Inc",
  "MESH": "Meshflow Acquisition Corp. Class A",
  "MESO": "Mesoblast Limited ADR",
  "MET": "MetLife, Inc.",
  "MET-P-A": "Metlife, Inc. Floating Rate Non Cuml Series A",
  "MET-P-E": "MetLife, Inc Series E Preferred Stock",
  "MET-P-F": "MetLife, Inc Series F Preferred Stock",
  "META": "Meta Platforms, Inc. Class A Common Stock",
  "METC": "Ramaco Resources, Inc. Class A Common Stock",
  "METCB": "Ramaco Resources, Inc. Class B Common Stock",
  "MEVO": "M Evo Global Acquisition Corp II Class A",
  "MF": "MindForge Inc. Class A",
  "MFA": "MFA Financial, Inc",
  "MFA-P-B": "MFA Financial, Inc Series B Preferred Stock",
  "MFA-P-C": "MFA Financial, Inc Series C Preferred Stock",
  "MFC": "Manulife Financial Corp.",
  "MFG": "Mizuho Financial Group, Inc. ADR",
  "MFI": "mF International Limited Class A",
  "MFIC": "MidCap Financial Investment Corporation Common Stock",
  "MFIN": "Medallion Financial Corp",
  "MFM": "Aberdeen Municipal Income Fund",
  "MFP": "Midera Food Processing, Inc. Common Stock",
  "MG": "Mistras Group Inc.",
  "MGA": "Magna International",
  "MGEE": "MGE Energy Inc",
  "MGF": "Aberdeen Government Markets Income Fund",
  "MGIH": "Millennium Group International Holdings Limited",
  "MGLD": "The Marygold Companies, Inc.",
  "MGM": "MGM RESORTS INTERNATIONAL",
  "MGN": "Megan Holdings Limited Class A",
  "MGNI": "Magnite, Inc. Common Stock",
  "MGNX": "MacroGenics, Inc.",
  "MGPI": "MGP Ingredients Inc",
  "MGRC": "Mcgrath Rentcorp",
  "MGRT": "Mega Fortune Company Limited",
  "MGRX": "Mangoceuticals, Inc. Common Stock",
  "MGTX": "MeiraGTx Holdings plc",
  "MGX": "Metagenomi Therapeutics, Inc. Common Stock",
  "MGY": "Magnolia Oil & Gas Corporation Class A Common Stock",
  "MGYR": "Magyar Bancorp, Inc.",
  "MH": "McGraw Hill, Inc.",
  "MHD": "Blackrock Muniholdings Fund, Inc.",
  "MHF": "Western Asset Municipal High Income Fund, Inc",
  "MHH": "Mastech Digital, Inc.",
  "MHK": "Mohawk Industries, Inc.",
  "MHO": "M/I Homes, Inc.",
  "MI": "NFT Limited",
  "MIAX": "Miami International Holdings, Inc.",
  "MICC": "The Magnum Ice Cream Company N.V.",
  "MIDD": "Middleby Corp",
  "MIMI": "Mint Incorporation Limited Class A",
  "MIN": "Aberdeen Intermediate Income Fund",
  "MIND": "MIND Technology, Inc. Common Stock (DE)",
  "MINE": "Mayfair Gold Corp.",
  "MIR": "Mirion Technologies, Inc.",
  "MIRA": "MIRA Pharmaceuticals, Inc. Common Stock",
  "MIRM": "Mirum Pharmaceuticals, Inc. Common Stock",
  "MIST": "Milestone Pharmaceuticals Inc. Common Shares",
  "MITK": "Mitek Systems, Inc.",
  "MITQ": "Moving iMage Technologies, Inc.",
  "MITT": "TPG Mortgage Investment Trust, Inc.",
  "MITT-P-A": "TPG Mortgage Investment Trust, Inc Series A Preferred Stock",
  "MITT-P-B": "TPG Mortgage Investment Trust, Inc Series B Preferred Stock",
  "MITT-P-C": "TPG Mortgage Investment Trust, Inc Series C Preferred Stock",
  "MIY": "BLACKROCK MUNIYIELD MICHIGAN QUALITY FUND, INC. i",
  "MKC": "McCormick & Company, Incorporated Non-VTG CS",
  "MKC-V": "McCormick & Company, Incorporated Voting CS",
  "MKDW": "MKDWELL Tech Inc. Ordinary Share",
  "MKL": "Markel Group Inc.",
  "MKLY": "McKinley Acquisition Corporation Class A",
  "MKSI": "MKS Inc. Common Stock",
  "MKTW": "MarketWise, Inc. Class A Common Stock",
  "MKTX": "MarketAxess Holdings Inc.",
  "MKZR": "MacKenzie Realty Capital, Inc. Common Stock",
  "MLAA": "Mountain Lake Acquisition Corp. II Class A",
  "MLAB": "Mesa Laboratories Inc",
  "MLCI": "Mount Logan Capital Inc. Common Stock",
  "MLCO": "Melco Resorts & Entertainment Limited ADR",
  "MLEC": "Moolec Science SA",
  "MLGO": "MicroAlgo, Inc.",
  "MLI": "Mueller Industries, Inc.",
  "MLKN": "MillerKnoll, Inc. Common Stock",
  "MLM": "Martin Marietta Materials",
  "MLP": "Maui Land & Pineapple Co.",
  "MLR": "Miller Industries, Inc.",
  "MLSS": "Milestone Scientific, Inc. Common Stock",
  "MLTX": "MoonLake Immunotherapeutics Class A",
  "MLYS": "Mineralys Therapeutics, Inc. Common Stock",
  "MMA": "Mixed Martial Arts Group Limited",
  "MMD": "NYLI MacKay DefinedTerm Muni Opportunities Fund",
  "MMED": "MiniMed Group, Inc. Common Stock",
  "MMI": "MARCUS & MILLICHAP",
  "MMLP": "Martin Midstream Partners LP",
  "MMM": "3M Company",
  "MMS": "MAXIMUS, Inc.",
  "MMSI": "Merit Medical Systems Inc",
  "MMT": "Aberdeen Multi-Market Income Fund",
  "MMTX": "Miluna Acquisition Corp Class A Ordinary Share",
  "MMU": "Western Asset Managed Municipals Fund, Inc",
  "MMYT": "MakeMyTrip Limited",
  "MNDO": "Mind CTI Ltd",
  "MNDR": "Mobile-health Network Solutions Class A",
  "MNDY": "monday.com Ltd.",
  "MNKD": "Mannkind Corporation",
  "MNOV": "Medicinova, Inc.",
  "MNPR": "Monopar Therapeutics Inc. Common Stock",
  "MNR": "Mach Natural Resources LP Common Units representing Limited Partner Interests",
  "MNRO": "Monro, Inc. Common Stock",
  "MNSB": "MainStreet Bancshares, Inc. Common Stock",
  "MNSBP": "MainStreet Bancshares, Inc. Depositary Shares",
  "MNSO": "MINISO Group Holding Limited ADR",
  "MNST": "Monster Beverage Corporation",
  "MNTK": "Montauk Renewables, Inc. Common Stock",
  "MNTN": "MNTN, Inc.",
  "MNTS": "Momentus Inc. Class A Common Stock",
  "MNY": "MoneyHero Limited Class A",
  "MO": "Altria Group, Inc.",
  "MOB": "Mobilicom Limited",
  "MOBI": "Mobia Medical, Inc. Common Stock",
  "MOBX": "Mobix Labs, Inc. Class A Common Stock",
  "MOD": "Modine Manufacturing Co",
  "MODD": "Modular Medical, Inc. Common Stock",
  "MOG-A": "Moog Inc.",
  "MOG-B": "MOOG INC CL B",
  "MOGU": "MOGU Inc. ADR",
  "MOH": "Molina Healthcare, Inc.",
  "MOLN": "Molecular Partners AG ADR",
  "MOMO": "Hello Group Inc. ADR",
  "MORN": "Morningstar, Inc.",
  "MOS": "The Mosaic Company",
  "MOV": "Movado Group, Inc.",
  "MOVE": "Corvex, Inc. Common Stock",
  "MP": "MP Materials Corp.",
  "MPA": "BLACKROCK MUNIYIELD PENNSYLVANIA QUALITY FUND",
  "MPAA": "Motorcar Parts of America, Inc.",
  "MPB": "Mid Penn Bancorp, Inc.",
  "MPC": "MARATHON PETROLEUM CORPORATION",
  "MPLT": "MapLight Therapeutics, Inc. Common Stock",
  "MPLX": "MPLX LP",
  "MPT": "Medical Properties Trust, Inc.",
  "MPTI": "M-tron Industries, Inc.",
  "MPU": "Mega Matrix Inc.",
  "MPV": "Barings Participation Investors",
  "MPWR": "Monolithic Power Systems, Inc.",
  "MQ": "Marqeta, Inc. Class A Common Stock",
  "MQY": "Blackrock Muni Yield Quality Fund, Inc",
  "MRAM": "Everspin Technologies, Inc",
  "MRBK": "Meridian Corporation",
  "MRCY": "Mercury Systems Inc.",
  "MRDN": "Meridian Holdings Inc. Common Stock",
  "MREO": "Mereo BioPharma Group plc ADR",
  "MRK": "Merck & Co., Inc.",
  "MRKR": "Marker Therapeutics, Inc. Common Stock",
  "MRLN": "Merlin, Inc. Common Stock",
  "MRM": "MEDIROM Healthcare Technologies Inc. ADR",
  "MRNA": "Moderna, Inc. Common Stock",
  "MRNO": "Murano Global Investments PLC",
  "MRP": "Millrose Properties, Inc.",
  "MRSH": "Marsh",
  "MRT": "Marti Technologies, Inc.",
  "MRTN": "Marten Transport Ltd",
  "MRVI": "Maravai LifeSciences Holdings, Inc. Class A Common Stock",
  "MRVL": "Marvell Technology, Inc. Common Stock",
  "MRX": "Marex Group Limited",
  "MS": "Morgan Stanley",
  "MS-P-A": "Morgan Stanley Floating Rate non-cumulative Preferred Series A",
  "MS-P-E": "MORGAN STANLEY DEP SHARES EACH REPRESENTING 1/1,000TH OF SHARE OF FIXED TO FLOATING RATE SER E",
  "MS-P-F": "MORGAN STANLEY SERIES F",
  "MS-P-I": "MORGAN STANLEY Series I Preferred Stock",
  "MS-P-K": "Morgan Stanley Series K Preferred Stock",
  "MS-P-L": "Morgan Stanley Series L Preferred Stock",
  "MS-P-O": "Morgan Stanley Series O Preferred Stock",
  "MS-P-P": "Morgan Stanley Series P Preferred Stock",
  "MS-P-Q": "Morgan Stanley Series Q Preferred Stock",
  "MSA": "Mine Safety Incorporated",
  "MSAI": "MultiSensor AI Holdings, Inc. Common Stock",
  "MSB": "Mesabi Trust",
  "MSBI": "Midland States Bancorp, Inc. Common Stock",
  "MSBIP": "Midland States Bancorp, Inc Series A Preferred Stock",
  "MSC": "Studio City International Holdings Limited American depositary shares, each representing four Class A ordinary shares",
  "MSCI": "MSCI, Inc.",
  "MSD": "Morgan Stanley Emerging Markets Debt Fund, Inc.",
  "MSDL": "Morgan Stanley Direct Lending Fund",
  "MSEX": "Middlesex Water Co",
  "MSFT": "Microsoft Corp",
  "MSGE": "Madison Square Garden Entertainment Corp.",
  "MSGM": "Motorsport Games Inc. Class A Common Stock",
  "MSGS": "Madison Square Garden Sports Corp.",
  "MSGY": "Masonglory Limited",
  "MSI": "Motorola Solutions, Inc. New",
  "MSIF": "MSC Income Fund, Inc.",
  "MSLE": "Satellos Bioscience Inc. Common Stock",
  "MSM": "MSC Industrial Direct Co., Inc. Class A",
  "MSN": "Emerson Radio Corp.",
  "MSS": "Maison Solutions Inc. Class A Common Stock",
  "MSTR": "Strategy Inc Common Stock Class A",
  "MT": "ArcelorMittal",
  "MTA": "Metalla Royalty & Streaming Ltd.",
  "MTAL": "Metals Acquisition Corp. II",
  "MTB": "M&T Bank Corp.",
  "MTB-P-H": "M&T Bank Corporation Series H Preferred Stock",
  "MTB-P-J": "M&T Bank Corporation Series J Preferred Stock",
  "MTB-P-K": "M&T Bank Corporation Series K Preferred Stock",
  "MTB-P-L": "M&T Bank Corporation Series L Preferred Stock",
  "MTC": "MMTec, Inc. Common Shares",
  "MTCH": "Match Group, Inc",
  "MTD": "Mettler-Toledo International",
  "MTDR": "MATADOR RESOURCES COMPANY",
  "MTEK": "Maris-Tech Ltd.",
  "MTEN": "Mingteng International Corporation Inc. Class A",
  "MTEX": "Mannatech Inc.",
  "MTG": "MGIC Investment Corp.",
  "MTH": "Meritage Homes Corporation",
  "MTLS": "Materialise NV",
  "MTN": "Vail Resorts, Inc.",
  "MTNB": "Matinas BioPharma Holdings, Inc.",
  "MTNE": "CH4 Natural Solutions Corporation",
  "MTR": "Mesa Royalty Trust",
  "MTRN": "Materion Corporation",
  "MTRX": "Matrix Service Co",
  "MTSI": "MACOM Technology Solutions Holdings, Inc",
  "MTUS": "Metallus Inc.",
  "MTVA": "MetaVia Inc. Common Stock",
  "MTW": "The Manitowoc Company, Inc.",
  "MTX": "Minerals Technologies Inc",
  "MTZ": "MasTec, Inc.",
  "MU": "Micron Technology, Inc.",
  "MUA": "Blackrock Muni Assets Fund, Inc.",
  "MUC": "BLACKROCK MUNIHOLDINGS CALIFORNIA QUALITY FUND, INC",
  "MUFG": "Mitsubishi UFJ Financial Group, Inc.",
  "MUJ": "BLACKROCK MUNIHOLDINGS NEW JERSEY QUALITY FUND, INC.",
  "MUR": "Murphy Oil Corp.",
  "MUSA": "MURPHY USA INC.",
  "MUX": "McEwen Inc.",
  "MUZE": "Muzero Acquisition Corp Class A",
  "MVBF": "MVB Financial Corp. Common Stock",
  "MVIS": "Microvision Inc",
  "MVST": "Microvast Holdings, Inc. Common Stock",
  "MWA": "Mueller Water Products, Inc.",
  "MWC": "Micware Co., Ltd. ADR",
  "MWG": "Multi Ways Holdings Limited",
  "MWH": "SOLV Energy, Inc. Class A Common Stock",
  "MWYN": "Marwynn Holdings, Inc. Common stock",
  "MX": "Magnachip Semiconductor Corp.",
  "MXC": "Mexco Energy Corporation",
  "MXCT": "MaxCyte, Inc. Common Stock",
  "MXE": "The Mexico Equity and Income Fund, Inc.",
  "MXF": "MEXICO FUND",
  "MXL": "MaxLinear, Inc. Common Stock",
  "MYE": "Myers Industries, Inc.",
  "MYFW": "First Western Financial, Inc.",
  "MYGN": "Myriad Genetics Inc",
  "MYI": "BLACKROCK MUNIYIELD QUALITY FUND III, INC.",
  "MYN": "BLACKROCK MUNIYIELD NEW YORK QUALITY FUND, INC.",
  "MYND": "Mynd.ai, Inc. ADR",
  "MYO": "Myomo Inc.",
  "MYPS": "PLAYSTUDIOS, Inc. Class A Common Stock",
  "MYRG": "MYR Group, Inc.",
  "MYSE": "Myseum.AI, Inc. Common Stock",
  "MYSZ": "My Size, Inc",
  "MYX": "Maywood Acquisition Corp. 2 Class A Ordinary Share",
  "MZTI": "The Marzetti Company Common Stock",
  "MZYX": "MOZAYYX Acquisition Corp.",
  "NA": "Nano Labs Ltd Class A",
  "NAAS": "NaaS Technology Inc. ADR",
  "NABL": "N-able, Inc.",
  "NAC": "Nuveen California Quality Municipal Income Fund",
  "NAD": "Nuveen Quality Municipal Income Fund",
  "NAGE": "Niagen Bioscience, Inc. Common Stock",
  "NAII": "Natural Alternatives International Inc.",
  "NAK": "Northern Dynasty Minerals, Ltd.",
  "NAKA": "Nakamoto Inc. Common Stock",
  "NAMI": "Jinxin Technology Holding Company ADR",
  "NAMM": "Namib Minerals",
  "NAMS": "NewAmsterdam Pharma Company N.V.",
  "NAN": "Nuveen New York Quality Municipal Income Fund",
  "NAT": "Nordic American Tanker",
  "NATH": "Nathan's Famous Inc",
  "NATL": "NCR Atleos Corporation",
  "NATR": "Nature's Sunshine Products Inc.",
  "NAUT": "Nautilus Biotechnolgy, Inc. Common Stock",
  "NAVI": "Navient Corporation",
  "NAVN": "Navan, Inc. Class A Common Stock",
  "NAZ": "Nuveen Arizona Quality Municipal Income Fund",
  "NB": "NioCorp Developments Ltd. Common Stock",
  "NBB": "Nuveen Taxable Municipal Income Fund",
  "NBBK": "NB Bancorp, Inc. Common Stock",
  "NBH": "Neuberger Municipal Fund Inc.",
  "NBHC": "NATIONAL BANK HOLDINGS CORP.",
  "NBIS": "Nebius Group N.V. Class A",
  "NBIX": "Neurocrine Biosciences Inc",
  "NBN": "Northeast Bank Common Stock",
  "NBP": "NovaBridge Biosciences ADR",
  "NBR": "Nabors Industries Ltd.",
  "NBRG": "Newbridge Acquisition Limited Class A Ordinary Share",
  "NBTB": "NBT Bancorp Inc",
  "NBTX": "Nanobiotix S.A. ADR",
  "NBXG": "Neuberger Next Generation Connectivity Fund Inc.",
  "NC": "NACCO Industries, Inc.",
  "NCA": "Nuveen California Municipal Value Fund",
  "NCDL": "Nuveen Churchill Direct Lending Corp",
  "NCEL": "NewcelX Ltd.",
  "NCEW": "New Century Logistics (BVI) Limited",
  "NCI": "Neo-Concept International Group Holdings Limited Class A",
  "NCL": "Northann Corp.",
  "NCLH": "Norwegian Cruise Line Holdings Ltd.",
  "NCMI": "National CineMedia, Inc.",
  "NCNA": "NuCana plc ADR",
  "NCNO": "nCino, Inc. Common Stock",
  "NCO": "Southern Cross Acquisition I Corp.",
  "NCPL": "Netcapital Inc. Common Stock",
  "NCRA": "Nocera, Inc. Common Stock",
  "NCSM": "NCS Multistage Holdings, Inc.",
  "NCT": "Intercont (Cayman) Limited Class A",
  "NCTY": "The9 Limited ADR",
  "NCV": "Virtus Convertible & Income Fund",
  "NCV-P-A": "Virtus Convertible & Income Fund Series A Preferred Shares",
  "NCZ": "Virtus Convertible & Income Fund II",
  "NCZ-P-A": "Virtus Convertible & Income Fund II Series A Preferred Shares",
  "NDAQ": "Nasdaq, Inc. Common Stock",
  "NDLS": "Noodles & Company Class A",
  "NDMO": "Nuveen Dynamic Municipal Opportunities Fund",
  "NDRA": "ENDRA Life Sciences Inc. Common Stock",
  "NDSN": "Nordson Corp",
  "NE": "Noble Corporation plc",
  "NEA": "Nuveen AMT-Free Quality Municipal Income Fund",
  "NECB": "Northeast Community Bancorp, Inc.",
  "NEE": "NextEra Energy, Inc.",
  "NEGG": "Newegg Commerce, Inc. Common Shares",
  "NEM": "Newmont Corporation",
  "NEN": "New England Realty Associates Limited Partnership",
  "NEO": "NeoGenomics, Inc.",
  "NEOG": "Neogen Corp",
  "NEON": "Neonode Inc. Common Stock",
  "NEOV": "NeoVolta Inc. Common Stock",
  "NEPH": "Nephros Inc.",
  "NERV": "Minerva Neurosciences, Inc",
  "NESR": "National Energy Services Reunited Corp.",
  "NET": "Cloudflare, Inc. Class A common stock, par value $0.001 per share",
  "NEU": "NewMarket Corporation",
  "NEUP": "Neuphoria Therapeutics Inc. Common Stock",
  "NEWP": "New Pacific Metals Corp.",
  "NEWT": "NewtekOne, Inc. Common Stock",
  "NEWTP": "NewtekOne, Inc. Depositary Shares Series B Preferred Stock",
  "NEXA": "Nexa Resources S.A. Common Shares",
  "NEXM": "NexMetals Mining Corp. Common Shares",
  "NEXN": "Nexxen International Ltd.",
  "NEXR": "Nexera Technologies Ltd",
  "NEXT": "NextDecade Corporation Common Stock",
  "NFE": "New Fortress Energy Inc. Class A Common Stock",
  "NFG": "National Fuel Gas Co.",
  "NFGC": "New Found Gold Corp",
  "NFJ": "Virtus Dividend, Interest & Premium Strategy Fund",
  "NFLX": "NetFlix Inc",
  "NG": "NovaGold Resources Inc.",
  "NGEN": "NervGen Pharma Corp. Common stock",
  "NGG": "National Grid PLC",
  "NGL": "NGL ENERGY PARTNERS LP",
  "NGNE": "Neurogene, Inc. Common Stock",
  "NGS": "Natural Gas Services Group, Inc.",
  "NGVC": "NATURAL GROCERS BY VITAMIN COTTAGE, INC",
  "NGVT": "Ingevity Corporation",
  "NHC": "National Healthcare Corp.",
  "NHI": "National Health Investors",
  "NHIC": "NewHold Investment Corp III Class A",
  "NHIV": "NewHold Investment Corp IV Class A",
  "NHP": "National Healthcare Properties, Inc. Class A Common Stock",
  "NHPAP": "National Healthcare Properties, Inc Series A Preferred Stock",
  "NHPBP": "National Healthcare Properties, Inc Series B Preferred Stock",
  "NHS": "Neuberger High Yield Strategies Fund Inc.",
  "NHTC": "Natural Health Trends Corp.",
  "NI": "NiSource Inc.",
  "NIC": "Nicolet Bankshares,Inc.",
  "NICE": "NICE Ltd",
  "NICM": "Nicola Mining Inc. ADR",
  "NIE": "Virtus Equity & Convertible Income Fund",
  "NIKI": "Niki BioSolutions, Inc. Common Stock",
  "NIM": "Nuveen Select Maturities Municipal Fund",
  "NINE": "Nine Energy Service, Inc.",
  "NIO": "NIO Inc. American depositary shares, each representing one Class A ordinary share",
  "NIPG": "NIP Group Inc. ADR",
  "NIQ": "NIQ Global Intelligence plc",
  "NIU": "Niu Technologies ADR",
  "NIVF": "NewGenIvf Group Limited Class A ordinary shares",
  "NIXX": "Nixxy, Inc. Common Stock",
  "NJR": "New Jersey Resources Corp",
  "NKE": "Nike, Inc.",
  "NKLR": "Terra Innovatum Global N.V.",
  "NKSH": "National Bankshares Inc/VA",
  "NKTR": "Nektar Therapeutics",
  "NKTX": "Nkarta, Inc. Common Stock",
  "NKX": "Nuveen California AMT-Free Quality Municipal Income Fund",
  "NL": "NLI Holdings, Inc.",
  "NLOP": "Net Lease Office Properties",
  "NLY": "Annaly Capital Management. Inc.",
  "NLY-P-F": "Annaly Capital Management, Inc Series F Preferred Stock",
  "NLY-P-G": "Annaly Capital Management, Inc Series G Preferred Stock",
  "NLY-P-I": "Annaly Capital Management, Inc Series I Preferred Stock",
  "NLY-P-J": "Annaly Capital Management, Inc Series J Preferred Stock",
  "NMAD": "Nomad Power Solutions, Inc. Common Stock",
  "NMAI": "Nuveen Multi-Asset Income Fund",
  "NMAX": "Newsmax, Inc.",
  "NMCO": "Nuveen Municipal Credit Opportunities Fund",
  "NMFC": "NEW MOUNTAIN FINANCE CORPORATION",
  "NMG": "Nouveau Monde Graphite Inc.",
  "NMI": "Nuveen Municipal Income",
  "NMIH": "NMI Holdings Inc. Common Stock",
  "NML": "Neuberger Energy Infrastructure and Income Fund Inc.",
  "NMM": "Navios Maritime Partners L.P.",
  "NMP": "NMP Acquisition Corp. Class A",
  "NMR": "Nomura Holdings, Inc",
  "NMRA": "Neumora Therapeutics, Inc. Common Stock",
  "NMRK": "Newmark Group, Inc. Class A Common Stock",
  "NMS": "Nuveen Minnesota Quality Municipal Income Fund",
  "NMT": "Nuveen Massachusetts Quality Municipal Income Fund",
  "NMTC": "NeuroOne Medical Technologies Corporation Common Stock",
  "NMZ": "Nuveen Municipal High Income Opportunity Fund",
  "NN": "NextNav Inc. Common Stock",
  "NNBR": "NN Inc",
  "NNDM": "Nano Dimension Ltd. ADR",
  "NNE": "Nano Nuclear Energy Inc. Common Stock",
  "NNI": "Nelnet, Inc. Class A",
  "NNN": "NNN REIT, Inc.",
  "NNNN": "Anbio Biotechnology Class A",
  "NNOX": "NANO-X IMAGING LTD",
  "NNVC": "NanoViricides Inc.",
  "NNY": "Nuveen New York Municipal Value Fund",
  "NOA": "North American Construction Group Ltd.",
  "NOAH": "Noah Holdings Limited ADR",
  "NOC": "Northrop Grumman Corp.",
  "NODK": "NI Holdings, Inc.",
  "NOEM": "CO2 Energy Transition Corp. Common Stock",
  "NOG": "Northern Oil and Gas, Inc.",
  "NOK": "Nokia Corporation",
  "NOMA": "NOMADAR Corp. Class A Common Stock",
  "NOMD": "Nomad Foods Limited",
  "NOV": "NOV Inc.",
  "NOVT": "Novanta Inc. Common Stock",
  "NOW": "SERVICENOW, INC.",
  "NP": "Neptune Insurance Holdings Inc.",
  "NPAC": "New Providence Acquisition Corp. III Class A",
  "NPB": "Northpointe Bancshares, Inc.",
  "NPCE": "Neuropace, Inc. Common Stock",
  "NPCT": "Nuveen Core Plus Impact Fund",
  "NPFD": "Nuveen Variable Rate Preferred & Income Fund",
  "NPK": "National Presto Industries, Inc.",
  "NPKI": "NPK International Inc.",
  "NPO": "Enpro Inc.",
  "NPT": "Texxon Holding Limited",
  "NPV": "Nuveen Virginia Quality Municipal Income Fund",
  "NPWR": "NET Power Inc.",
  "NRC": "NRC Health Common Stock",
  "NRDS": "NerdWallet, Inc. Class A Common Stock",
  "NRDY": "Nerdy Inc.",
  "NREF": "NexPoint Real Estate Finance, Inc.",
  "NREF-P-A": "NexPoint Real Estate Finance, Inc Series A Preferred Stock",
  "NRG": "NRG Energy, Inc.",
  "NRGV": "Energy Vault Holdings, Inc.",
  "NRIM": "Northrim BanCorp Inc",
  "NRIX": "Nurix Therapeutics, Inc. Common stock",
  "NRK": "Nuveen New York AMT-Free Quality Municipal Income Fund",
  "NRO": "Neuberger Real Estate Securities Income Fund Inc.",
  "NRP": "Natural Resource Partners L.P.",
  "NRSN": "NeuroSense Therapeutics Ltd.",
  "NRT": "North European Oil Royalty Trust",
  "NRXP": "NRX Pharmaceuticals, Inc. Common Stock",
  "NRXS": "Neuraxis, Inc.",
  "NSC": "Norfolk Southern Corp.",
  "NSIT": "Insight Enterprises Inc",
  "NSLR": "Neostellar Capital Corp. Common Stock",
  "NSP": "Insperity, Inc",
  "NSPR": "InspireMD, Inc.",
  "NSRX": "Nasus Pharma Ltd.",
  "NSSC": "Napco Security Technologies, Inc",
  "NSTS": "NSTS Bancorp, Inc. Common Stock",
  "NSYS": "Nortech Systems Inc",
  "NTAP": "NetApp, Inc",
  "NTB": "The Bank of N.T. Butterfield & Son Limited",
  "NTCL": "NETCLASS TECHNOLOGY INC Class A",
  "NTCT": "Netscout Systems Inc",
  "NTES": "NetEase, inc.",
  "NTGR": "NETGEAR, Inc.",
  "NTHI": "NeOnc Technologies Holdings, Inc. Common Stock",
  "NTIC": "Northern Technologies International Corp.",
  "NTIP": "Network-1 Technologies, Inc.",
  "NTLA": "Intellia Therapeutics, Inc",
  "NTNX": "Nutanix, Inc. Class A Common Stock",
  "NTR": "Nutrien Ltd. Common Shares",
  "NTRA": "Natera, Inc. Common Stock",
  "NTRB": "Nutriband Inc. Common Stock",
  "NTRP": "NextTrip, Inc. Common Stock",
  "NTRS": "Northern Trust Corp",
  "NTRSO": "Northern Trust Corporation Series E Preferred Stock",
  "NTSK": "Netskope, Inc. Class A Common Stock",
  "NTST": "NetSTREIT Corp.",
  "NTWK": "NetSol Technologies, Inc.",
  "NTWO": "Newbury Street II Acquisition Corp Class A",
  "NTZ": "Natuzzi, S.p.A",
  "NU": "Nu Holdings Ltd.",
  "NUAI": "New Era Energy & Digital, Inc. Common Stock",
  "NUCL": "Eagle Nuclear Energy Corp. Common stock",
  "NUE": "Nucor Corporation",
  "NUS": "NuSkin Enterprises, Inc.",
  "NUTR": "Nusatrip Incorporated Common Stock",
  "NUTX": "Nutex Health Inc. Common Stock",
  "NUV": "Nuveen Municipal Value Fund, Inc.",
  "NUVB": "Nuvation Bio Inc.",
  "NUW": "Nuveen AMT-Free Municipal Value Fund",
  "NUWE": "Nuwellis, Inc. Common Stock",
  "NVA": "Nova Minerals Corp",
  "NVAX": "Novavax Inc",
  "NVCR": "NovoCure Limited",
  "NVCT": "Nuvectis Pharma, Inc. Common Stock",
  "NVDA": "Nvidia Corp",
  "NVEC": "NVE Corp",
  "NVG": "Nuveen AMT-Free Municipal Credit Income Fund",
  "NVGS": "NAVIGATOR HOLDINGS LTD.",
  "NVMI": "Nova Ltd.",
  "NVNI": "Nvni Group Limited",
  "NVNO": "enVVeno Medical Corporation Common Stock",
  "NVO": "Novo-Nordisk A/S",
  "NVR": "NVR, Inc.",
  "NVRI": "Enviri Corporation",
  "NVS": "Novartis AG",
  "NVST": "Envista Holdings Corporation Common stock, $0.01 par value per share",
  "NVT": "nVent Electric plc",
  "NVTS": "Navitas Semiconductor Corporation Common Stock",
  "NVX": "NOVONIX Limited ADR",
  "NWAX": "New America Acquisition I Corp.",
  "NWBI": "Northwest Bancshares, Inc",
  "NWE": "NorthWestern Energy Group, Inc. Common Stock",
  "NWFL": "Norwood Financial Corp",
  "NWG": "NatWest Group plc ADR",
  "NWGL": "CL Workshop Group Limited ADR",
  "NWL": "Newell Brands Inc.",
  "NWN": "Northwest Natural Holding Company",
  "NWPX": "NWPX Infrastructure, Inc. Common Stock",
  "NWS": "News Corporation Class B Common Stock",
  "NWSA": "News Corporation Class A Common Stock",
  "NWTG": "Newton Golf Company, Inc. Common Stock",
  "NX": "Quanex Building Products Corporation",
  "NXB": "NextBoat Inc.",
  "NXDR": "Nextdoor Holdings, Inc.",
  "NXDT": "NexPoint Diversified Real Estate Trust",
  "NXDT-P-A": "NexPoint Diversified Real Estate Trust Series A Preferred Shares",
  "NXE": "NexGen Energy Ltd.",
  "NXG": "NXG NextGen Infrastructure Income Fund",
  "NXGL": "NexGel, Inc Common Stock",
  "NXL": "Nexalin Technology, Inc. Common Stock",
  "NXP": "NUVEEN SELECT TAX-FREE INC",
  "NXPI": "NXP Semiconductors N.V.",
  "NXPL": "NextPlat Corp Common Stock",
  "NXRT": "NexPoint Residential Trust Inc",
  "NXST": "Nexstar Media Group, Inc. Common Stock",
  "NXT": "Nextpower Inc. Class A Common Stock",
  "NXTC": "NextCure, Inc. Common Stock",
  "NXTS": "Nexentis Technologies Inc. Common Stock",
  "NXTT": "Next Technology Holding Inc.",
  "NXXT": "NextNRG, Inc. Common Stock",
  "NYAX": "Nayax Ltd.",
  "NYC": "American Strategic Investment Co.",
  "NYT": "New York Times Co.",
  "NYXH": "Nyxoah SA",
  "NZF": "Nuveen Municipal Credit Income Fund",
  "O": "Realty Income Corporation",
  "OABI": "OmniAb, Inc. Common Stock",
  "OACC": "Oaktree Acquisition Corp. III Life Sciences Class A Ordinary Share",
  "OBA": "Oxley Bridge Acquisition Limited Class A",
  "OBAI": "Our Bond, Inc. Common Stock",
  "OBDC": "Blue Owl Capital Corporation",
  "OBE": "Obsidian Energy Ltd.",
  "OBIO": "Orchestra BioMed Holdings, Inc.",
  "OBK": "Origin Bancorp, Inc.",
  "OBT": "Orange County Bancorp, Inc. Common Stock",
  "OBX": "Obsidian Therapeutics, Inc. Common Stock",
  "OC": "Owens Corning",
  "OCAC": "Ocean Capital Acquisition Corporation",
  "OCC": "Optical Cable Corp.",
  "OCCI": "OFS Credit Company, Inc. Common Stock",
  "OCCIM": "OFS Credit Company, Inc Series F Preferred Stock",
  "OCCIN": "OFS Credit Company, Inc Series E Preferred Stock",
  "OCFC": "OceanFirst Financial Corp",
  "OCG": "Oriental Culture Holding LTD",
  "OCGN": "Ocugen, Inc. Common Stock",
  "OCS": "Oculis Holding AG",
  "OCSL": "Oaktree Specialty Lending Corporation",
  "OCTV": "Octave Intelligence plc Class B",
  "OCUL": "Ocular Therapeutix, Inc.",
  "ODC": "Oil-Dri Corporation of America",
  "ODD": "ODDITY Tech Ltd. Class A",
  "ODFL": "Old Dominion Freight Line",
  "ODTX": "Odyssey Therapeutics, Inc. Common Stock",
  "ODYS": "Odysight.ai Inc. Common Stock",
  "OEC": "Orion S.A.",
  "OESX": "Orion Energy Systems, Inc.",
  "OFAL": "OFA Group Class A",
  "OFG": "OFG BANCORP",
  "OFIX": "Orthofix Medical Inc. Common Stock (DE)",
  "OFLX": "Omega Flex, Inc.",
  "OFRM": "Once Upon a Farm, PBC",
  "OFS": "OFS Capital Corporation",
  "OGC": "OceanaGold Corporation",
  "OGCP": "Empire State Realty OP, L.P. Series 60",
  "OGE": "OGE Energy Corp.",
  "OGEN": "Oragenics Inc.",
  "OGG": "Osisko Gold Group Inc.",
  "OGI": "Organigram Global Inc. Common Shares",
  "OGN": "Organon & Co.",
  "OGS": "ONE GAS, INC.",
  "OHAC": "Oceanhawk Acquisition Corp. Class A",
  "OHI": "Omega Healthcare Investors Inc.",
  "OI": "O-I Glass, Inc.",
  "OIA": "INVESCO MUNICIPAL INCOME OPPORTUNITIES TRUST",
  "OII": "Oceaneering International Inc.",
  "OIM": "OneIM Acquisition Corp. Class A",
  "OIO": "OIO Group",
  "OIS": "OIL STATES INTERNATIONAL, INC.",
  "OKE": "Oneok, Inc.",
  "OKLO": "Oklo Inc.",
  "OKTA": "Okta, Inc. Class A Common Stock",
  "OKUR": "OnKure Therapeutics, Inc. Class A Common Stock",
  "OKYO": "OKYO Pharma Limited",
  "OLB": "The OLB Group, Inc. Common Stock",
  "OLED": "Universal Display Corp",
  "OLLI": "Ollie's Bargain Outlet Holdings, Inc. Common Stock",
  "OLMA": "Olema Pharmaceuticals, Inc. Common Stock",
  "OLN": "Olin Corp.",
  "OLOX": "Olenox Industries Inc. Common Stock",
  "OLP": "One Liberty Properties, Inc.",
  "OM": "Outset Medical, Inc. Common Stock",
  "OMAB": "Grupo Aeroportuario del Centro Norte S.A.B. de C.V",
  "OMC": "Omnicom Group Inc.",
  "OMCL": "Omnicell Inc",
  "OMDA": "Omada Health, Inc. Common Stock",
  "OMER": "Omeros Corporation",
  "OMEX": "Odyssey Marine Exploration, Inc",
  "OMF": "OneMain Holdings, Inc.",
  "OMH": "Ohmyhome Limited Class A",
  "OMSE": "OMS Energy Technologies Inc.",
  "ON": "ON Semiconductor Corp",
  "ONB": "Old National Bancorp",
  "ONBPO": "Old National Bancorp Series C Preferred Stock",
  "ONBPP": "Old National Bancorp Series A Preferred Stock",
  "ONC": "BeOne Medicines Ltd. ADR",
  "ONCH": "1RT Acquisition Corp. Class A Ordinary Share",
  "ONCO": "Onconetix, Inc. Common Stock",
  "ONCY": "Oncolytics Biotech, Inc. Common Shares",
  "ONDS": "Ondas Inc. Common Stock",
  "ONEG": "OneConstruction Group Limited",
  "ONEW": "OneWater Marine Inc. Class A Common Stock",
  "ONFO": "Onfolio Holdings Inc. Common Stock",
  "ONIT": "Onity Group Inc.",
  "ONL": "Orion Properties Inc.",
  "ONMD": "OneMedNet Corp Class A Common Stock",
  "ONON": "On Holding AG",
  "ONT": "Onterris, Inc.",
  "ONTO": "Onto Innovation Inc.",
  "OOMA": "Ooma, Inc. Common Stock",
  "OPAD": "Offerpad Solutions Inc.",
  "OPAL": "OPAL Fuels Inc. Class A Common Stock",
  "OPBK": "OP Bancorp Common Stock",
  "OPCH": "Option Care Health, Inc. Common Stock",
  "OPEN": "Opendoor Technologies Inc Common Stock",
  "OPFI": "OppFi Inc.",
  "OPHC": "OptimumBank Holdings, Inc.",
  "OPI": "Office Properties Income Trust",
  "OPK": "Opko Health Inc.",
  "OPLN": "OPENLANE, Inc",
  "OPP": "RiverNorth/DoubleLine Strategic Opportunity Fund, Inc.",
  "OPP-P-A": "RiverNorth/DoubleLine Strategic Opportunity Fund, Inc Series A Preferred Stock",
  "OPP-P-B": "RiverNorth/DoubleLine Strategic Opportunity Fund, Inc Series B Preferred Stock",
  "OPP-P-C": "RiverNorth/DoubleLine Strategic Opportunity Fund, Inc Series C Preferred Stock",
  "OPRA": "Opera Limited ADR",
  "OPRT": "Oportun Financial Corporation Common Stock",
  "OPRX": "OptimizeRx Corporation Common Stock",
  "OPTH": "Optimi Health Corp. Common Shares",
  "OPTT": "Ocean Power Technologies, Inc.",
  "OPTU": "Optimum Communications, Inc.",
  "OPTX": "Syntec Optics Holdings, Inc. Class A Common Stock",
  "OPXS": "Optex Systems Holdings, INC",
  "OPY": "Oppenheimer Holdings, Inc.",
  "OR": "OR Royalties Inc.",
  "ORA": "Ormat Technologies, Inc.",
  "ORBS": "Eightco Holdings Inc. Common Stock",
  "ORC": "Orchid Island Capital, Inc.",
  "ORCL": "Oracle Corp",
  "ORCL-P-D": "Oracle Corporation Series D Preferred Stock",
  "ORGO": "Organogenesis Holdings Inc. Class A Common Stock",
  "ORI": "Old Republic International Corporation",
  "ORIC": "Oric Pharmaceuticals, Inc. Common Stock",
  "ORIO": "Orion Digital Corp. Common Shares",
  "ORIQ": "Origin Investment Corp I",
  "ORKA": "Oruka Therapeutics, Inc. Common Stock",
  "ORKT": "Orangekloud Technology Inc. Class A",
  "ORLY": "O'Reilly Automotive, Inc.",
  "ORMP": "Oramed Pharmaceuticals Inc.",
  "ORN": "Orion Group Holdings, Inc",
  "ORRF": "Orrstown Financial Services Inc",
  "OSBC": "Old Second Bancorp Inc",
  "OSCR": "Oscar Health, Inc.",
  "OSG": "Octave Specialty Group, Inc.",
  "OSIS": "OSI Systems Inc",
  "OSK": "Oshkosh Corp.",
  "OSPN": "OneSpan Inc. Common Stock",
  "OSRH": "OSR Health, Inc. Common Stock",
  "OSS": "One Stop Systems, Inc. Common Stock",
  "OST": "Ostin Technology Group Co., Ltd. Class A",
  "OSTX": "OS Therapies Incorporated",
  "OSUR": "OraSure Technologies Inc",
  "OSW": "OneSpaWorld Holdings Limited Common Shares",
  "OTAI": "Starlink AI Acquisition Corporation",
  "OTEX": "Open Text Corp",
  "OTF": "Blue Owl Technology Finance Corp.",
  "OTGA": "OTG Acquisition Corp. I Class A Ordinary Share",
  "OTIS": "Otis Worldwide Corporation",
  "OTLK": "Outlook Therapeutics, Inc. Common Stock",
  "OTLY": "Oatly Group AB ADR",
  "OTTR": "Otter Tail Corp",
  "OUST": "Ouster, Inc.",
  "OUT": "OUTFRONT Media Inc.",
  "OVBC": "Ohio Valley Banc Corp",
  "OVID": "Ovid Therapeutics Inc. Common Stock",
  "OVLY": "Oak Valley Bancorp",
  "OVV": "Ovintiv Inc.",
  "OWL": "Blue Owl Capital Inc.",
  "OWLS": "OBOOK Holdings Inc. Class A Common Shares",
  "OWLT": "Owlet, Inc.",
  "OXBR": "Oxbridge Re Holdings Limited",
  "OXLC": "Oxford Lane Capital Corp.",
  "OXLCM": "Oxford Lane Capital Corp. Preferred Stock Shares, 8.25% Series 2031",
  "OXLCN": "Oxford Lane Capital Corp Preferred Stock",
  "OXLCO": "Oxford Lane Capital Corp. Preferred Stock Shares, 6.00% Series 2029",
  "OXM": "Oxford Industries, Inc.",
  "OXSQ": "Oxford Square Capital Corp.",
  "OXY": "Occidental Petroleum Corporation",
  "OYSE": "Oyster Enterprises II Acquisition Corp Class A",
  "OZK": "Bank OZK",
  "OZKAP": "Bank OZK Series A Preferred Stock",
  "P": "Everpure, Inc.",
  "PAA": "Plains All American Pipeline, L.P. Common Units representing Limited Partner Interests",
  "PAAC": "Proem Acquisition Corp I",
  "PAAS": "Pan American Silver Corp.",
  "PAC": "Grupo Aeroportuario del Pacifico, S.A.B. de C.V. ADR",
  "PACB": "Pacific Biosciences of California, Inc.",
  "PACH": "Pioneer Acquisition I Corp Class A",
  "PACK": "Ranpak Holdings Corp.",
  "PACS": "PACS Group, Inc.",
  "PAG": "Penske Automotive Group, Inc.",
  "PAGP": "Plains GP Holdings, L.P. Class A Units representing Limited Partner Interests",
  "PAGS": "PagSeguro Digital Ltd.",
  "PAHC": "Phibro Animal Health Corporation Class A",
  "PAI": "Western Asset Investment Grade Income Fund Inc.",
  "PAII": "Pyrophyte Acquisition Corp. II",
  "PAL": "Proficient Auto Logistics, Inc. Common Stock",
  "PALI": "Palisade Bio, Inc. Common Stock",
  "PALO": "Paloma Acquisition Corp I Class A",
  "PAM": "PAMPA ENERGIA S.A.",
  "PAMT": "PAMT CORP Common Stock",
  "PANL": "Pangaea Logistics Solutions Ltd.",
  "PANW": "Palo Alto Networks, Inc. Common Stock",
  "PAPL": "Pineapple Financial Inc.",
  "PAR": "PAR Technology Corp.",
  "PARA": "Banzai International, Inc. Class A Common Stock",
  "PARK": "Park Dental Partners, Inc. Common Stock",
  "PARR": "Par Pacific Holdings, Inc. Common Stock",
  "PASG": "Passage Bio, Inc. Common Stock",
  "PASW": "Ping An Biomedical Co., Ltd. Class A",
  "PATH": "UiPath, Inc.",
  "PATK": "Patrick Industries Inc",
  "PAVM": "PAVmed Inc. Common Stock",
  "PAVS": "Paranovus Entertainment Technology Ltd. Class A",
  "PAX": "Patria Investments Limited Class A Common Shares",
  "PAXS": "PIMCO Access Income Fund",
  "PAY": "Paymentus Holdings, Inc.",
  "PAYC": "PAYCOM SOFTWARE, INC.",
  "PAYO": "Payoneer Global Inc. Common Stock",
  "PAYP": "PayPay Corporation ADR",
  "PAYS": "Paysign, Inc. Common Stock",
  "PAYX": "Paychex Inc",
  "PB": "Prosperity Bancshares Inc",
  "PBA": "PEMBINA PIPELINE CORPORATION",
  "PBAM": "Private Bancorp of America, Inc. Common Stock",
  "PBF": "PBF ENERGY INC.",
  "PBFS": "Pioneer Bancorp, Inc. Common Stock",
  "PBH": "Prestige Consumer Healthcare Inc.",
  "PBHC": "Pathfinder Bancorp Inc",
  "PBI": "Pitney Bowes Inc.",
  "PBK": "PowerBank Corporation Common Stock",
  "PBLS": "Parabilis Medicines, Inc. Common Stock",
  "PBM": "Psyence Biomedical Ltd. Common Shares",
  "PBR": "PETROLEO BRASILEIRO S.A.-PETROBRAS ADS (REP 1 COMMON SHARE)",
  "PBR-A": "Petroleo Brasileiro S.A.-Petrobras",
  "PBT": "Permian Basin Royalty Trust",
  "PBYI": "PUMA BIOTECHNOLOGY INC",
  "PC": "Premium Catering (Holdings) Limited",
  "PCAP": "ProCap Acquisition Corp Class A",
  "PCAR": "Paccar Inc",
  "PCB": "PCB Bancorp Common Stock",
  "PCF": "High Income Securities Fund",
  "PCG": "PG&E Corporation",
  "PCG-P-A": "Pacific Gas and Electric Company 6% 1st Pfd.",
  "PCG-P-B": "Pacific Gas and Electric Company 5 1/2% 1st Pfd.",
  "PCG-P-C": "Pacific Gas and Electric Company 5% 1st Pfd.",
  "PCG-P-D": "Pacific Gas and Electric Company 5% Red. 1st Pfd.",
  "PCG-P-E": "Pacific Gas and Electric Company 5% Red. 1st Pfd.A",
  "PCG-P-G": "Pacific Gas and Electric Company 4.80% Red. 1st Pfd.",
  "PCG-P-H": "Pacific Gas and Electric Company 4.50% Red. 1st Pfd.",
  "PCG-P-I": "Pacific Gas & Electric Company 4.36% Red 1st Pfd",
  "PCG-P-X": "PG&E Corporation Series A Preferred Stock",
  "PCLA": "PicoCELA Inc. ADR",
  "PCM": "PCM Fund, Inc.",
  "PCN": "PIMCO Corporate & Income Strategy Fund",
  "PCOR": "Procore Technologies, Inc.",
  "PCQ": "Pimco California Municipal Income Fund",
  "PCRX": "Pacira BioSciences, Inc. Common Stock",
  "PCSA": "Processa Pharmaceuticals, Inc. Common",
  "PCT": "PureCycle Technologies, Inc. Common stock",
  "PCTY": "Paylocity Holding Corporation Common Stock",
  "PCVX": "Vaxcyte, Inc. Common Stock",
  "PCYO": "Pure Cycle Corporation",
  "PD": "PagerDuty, Inc.",
  "PDC": "Perpetuals.com Ltd ADR",
  "PDCC": "Pearl Diver Credit Company Inc.",
  "PDD": "PDD Holdings Inc. ADR",
  "PDEX": "Pro-Dex Inc New",
  "PDFS": "PDF Solutions Inc",
  "PDI": "PIMCO Dynamic Income Fund",
  "PDLB": "Ponce Financial Group, Inc. Common Stock",
  "PDM": "Piedmont Realty Trust, Inc.",
  "PDO": "PIMCO Dynamic Income Opportunities Fund",
  "PDPA": "Pearl Diver Credit Company Inc Series A Preferred Stock",
  "PDS": "Precision Drilling Corporation",
  "PDSB": "PDS Biotechnology Corporation Common Stock",
  "PDT": "John Hancock Premium Dividend Fund",
  "PDX": "PIMCO Dynamic Income Strategy Fund",
  "PDYN": "Palladyne AI Corp. Common Stock",
  "PEB": "Pebblebrook Hotel Trust",
  "PEB-P-E": "Pebblebrook Hotel Trust Series E Preferred Shares",
  "PEB-P-F": "Pebblebrook Hotel Trust Series F Preferred Shares",
  "PEB-P-G": "Pebblebrook Hotel Trust Series G Preferred Shares",
  "PEB-P-H": "Pebblebrook Hotel Trust Series H Preferred Shares",
  "PEBK": "Peoples Bancorp of North Carol",
  "PEBO": "Peoples Bancorp Inc/OH",
  "PECE": "Peace Acquisition Corp",
  "PECO": "Phillips Edison & Company, Inc. Common Stock",
  "PED": "PEDEVCO Corp.",
  "PEG": "Public Service Enterprise Group Incorporated",
  "PEGA": "Pegasystems Inc",
  "PEN": "Penumbra, Inc.",
  "PENG": "Penguin Solutions, Inc.",
  "PENN": "PENN Entertainment, Inc. Common Stock",
  "PEO": "Adams Natural Resources Fund, Inc.",
  "PEP": "PepsiCo, Inc.",
  "PEPG": "PepGen Inc. Common Stock",
  "PERF": "Perfect Corp.",
  "PERI": "Perion Network Ltd.",
  "PESI": "Perma-Fix Environmental Services, Inc.",
  "PETS": "PetMed Express, Inc.",
  "PETZ": "TDH Holdings, Inc. Common Shares",
  "PEW": "GrabAGun Digital Holdings Inc.",
  "PFAI": "Pinnacle Food Group Limited Class A Common Shares",
  "PFBC": "Preferred Bank",
  "PFD": "Flaherty & Crumrine Preferred and Income Fund Incorporated",
  "PFE": "Pfizer Inc.",
  "PFG": "Principal Financial Group, Inc.",
  "PFGC": "Performance Food Group Company",
  "PFIS": "Peoples Financial Services Corp.",
  "PFL": "PIMCO Income Strategy  Fund",
  "PFLT": "PennantPark Floating Rate Capital Ltd.",
  "PFN": "PIMCO Income Strategy Fund II",
  "PFO": "Flaherty & Crumrine Preferred and Income Opportunity Fund Incorporated",
  "PFS": "Provident Financial Services, Inc.",
  "PFSA": "Profusa, Inc. Common Stock",
  "PFSI": "PennyMac Financial Services, Inc. Common Stock",
  "PFX": "PhenixFIN Corporation Common Stock",
  "PG": "Procter & Gamble Company",
  "PGAC": "Pantages Capital Acquisition Corporation Class A",
  "PGC": "Peapack-Gladstone Financial Corp",
  "PGEN": "Precigen, Inc. Common Stock",
  "PGNY": "Progyny, Inc. Common Stock",
  "PGP": "PIMCO Global StockPLUS & Income Fund",
  "PGR": "Progressive Corporation",
  "PGY": "Pagaya Technologies Ltd. Class A",
  "PGZ": "PRINCIPAL REAL ESTATE INCOME FUND",
  "PH": "Parker-Hannifin Corporation",
  "PHAR": "Pharming Group N.V. ADS, each representing 10 ordinary shares",
  "PHAT": "Phathom Pharmaceuticals, Inc. Common Stock",
  "PHG": "KONINKLIJKE PHILIPS  N.V.",
  "PHGE": "BiomX Inc.",
  "PHI": "PLDT Inc.",
  "PHIN": "PHINIA Inc.",
  "PHIO": "Phio Pharmaceuticals Corp. Common Stock",
  "PHK": "PIMCO High Income Fund",
  "PHM": "Pultegroup, Inc.",
  "PHOE": "Phoenix Asia Holdings Limited",
  "PHR": "Phreesia, Inc.",
  "PHUN": "Phunware, Inc. Common Stock",
  "PHVS": "Pharvaris N.V.",
  "PHXE-P": "Phoenix Energy One, LLC Series A Series A Preferred Shares",
  "PI": "Impinj, Inc. Common Stock",
  "PICS": "PicS N.V. Class A Common Shares",
  "PII": "Polaris Inc.",
  "PIII": "P3 Health Partners Inc. Common Stock",
  "PIM": "Franklin Master Intermediate Income Trust",
  "PINE": "Alpine Income Property Trust, Inc",
  "PINE-P-A": "Alpine Income Property Trust, Inc Series A Preferred Stock",
  "PINS": "Pinterest, Inc. Class A Common Stock",
  "PIPR": "Piper Sandler Companies",
  "PJT": "PJT Partners Inc.",
  "PK": "Park Hotels & Resorts Inc. Common Stock",
  "PKBK": "Parke Bancorp Inc.",
  "PKE": "Park Aerospace Corp. Common Stock",
  "PKG": "Packaging Corp of America",
  "PKOH": "Park-Ohio Holdings Corp",
  "PKX": "POSCO Holdings Inc. ADR",
  "PL": "Planet Labs PBC",
  "PLAB": "Photronics Inc",
  "PLAG": "Planet Green Holdings Corp.",
  "PLAY": "Dave & Buster's Entertainment, Inc.",
  "PLBC": "Plumas Bancorp",
  "PLBL": "Polibeli Group Ltd Class A",
  "PLBY": "Playboy, Inc. Common Stock",
  "PLCE": "Children's Place, Inc.",
  "PLD": "PROLOGIS, INC.",
  "PLG": "Platinum Group Metals LTD.",
  "PLGO": "Pelagos Insurance Capital Limited",
  "PLMK": "Plum Acquisition Corp. IV Class A",
  "PLMR": "Palomar Holdings, Inc. Common stock",
  "PLNT": "Planet Fitness, Inc.",
  "PLOW": "DOUGLAS DYNAMICS, INC.",
  "PLPC": "Preformed Line Products Co",
  "PLRX": "Pliant Therapeutics, Inc. Common Stock",
  "PLRZ": "Polyrizon Ltd.",
  "PLSE": "Pulse Biosciences, Inc Common Stock (DE)",
  "PLSM": "Pulsenmore Ltd.",
  "PLTK": "Playtika Holding Corp. Common Stock",
  "PLTR": "Palantir Technologies Inc. Class A Common Stock",
  "PLTS": "Platinum Analytics Cayman Limited Class A",
  "PLUG": "Plug Power Inc.",
  "PLUN": "Plutonian Acquisition Corp II",
  "PLUR": "Pluri Inc. Common Stock",
  "PLUS": "ePlus Inc",
  "PLUT": "Plutus Financial Group Limited",
  "PLX": "Protalix BioTherapeutics, Inc. Common Stock",
  "PLXS": "Plexus Corp",
  "PLYX": "Polaryx Therapeutics, Inc. Common Stock",
  "PM": "Philip Morris International Inc.",
  "PMA": "Ming Shing Group Holdings Limited",
  "PMAX": "Powell Max Limited Class A",
  "PMCB": "PharmaCyte Biotech, Inc. Common Stock",
  "PMEC": "Primech Holdings Ltd.",
  "PMI": "Picard Medical, Inc.",
  "PML": "PIMCO MUNICIPAL INCOME FUND II COMMON SHARES OF BENEFICIAL INT.",
  "PMM": "Franklin Managed Municipal Income Trust",
  "PMN": "ProMIS Neurosciences Inc. Common Shares (ON)",
  "PMO": "Franklin Municipal Opportunities Trust",
  "PMT": "PennyMac Mortgage Investment Trust",
  "PMT-P-A": "PennyMac Mortgage Investment Trust Series A Preferred Shares",
  "PMT-P-B": "PennyMac Mortgage Investment Trust Series B Preferred Shares",
  "PMT-P-C": "PennyMac Mortgage Investment Trust Series C Preferred Shares",
  "PMTR": "Perimeter Acquisition Corp. I Class A",
  "PMTS": "CPI Card Group Inc. Common Stock",
  "PMVP": "PMV Pharmaceuticals, Inc",
  "PN": "PN Smart Energy Limited Class A",
  "PNBK": "Patriot National Bancorp Inc",
  "PNC": "PNC Financial Services Group",
  "PNFP": "Pinnacle Financial Partners, Inc.",
  "PNFP-P-A": "Pinnacle Financial Partners, Inc Series A Preferred Stock",
  "PNFP-P-B": "Pinnacle Financial Partners, Inc Series B Preferred Stock",
  "PNFP-P-C": "Pinnacle Financial Partners, Inc Series C Preferred Stock",
  "PNI": "PIMCO NEW YORK MUNICIPAL INCOME FUND II COMMON SHARES OF BENEFICIAL INT.",
  "PNNT": "Pennant Investment Corp",
  "PNR": "Pentair plc",
  "PNRG": "PrimeEnergy Resources Corporation Common Stock",
  "PNTG": "The Pennant Group, Inc. Common Stock",
  "PNW": "Pinnacle West Capital Corporation",
  "POAS": "Phaos Technology Holdings (Cayman) Limited",
  "POCI": "Precision Optics Corporation, Inc. Common Stock",
  "PODC": "PodcastOne, Inc. Common Stock",
  "PODD": "Insulet Corporation",
  "POET": "POET Technologies Inc. Common Shares",
  "POLA": "Polar Power, Inc. Common Stock",
  "POLE": "Andretti Acquisition Corp. II Class A",
  "POM": "POMDOCTOR LIMITED ADR",
  "PONO": "Pono Capital Four, Inc. Class A",
  "PONY": "Pony AI Inc. ADR",
  "POOL": "Pool Corporation",
  "POR": "Portland General Electric Company",
  "POST": "POST HOLDINGS, INC.",
  "POWI": "Power Integrations Inc",
  "POWL": "Powell Industries Inc",
  "POWW": "Outdoor Holding Company Common Stock",
  "POWWP": "Outdoor Holding Company Series A Preferred Stock",
  "PPBT": "Purple Biotech Ltd. ADR",
  "PPC": "Pilgrims Pride Corporation",
  "PPCB": "Propanc Biopharma, Inc. Common Stock",
  "PPG": "PPG Industries, Inc.",
  "PPHC": "Public Policy Holding Company, Inc. Common Stock",
  "PPIH": "Perma-Pipe International Holdings, Inc.",
  "PPL": "PPL Corporation",
  "PPLI": "People Incorporated Common Stock",
  "PPSI": "Pioneer Power Solutions, Inc.",
  "PPT": "Franklin Premier Income Trust",
  "PPTA": "Perpetua Resources Corp. Common Shares",
  "PR": "Permian Resources Corporation",
  "PRAA": "PRA Group, Inc.",
  "PRAX": "Praxis Precision Medicines, Inc. Common Stock",
  "PRCH": "Porch Group, Inc. Common Stock",
  "PRCT": "PROCEPT BioRobotics Corporation Common Stock",
  "PRDO": "Perdoceo Education Corporation",
  "PRE": "Prenetics Global Limited Class A Ordinary Share",
  "PRFX": "PRF Technologies Ltd.",
  "PRG": "PROG Holdings, Inc.",
  "PRGO": "PERRIGO COMPANY PLC",
  "PRGS": "Progress Software Corp (DE)",
  "PRHI": "Presurance Holdings, Inc. Common Stock",
  "PRI": "PRIMERICA, INC.",
  "PRIF-P-D": "Priority Income Fund, Inc Series D Preferred Stock",
  "PRIF-P-K": "Priority Income Fund, Inc Series K Preferred Stock",
  "PRIF-P-L": "Priority Income Fund, Inc Series L Preferred Stock",
  "PRIM": "Primoris Services Corporation",
  "PRK": "Park National Corporation",
  "PRKS": "United Parks & Resorts Inc.",
  "PRLB": "PROTO LABS, INC.",
  "PRLD": "Prelude Therapeutics Incorporated",
  "PRM": "Perimeter Solutions, Inc.",
  "PRMB": "Primo Brands Corporation",
  "PRME": "Prime Medicine, Inc. Common Stock",
  "PROF": "Profound Medical Corp. Common Stock",
  "PROK": "ProKidney Corp. Class A",
  "PROP": "Prairie Operating Co. Common Stock",
  "PROV": "Provident Financial Hldgs",
  "PRPL": "Purple Innovation, Inc. Common Stock",
  "PRPO": "Precipio, Inc. Common Stock",
  "PRQR": "ProQR Therapeutics N.V.",
  "PRSO": "Peraso, Inc. Common Stock",
  "PRSU": "Pursuit Attractions and Hospitality, Inc.",
  "PRT": "PermRock Royalty Trust Trust Unit",
  "PRTA": "Prothena Corporation plc",
  "PRTH": "Priority Technology Holdings, Inc.",
  "PRTS": "CarParts.com, Inc. Common Stock",
  "PRU": "Prudential Financial, Inc.",
  "PRVA": "Privia Health Group, Inc. Common Stock",
  "PRZO": "ParaZero Technologies Ltd.",
  "PS": "Pershing Square Inc.",
  "PSA": "Public Storage",
  "PSA-P-F": "Public Storage Series F Preferred Stock",
  "PSA-P-G": "Public Storage Series G Preferred Stock",
  "PSA-P-H": "Public Storage Series H Preferred Stock",
  "PSA-P-I": "Public Storage Series I Preferred Stock",
  "PSA-P-J": "Public Storage Series J Preferred Stock",
  "PSA-P-K": "Public Storage Series K Preferred Stock",
  "PSA-P-L": "Public Storage Series L Preferred Stock",
  "PSA-P-M": "Public Storage Series M Preferred Stock",
  "PSA-P-N": "Public Storage Series N Preferred Stock",
  "PSA-P-O": "Public Storage Series O Preferred Stock",
  "PSA-P-P": "Public Storage Series P Preferred Stock",
  "PSA-P-Q": "Public Storage Series Q Preferred Stock",
  "PSA-P-R": "Public Storage Series R Preferred Stock",
  "PSA-P-S": "Public Storage Series S Preferred Stock",
  "PSA-P-T": "Public Storage Series T Preferred Shares",
  "PSA-P-U": "Public Storage Series U Preferred Shares",
  "PSBD": "Palmer Square Capital BDC Inc.",
  "PSEC": "Prospect Capital Corporation",
  "PSEC-P-A": "Prospect Capital Corporation Series A Preferred Stock",
  "PSF": "COHEN & STEERS SELECT PREFERRED AND INCOME FUND",
  "PSFE": "Paysafe Limited",
  "PSHG": "Performance Shipping Inc. Common Shares",
  "PSIG": "PS International Group Ltd.",
  "PSIX": "Power Solutions International, Inc. Common Stock",
  "PSKY": "Paramount Skydance Corporation Class B Common Stock",
  "PSMT": "Pricesmart Inc",
  "PSN": "Parsons Corporation",
  "PSNL": "Personalis, Inc. Common Stock",
  "PSNY": "Polestar Automotive Holding UK PLC Class A ADS",
  "PSNYW": "Polestar Automotive Holding UK PLC Class C-1 ADS (ADW)",
  "PSO": "Pearson plc",
  "PSQH": "PSQ Holdings, Inc.",
  "PSTL": "Postal Realty Trust, Inc",
  "PSUS": "Pershing Square USA, Ltd.",
  "PSX": "PHILLIPS 66",
  "PTA": "Cohen & Steers Tax-Advantaged Preferred Securities and Income Fund",
  "PTAC": "Patriot Acquisition Corp. Class A",
  "PTC": "PTC, INC",
  "PTCT": "PTC Therapeutics, Inc.",
  "PTEN": "Patterson-UTI Energy Inc",
  "PTGX": "Protagonist Therapeutics, Inc",
  "PTHS": "Pelthos Therapeutics Inc.",
  "PTLE": "PTL LTD Class A",
  "PTLO": "Portillo's Inc. Class A Common Stock",
  "PTN": "Palatin Technologies, Inc. Common Stock",
  "PTON": "Peloton Interactive, Inc. Class A Common Stock",
  "PTOR": "Praetorian Acquisition Corp. Class A",
  "PTRN": "Pattern Group Inc. Series A Common Stock",
  "PTY": "PIMCO Corporate & Income Opportunity Fund",
  "PUBM": "PubMatic, Inc. Class A Common Stock",
  "PUK": "PRUDENTIAL PLC ADS (REP 2 ORD SHARES)",
  "PULM": "Pulmatrix, Inc. Common Stock",
  "PUMP": "ProPetro Holding Corp.",
  "PURR": "Hyperliquid Strategies Inc Common Stock",
  "PUSA": "Aureus Greenway Holdings Inc. Common Stock",
  "PVH": "PVH Corp.",
  "PVL": "Permianville Royalty Trust",
  "PVLA": "Palvella Therapeutics, Inc. Common Stock",
  "PW": "Power REIT",
  "PW-P-A": "Power REIT Series A Preferred Stock",
  "PWCM": "PowerCompute, Inc. Common Stock",
  "PWP": "Perella Weinberg Partners Class A Common Stock",
  "PWR": "Quanta Services, Inc.",
  "PWRL": "Powerlaw Corp. Common Stock",
  "PXED": "Phoenix Education Partners, Inc.",
  "PXLW": "Pixelworks Inc",
  "PXS": "Pyxis Tankers Inc. Common Stock",
  "PYPD": "PolyPid Ltd.",
  "PYPL": "PayPal Holdings, Inc. Common Stock",
  "PYT": "Merrill Lynch Depositor PPLUS  Floating Rate Call TR Cert. Ser GSC-2(Goldman Sachs)",
  "PYXS": "Pyxis Oncology, Inc. Common Stock",
  "PZG": "Paramount Gold Nevada Corp.",
  "PZZA": "Papa John's International Inc",
  "Q": "Qnity Electronics, Inc.",
  "QADR": "QDRO Acquisition Corp. Class A",
  "QBTS": "D-Wave Quantum Inc. Common Stock",
  "QCLS": "Q/C Technologies, Inc. Common Stock",
  "QCOM": "Qualcomm Inc",
  "QCRH": "QCR Holdings Inc",
  "QDEL": "QuidelOrtho Corporation Common Stock",
  "QETA": "Quetta Acquisition Corporation Common Stock",
  "QFIN": "Qfin Holdings, Inc. ADR",
  "QGEN": "QIAGEN N.V.",
  "QH": "Quhuo Limited Class A",
  "QLEP": "Quantum Leap Acquisition Corp",
  "QLYS": "Qualys, Inc. Common Stock",
  "QMCO": "Quantum Corporation",
  "QMLS": "QumulusAI, Inc. Common Stock",
  "QMMM": "QMMM Holdings Limited Class A",
  "QNC": "Quantum eMotion Corp.",
  "QNCX": "Quince Therapeutics, Inc. Common Stock",
  "QNME": "Quanome Technologies, Inc. Common Stock",
  "QNRX": "Quoin Pharmaceuticals, Ltd. ADR",
  "QNST": "QuinStreet, Inc.",
  "QNT": "Quantinuum Inc. Class A Common Stock",
  "QNTM": "Quantum Biopharma Ltd. Class B Subordinate Voting Shares",
  "QQQX": "Nuveen NASDAQ 100 Dynamic Overwrite Fund - Shares of Beneficial Interest",
  "QRED": "QuasarEdge Acquisition Corporation",
  "QRHC": "Quest Resource Holding Corporation",
  "QRVO": "Qorvo, Inc.",
  "QS": "QuantumScape Corporation Class A Common Stock",
  "QSEA": "Quartzsea Acquisition Corporation",
  "QSI": "Quantum-Si Incorporated Class A Common Stock",
  "QSR": "Restaurant Brands International Inc.",
  "QTEX": "QTREX Quantum Ltd.",
  "QTI": "QT Imaging Holdings, Inc. Common Stock",
  "QTRX": "Quanterix Corporation Common Stock",
  "QTTB": "Q32 Bio Inc. Common Stock",
  "QTWO": "Q2 Holdings Inc",
  "QUAD": "QUAD/GRAPHICS, INC.",
  "QUBT": "Quantum Computing Inc. Common",
  "QUCY": "Quantum Cyber N.V.",
  "QUIK": "QuickLogic Corp",
  "QUMS": "Quantumsphere Acquisition Corp.",
  "QURE": "uniQure N.V.",
  "QVC": "QVC Group, Inc. Common Stock",
  "QXL": "Quantum X Labs Inc. Common Stock",
  "QXO": "QXO, Inc.",
  "QXO-P-B": "QXO, Inc Series B Preferred Stock",
  "R": "Ryder System, Inc.",
  "RA": "Brookfield Real Assets Income Fund Inc.",
  "RAC": "Rithm Acquisition Corp.",
  "RACC": "Research Alliance Corporation III Class A",
  "RACD": "Research Alliance Corporation IV Class A",
  "RACE": "Ferrari N.V.",
  "RADX": "Radiopharm Theranostics Limited ADR",
  "RAIL": "FreightCar America, Inc.",
  "RAIN": "Rain Enhancement Technologies Holdco, Inc. Class A Common Stock",
  "RAL": "Ralliant Corporation",
  "RAMP": "LiveRamp Holdings, Inc. Common Stock",
  "RAND": "Rand Capital Corp",
  "RANG": "Range Capital Acquisition Corp.",
  "RANI": "Rani Therapeutics Holdings, Inc. Class A Common Stock",
  "RAPP": "Rapport Therapeutics, Inc. Common Stock",
  "RARE": "Ultragenyx Pharmaceutical Inc.",
  "RAVE": "Rave Restaurant Group, Inc.",
  "RAY": "Raytech Holding Limited",
  "RAYA": "Erayak Power Solution Group Inc. Class A",
  "RBA": "RB Global, Inc.",
  "RBB": "RBB Bancorp Common Stock",
  "RBBN": "Ribbon Communications Inc. Common Stock",
  "RBC": "RBC Bearings Incorporated",
  "RBCAA": "Republic Bancorp Inc/KY",
  "RBKB": "Rhinebeck Bancorp, Inc. Common Stock",
  "RBLX": "Roblox Corporation",
  "RBNE": "Robin Energy Ltd. Common Stock",
  "RBRK": "Rubrik, Inc.",
  "RC": "Ready Capital Corporation",
  "RC-P-C": "Ready Capital Corporation Series C Preferred Stock",
  "RC-P-E": "Ready Capital Corporation Series E Preferred Stock",
  "RCAT": "Red Cat Holdings, Inc. Common Stock",
  "RCBC": "River City Bank Common stock",
  "RCEL": "Avita Medical, Inc. Common Stock",
  "RCG": "RENN Fund Inc.",
  "RCI": "Rogers Communications, Inc.",
  "RCKT": "Rocket Pharmaceuticals, Inc. Common Stock",
  "RCKY": "Rocky Brands, Inc.",
  "RCL": "Royal Caribbean Group",
  "RCMT": "RCM Technologies Inc",
  "RCON": "Recon Technology, Ltd. Class A",
  "RCS": "PIMCO STRATEGIC INCOME FUND, INC.",
  "RCT": "RedCloud Holdings plc",
  "RCUS": "Arcus Biosciences, Inc.",
  "RDAC": "Rising Dragon Acquisition Corp.",
  "RDAG": "Republic Digital Acquisition Company Class A",
  "RDCM": "Radcom Ltd.",
  "RDDT": "Reddit, Inc.",
  "RDGT": "Ridgetech, Inc.",
  "RDHL": "Redhill Biopharma Ltd.",
  "RDI": "Reading International, Inc Class A Common Stock",
  "RDIB": "Reading International, Inc (Class B",
  "RDN": "Radian Group Inc.",
  "RDNT": "RadNet, Inc. Common Stock",
  "RDNW": "RideNow Group, Inc. Class B Common Stock",
  "RDVT": "Red Violet, Inc. Common Stock",
  "RDW": "Redwire Corporation",
  "RDWR": "Radware Ltd.",
  "RDY": "Dr. Reddy's Laboratories Limited ADR",
  "RDZN": "Roadzen, Inc.",
  "REA": "Rare Earths Americas, Inc.",
  "REAL": "The RealReal, Inc. Common Stock",
  "REAX": "REAL BROKERAGE INC",
  "REBN": "Reborn Coffee, Inc. Common Stock",
  "RECT": "Rectitude Holdings Ltd",
  "REED": "Reed's, Inc.",
  "REF": "Reformation Inc.",
  "REFI": "Chicago Atlantic Real Estate Finance, Inc. Common Stock",
  "REFR": "Research Frontiers Inc",
  "REG": "Regency Centers Corporation",
  "REGCO": "Regency Centers Corporation Series B Preferred Stock",
  "REGCP": "Regency Centers Corporation Series A Preferred Stock",
  "REGN": "Regeneron Pharmaceuticals Inc",
  "REI": "Ring Energy Inc.",
  "REKR": "Rekor Systems, Inc. Common Stock",
  "RELL": "Richardson Electronics Ltd",
  "RELX": "RELX PLC",
  "RELY": "Remitly Global, Inc. Common Stock",
  "RENT": "Rent the Runway, Inc. Class A Common Stock",
  "RENX": "RenX Enterprises Corp. Common Stock",
  "REPL": "Replimune Group, Inc.",
  "REPX": "Riley Exploration Permian, Inc.",
  "RERE": "ATRenew Inc. ADR",
  "RES": "RPC, Inc.",
  "RETO": "ReTo Eco-Solutions, Inc. Class A Shares",
  "REVB": "Revelation Biosciences, Inc. Common Stock",
  "REX": "REX American Resources Corp.",
  "REXR": "REXFORD INDUSTRIAL REALTY, INC.",
  "REXR-P-B": "Rexford Industrial Realty, Inc Series B Preferred Stock",
  "REXR-P-C": "Rexford Industrial Realty, Inc Series C Preferred Stock",
  "REYN": "Reynolds Consumer Products Inc. Common Stock",
  "REZI": "Resideo Technologies, Inc. Common Stock",
  "RF": "Regions Financial Corp.",
  "RF-P-C": "Regions Financial Corporation Series C Preferred Stock",
  "RF-P-E": "Regions Financial Corporation Series E Preferred Stock",
  "RF-P-F": "Regions Financial Corporation Series F Preferred Stock",
  "RFAI": "RF Acquisition Corp II",
  "RFAM": "RF Acquisition Corp III",
  "RFI": "Cohen and Steers Total Return Realty Fund",
  "RFIL": "RF Industries Ltd",
  "RFL": "Rafael Holdings, Inc. Class B Common Stock",
  "RFM": "RiverNorth Flexible Municipal Income Fund, Inc.",
  "RFMZ": "RiverNorth Flexible Municipal Income Fund II, Inc.",
  "RGA": "Reinsurance Group of America, Incorporated",
  "RGC": "Regencell Bioscience Holdings Limited",
  "RGCO": "RGC Resources Inc",
  "RGEN": "Repligen Corp",
  "RGLD": "Royal Gold Inc",
  "RGNT": "Regentis Biomaterials Ltd.",
  "RGNX": "REGENXBIO Inc.",
  "RGP": "Resources Connection",
  "RGR": "Sturm, Ruger & Company, Inc.",
  "RGS": "Regis Corporation",
  "RGT": "Royce Global Trust, Inc.",
  "RGTI": "Rigetti Computing, Inc. Common Stock",
  "RH": "RH",
  "RHI": "Robert Half Inc.",
  "RHLD": "Resolute Holdings Management, Inc.",
  "RHP": "Ryman Hospitality Properties, Inc",
  "RIBB": "Ribbon Acquisition Corp Class A",
  "RICK": "RCI Hospitality Holdings, Inc.",
  "RIG": "Transocean LTD.",
  "RIGL": "Rigel Pharmaceuticals Inc. (New)",
  "RILY": "BRC Group Holdings, Inc. Common Stock",
  "RILYL": "BRC Group Holdings, Inc Series B Preferred Stock",
  "RILYP": "BRC Group Holdings, Inc Series A Preferred Stock",
  "RIME": "Algorhythm Holdings, Inc. Common Stock",
  "RIO": "Rio Tinto plc",
  "RIOT": "Riot Platforms, Inc. Common Stock",
  "RITM": "Rithm Capital Corp.",
  "RITM-P-A": "Rithm Capital Corp Series A Preferred Stock",
  "RITM-P-B": "Rithm Capital Corp Series B Preferred Stock",
  "RITM-P-C": "Rithm Capital Corp Series C Preferred Stock",
  "RITM-P-D": "Rithm Capital Corp Series D Preferred Stock",
  "RITM-P-E": "Rithm Capital Corp Series E Preferred Stock",
  "RITM-P-F": "Rithm Capital Corp Series F Preferred Stock",
  "RITR": "Reitar Logtech Holdings Limited",
  "RIV": "RiverNorth Opportunities Fund, Inc. Common Stock",
  "RIV-P-A": "RiverNorth Opportunities Fund, Inc Series A Preferred Stock",
  "RIVN": "Rivian Automotive, Inc. Class A Common Stock",
  "RJET": "Republic Airways Holdings Inc. Common Stock",
  "RJF": "Raymond James Financial, Inc.",
  "RKDA": "Arcadia Biosciences, Inc.",
  "RKLB": "Rocket Lab Corporation Common Stock",
  "RKT": "Rocket Companies, Inc.",
  "RKTO": "Rocket One Inc. Common Stock",
  "RL": "Ralph Lauren Corporation",
  "RLAY": "Relay Therapeutics, Inc. Common Stock",
  "RLGT": "Radiant Logistics, Inc.",
  "RLI": "RLI Corp.",
  "RLJ": "RLJ Lodging Trust",
  "RLJ-P-A": "RLJ Lodging Trust $1 Series A Preferred Shares",
  "RLMD": "Relmada Therapeutics, Inc. Common Stock",
  "RLTY": "Cohen & Steers Real Estate Opportunities and Income Fund",
  "RLX": "RLX Technology Inc. ADR",
  "RLYB": "Rallybio Corporation Common Stock",
  "RM": "REGIONAL MANAGEMENT CORP",
  "RMAX": "RE/MAX HOLDINGS, INC.",
  "RMBI": "Richmond Mutual Bancorporation, Inc. Common Stock",
  "RMBS": "Rambus Inc",
  "RMCF": "Rocky Mountain Chocolate Factory, Inc. Common Stock",
  "RMCO": "Royalty Management Holding Corporation Class A Common Stock",
  "RMD": "ResMed Inc.",
  "RMI": "RiverNorth Opportunistic Municipal Income Fund, Inc. Common Stock",
  "RMIX": "Suncrete, Inc. Class A Common Stock",
  "RMM": "RiverNorth Managed Duration Municipal Income Fund, Inc.",
  "RMMZ": "RiverNorth Managed Duration Municipal Income Fund II, Inc.",
  "RMNI": "Rimini Street, Inc. (DE) Common Stock",
  "RMR": "The RMR Group Inc. Class A Common Stock",
  "RMSG": "Real Messenger Corporation",
  "RMT": "Royce Micro-Cap Trust Inc",
  "RMTI": "Rockwell Medical, Inc. (DE) Common Stock",
  "RNA": "Atrium Therapeutics, Inc. Common Stock",
  "RNAC": "Cartesian Therapeutics, Inc. Common Stock",
  "RNAZ": "TransCode Therapeutics, Inc. Common Stock",
  "RNG": "RINGCENTRAL, INC.",
  "RNGR": "Ranger Energy Services, Inc.",
  "RNGT": "Range Capital Acquisition Corp II Class A",
  "RNP": "Cohen & Steers REIT and Preferred and Income Fund, Inc.",
  "RNR": "RenaissanceRe Holdings Ltd.",
  "RNR-P-F": "RenaissanceRe Holdings Ltd Series F Preferred Stock",
  "RNR-P-G": "RenaissanceRe Holdings Ltd Series G Preference Shares",
  "RNST": "Renasant Corporation",
  "RNTX": "Rein Therapeutics, Inc. Common Stock",
  "RNW": "ReNew Energy Global plc Class A",
  "RNXT": "RenovoRx, Inc. Common Stock",
  "ROAD": "Construction Partners, Inc. Class A Common Stock",
  "ROC": "Rank One Computing Corporation Common stock",
  "ROCK": "Gibraltar Industries, Inc.",
  "ROG": "Rogers Corporation",
  "ROIV": "Roivant Sciences Ltd. Common Shares",
  "ROK": "Rockwell Automation, Inc.",
  "ROKU": "Roku, Inc. Class A Common Stock",
  "ROL": "Rollins, Inc.",
  "ROLR": "High Roller Technologies, Inc.",
  "ROMA": "Roma Green Finance Limited Class A",
  "ROOT": "Root, Inc. Class A Common Stock",
  "ROP": "Roper Technologies, Inc. Common Stock",
  "ROST": "Ross Stores Inc",
  "RPAY": "Repay Holdings Corporation Class A Common Stock",
  "RPC": "Ridgepost Capital, Inc.",
  "RPD": "Rapid7, Inc. Common Stock",
  "RPGL": "Republic Power Group Limited Class A",
  "RPID": "Rapid Micro Biosystems, Inc. Class A Common Stock",
  "RPM": "RPM International, Inc.",
  "RPRX": "Royalty Pharma plc Class A",
  "RPT": "Rithm Property Trust Inc.",
  "RPT-P-C": "Rithm Property Trust Inc Series C Preferred Stock",
  "RQI": "COHEN & STEERS QUALITY INCOME REALTY FUND, INC. COMMON SHARES",
  "RR": "Richtech Robotics Inc. Class B Common Stock",
  "RRBI": "Red River Bancshares, Inc. Common Stock",
  "RRC": "Range Resources Corp",
  "RREV": "RRE Ventures Acquisition Corp. Class A",
  "RRGB": "Red Robin Gourmet Burgers Inc",
  "RRR": "Red Rock Resorts, Inc. Class A Common Stock",
  "RRX": "Regal Rexnord Corporation",
  "RS": "Reliance, Inc.",
  "RSF": "RiverNorth Capital and Income Fund, Inc.",
  "RSG": "Republic Services Inc.",
  "RSI": "Rush Street Interactive, Inc.",
  "RSKD": "Riskified Ltd.",
  "RSSS": "RESEARCH SOLUTIONS INC",
  "RSVR": "Reservoir Media, Inc. Common Stock",
  "RTAC": "Renatus Tactical Acquisition Corp I Class A",
  "RTB": "RTB Digital, Inc. Common Stock",
  "RTO": "Rentokil Initial plc ADR",
  "RTX": "RTX Corporation",
  "RUBI": "Rubico Inc. Common Stock",
  "RUM": "RUM Group Inc. Class A Common Stock",
  "RUN": "Sunrun Inc",
  "RUSHA": "Rush Enterprises Inc",
  "RUSHB": "Rush Enterprises Inc",
  "RVI": "Robinhood Ventures Fund I",
  "RVLV": "Revolve Group, Inc.",
  "RVMD": "Revolution Medicines, Inc. Common Stock",
  "RVP": "Retractable Technologies, Inc",
  "RVSB": "Riverview Bancorp Inc",
  "RVSN": "Rail Vision Ltd. Ordinary Share",
  "RVT": "Royce Small-Cap Trust, Inc.",
  "RVTY": "Revvity, Inc.",
  "RWAY": "Runway Growth Finance Corp. Common Stock",
  "RWT": "Redwood Trust, Inc.",
  "RWT-P-A": "Redwood Trust, Inc Series A Preferred Stock",
  "RXO": "RXO, Inc.",
  "RXRX": "Recursion Pharmaceuticals, Inc. Class A Common Stock",
  "RXST": "RxSight, Inc. Common Stock",
  "RXT": "Rackspace Technology, Inc. Common Stock",
  "RY": "Royal Bank of Canada",
  "RYAAY": "Ryanair Holdings plc ADR",
  "RYAM": "Rayonier Advanced Materials Inc.",
  "RYAN": "Ryan Specialty Holdings, Inc.",
  "RYDE": "Ryde Group Ltd.",
  "RYET": "Ruanyun Edai Technology Inc.",
  "RYM": "RYTHM, Inc. Common Stock",
  "RYN": "Rayonier Inc.",
  "RYOJ": "rYojbaba Co., Ltd. Common Shares",
  "RYTM": "Rhythm Pharmaceuticals, Inc. Common Stock",
  "RYZ": "Ryerson Holding Corporation",
  "RZLT": "Rezolute, Inc. Common Stock (NV)",
  "RZLV": "Rezolve AI PLC",
  "S": "SentinelOne, Inc.",
  "SA": "Seabridge Gold, Inc.",
  "SAAQ": "Space Asset Acquisition Corp. Class A",
  "SABA": "Saba Capital Income & Opportunities Fund II",
  "SABR": "Sabre Corporation",
  "SABS": "SAB Biotherapeutics, Inc. Common Stock",
  "SAC": "Safeguard Acquisition Corp.",
  "SACH": "Sachem Capital Corp. Common Shares",
  "SACH-P-A": "Sachem Capital Corp Series A Preferred Stock",
  "SAFE": "Safehold Inc.",
  "SAFT": "Safety Insurance Group Inc",
  "SAFX": "XCF Global, Inc. Class A Common Stock",
  "SAGT": "SAGTEC GLOBAL LIMITED Class A",
  "SAGU": "Shreya Acquisition Group",
  "SAH": "Sonic Automotive, Inc.",
  "SAIA": "Saia, Inc.",
  "SAIC": "Science Applications International Corporation Common Stock",
  "SAIH": "SAIHEAT Limited Class A",
  "SAIL": "SailPoint, Inc. Common Stock",
  "SAM": "Boston Beer Company",
  "SAMG": "Silvercrest Asset Management Group Inc.",
  "SAN": "Banco Santander S.A.",
  "SANA": "Sana Biotechnology, Inc. Common Stock",
  "SANG": "Sangoma Technologies Corporation Common Shares",
  "SANM": "Sanmina  Corp",
  "SAP": "SAP SE",
  "SAR": "SARATOGA INVESTMENT CORP. NEW",
  "SARO": "StandardAero, Inc.",
  "SATA": "Strive, Inc. Variable Series A Preferred Stock",
  "SATL": "Satellogic Inc. Class A",
  "SB": "Safe Bulkers, Inc.",
  "SB-P-C": "SAFE BULKERS, INC. 8.00%  SER C",
  "SB-P-D": "Safe Bulkers, Inc. 8.00% Series D",
  "SBAC": "SBA Communications Corp",
  "SBC": "SBC Medical Group Holdings Incorporated Common Stock",
  "SBCF": "Seacoast Banking Corp of Florida",
  "SBET": "Sharplink, Inc. Common Stock",
  "SBEV": "Splash Beverage Group, Inc.",
  "SBFG": "SB Financial Group, Inc.",
  "SBFM": "Sunshine Biopharma Inc.",
  "SBGI": "Sinclair, Inc. Class A Common Stock",
  "SBH": "Sally Beauty Holdings, Inc.",
  "SBI": "Western Asset Intermediate Muni Fund, Inc.",
  "SBLK": "Star Bulk Carriers Corp.",
  "SBMT": "Silver Bow Mining Corp.",
  "SBR": "Sabine Royalty Trust",
  "SBRA": "Sabra Healthcare REIT, Inc.",
  "SBS": "COMPANHIA DE SANEAMENTO B SICO DO ESTADO DE SAO PAULO-SABESP ADS'S",
  "SBSI": "Southside Bancshares, Inc.",
  "SBSW": "Sibanye-Stillwater ADR",
  "SBUX": "Starbucks Corp",
  "SBXD": "SilverBox Corp IV",
  "SBXE": "SilverBox Corp V",
  "SCAG": "Scage Future ADR",
  "SCCO": "Southern Copper Corporation",
  "SCD": "LMP Capital and Income Fund, Inc.",
  "SCE-P-G": "SCE TRUST II 5.10% Trust Preference Securities",
  "SCE-P-L": "SCE TRUST VI 5.00% Trust Preference Securities",
  "SCE-P-M": "SCE Trust VII 7.50% Trust Preference Securities",
  "SCE-P-N": "SCE Trust VIII 6.95% Trust Preference Securities",
  "SCHL": "Scholastic Corp",
  "SCHW": "The Charles Schwab Corporation",
  "SCHW-P-D": "Charles Schwab Corporation Series D Preferred Stock",
  "SCHW-P-J": "The Charles Schwab Corporation Series J Preferred Stock",
  "SCI": "Service Corporation International",
  "SCII": "SC II Acquisition Corp. Class A ordinary share",
  "SCKT": "Socket Mobile, Inc. New",
  "SCL": "Stepan Co.",
  "SCLX": "Scilex Holding Company Common Stock",
  "SCM": "STELLUS CAPITAL INVESTMENT CORPORATION",
  "SCNI": "Scinai Immunotherapeutics Ltd. ADR",
  "SCNX": "Scienture Holdings, Inc. Common Stock",
  "SCOR": "comScore, Inc. Common Stock",
  "SCPQ": "Social Commerce Partners Corporation Class A",
  "SCSC": "Scansource Inc",
  "SCTX": "Scribe Therapeutics Inc. Common Stock",
  "SCWO": "374Water Inc. Common Stock",
  "SCYX": "SCYNEXIS, Inc.",
  "SCZM": "Santacruz Silver Mining Ltd. Common Shares",
  "SD": "SandRidge Energy, Inc.",
  "SDA": "SunCar Technology Group Inc. Class A",
  "SDEV": "Stablecoin Development Corporation",
  "SDGR": "Schrodinger, Inc. Common Stock",
  "SDHC": "Smith Douglas Homes Corp.",
  "SDHI": "Siddhi Acquisition Corp Class A Common stock",
  "SDHY": "PGIM Short Duration High Yield Opportunities Fund",
  "SDOT": "Sadot Group Inc. Common Stock",
  "SDRL": "Seadrill Limited",
  "SDST": "Stardust Power Inc. Common Stock",
  "SE": "Sea Limited ADR",
  "SEAT": "Vivid Seats Inc. Class A Common Stock",
  "SEB": "Seaboard Corporation",
  "SECZ": "Securitize Corp.",
  "SEDG": "SolarEdge Technologies, Inc.",
  "SEED": "Origin Agritech Limited",
  "SEER": "Seer, Inc. Class A Common Stock",
  "SEG": "Seaport Entertainment Group Inc.",
  "SEGG": "Sports Entertainment Gaming Global Corporation Common Stock",
  "SEI": "Solaris Energy Infrastructure, Inc.",
  "SEIC": "SEI Investments Co",
  "SELF": "Global Self Storage, Inc. Common Stock",
  "SENEA": "Seneca Foods Corp",
  "SENEB": "Seneca Foods Corp",
  "SENS": "Senseonics Holdings, Inc. Common Stock",
  "SEPN": "Septerna, Inc. Common Stock",
  "SER": "Serina Therapeutics, Inc.",
  "SERA": "Sera Prognostics, Inc. Class A Common Stock",
  "SERV": "Serve Robotics Inc. Common Stock",
  "SES": "SES AI Corporation",
  "SEV": "Aptera Motors Corp. Class B Common Stock",
  "SEVN": "Seven Hills Realty Trust Common Stock",
  "SEZL": "Sezzle Inc. Common Stock",
  "SF": "Stifel Financial Corp.",
  "SF-P-B": "Stifel Financial Corp Series B Preferred Stock",
  "SF-P-C": "Stifel Financial Corp Series C Preferred Stock",
  "SF-P-D": "Stifel Financial Corp Series D Preferred Stock",
  "SFBC": "Sound Financial Bancorp, Inc.",
  "SFBS": "ServisFirst Bancshares Inc.",
  "SFD": "Smithfield Foods, Inc. Common Stock",
  "SFHG": "Samfine Creation Holdings Group Limited Class A Ordinary Share",
  "SFIX": "Stitch Fix, Inc. Class A Common Stock",
  "SFL": "SFL Corporation Ltd.",
  "SFM": "Sprouts Farmers Market, Inc.",
  "SFNC": "Simmons First National Corp",
  "SFST": "Southern First Bancshares, Inc.",
  "SFWL": "Shengfeng Development Limited Class A",
  "SG": "Sweetgreen, Inc.",
  "SGA": "Saga Communications, Inc. Class A Common Stock (FL)",
  "SGC": "Superior Group of Companies, Inc. Common Stock",
  "SGHC": "Super Group (SGHC) Limited",
  "SGHT": "Sight Sciences, Inc. Common Stock",
  "SGI": "Somnigroup International Inc.",
  "SGLY": "Singularity Future Technology Ltd. Common Stock",
  "SGML": "Sigma Lithium Corporation Common Shares",
  "SGMT": "Sagimet Biosciences Inc. Series A Common Stock",
  "SGP": "SpyGlass Pharma, Inc. Common Stock",
  "SGRY": "Surgery Partners, Inc. Common Stock",
  "SGU": "Star Group, L.P. Common Units Representing Limited Partner Interest",
  "SHAK": "Shake Shack Inc.",
  "SHAZ": "SharonAI Holdings, Inc. Class A Common Stock",
  "SHBI": "Shore Bancshares Inc",
  "SHC": "Sotera Health Company Common Stock",
  "SHEL": "Shell plc ADR",
  "SHEN": "Shenandoah Telecom Co",
  "SHFS": "SHF Holdings, Inc. Class A Common Stock",
  "SHG": "Shinhan Financial Group Co Ltd",
  "SHIM": "Shimmick Corporation Common Stock",
  "SHIP": "Seanergy Maritime Holdings Corp.",
  "SHLS": "Shoals Technologies Group, Inc. Class A Common Stock",
  "SHMD": "SCHMID Group N.V. Class A",
  "SHO": "Sunstone Hotel Investors, Inc.",
  "SHO-P-H": "Sunstone Hotel Investors, Inc Series H Preferred Stock",
  "SHO-P-I": "Sunstone Hotel Investors, Inc Series I Preferred Stock",
  "SHOE": "Shoe Station Group, Inc. Common Stock",
  "SHOO": "Steven Madden Ltd",
  "SHOP": "Shopify Inc. Class A subordinate voting shares",
  "SHOT": "RMG ML Sports Holdings Class A",
  "SHPH": "Shuttle Pharmaceuticals Holdings, Inc. Common Stock",
  "SHW": "The Sherwin-Williams Company",
  "SI": "Shoulder Innovations, Inc.",
  "SIBN": "SI-BONE, Inc. Common Stock",
  "SID": "Companhia Siderurgica Nacional S.A. (CSN)",
  "SIDU": "Sidus Space, Inc. Class A Common Stock",
  "SIEB": "Siebert Financial Corp",
  "SIF": "SIFCO Industries, Inc.",
  "SIFY": "Sify Technologies Limited",
  "SIG": "Signet Jewelers Limited",
  "SIGA": "SIGA Technologies Inc.",
  "SIGI": "Selective Insurance Group",
  "SIGIP": "Selective Insurance Group, Inc Series B Preferred Stock",
  "SII": "Sprott Inc.",
  "SILC": "Silicom Ltd",
  "SILO": "Silo Pharma, Inc. Common Stock",
  "SIM": "Groupo Simec, S.A.B de C.V.",
  "SIMA": "SIM Acquisition Corp. I Class A",
  "SIMO": "Silicon Motion Technology Corporation",
  "SIND": "Sinda Ltd.",
  "SINT": "SiNtx Technologies, Inc. Common Stock",
  "SION": "Sionna Therapeutics, Inc. Common Stock",
  "SIRI": "Sirius XM Holdings,  Inc",
  "SITC": "SITE Centers Corp. Common Shares",
  "SITE": "SiteOne Landscape Supply, Inc.",
  "SITM": "SiTime Corporation Common Stock",
  "SJ": "Scienjoy Holding Corporation Class A",
  "SJM": "The J.M. Smucker Company",
  "SJT": "San Juan Basin Royalty Trust UBI",
  "SKE": "Skeena Resources Limited",
  "SKHY": "SK hynix Inc. ADR",
  "SKIL": "Skillsoft Corp.",
  "SKIN": "SkinHealth Systems Inc. Class A Common Stock",
  "SKK": "SKK Holdings Limited Class A",
  "SKM": "SK Telecom Co., Ltd. ADR",
  "SKT": "Tanger Inc.",
  "SKWD": "Skyward Specialty Insurance Group, Inc. Common Stock",
  "SKY": "Champion Homes, Inc.",
  "SKYA": "SkyAI, Inc. Common Stock",
  "SKYE": "Skye Bioscience, Inc. Common Stock",
  "SKYH": "Sky Harbour Group Corporation",
  "SKYQ": "Sky Quarry Inc. Common Stock",
  "SKYW": "Skywest Inc",
  "SKYX": "SKYX Platforms Corp. Common Stock",
  "SLAB": "Silicon Laboratories Inc",
  "SLB": "SLB Limited",
  "SLBT": "SL Science Holding Limited",
  "SLDB": "Solid Biosciences Inc. Common Stock",
  "SLDE": "Slide Insurance Holdings, Inc. Common Stock",
  "SLDP": "Solid Power, Inc. Class A Common Stock",
  "SLE": "Super League Enterprise, Inc. Common Stock",
  "SLF": "Sun Life Financial Inc.",
  "SLG": "SL Green Realty Corp.",
  "SLG-P-I": "SL GREEN REALTY CORP Series I Preferred Stock",
  "SLGB": "Smart Logistics Global Limited Class A",
  "SLGL": "Sol-Gel Technologies Ltd.",
  "SLGN": "Silgan Holdings Inc",
  "SLI": "Standard Lithium Ltd.",
  "SLM": "SLM Corporation",
  "SLMBP": "SLM Corporation Floating-Rate Non-Cumulative Series B",
  "SLMT": "Brera Holdings PLC Class B",
  "SLN": "Silence Therapeutics Plc ADR",
  "SLND": "Southland Holdings, Inc.",
  "SLNG": "Stabilis Solutions, Inc. Common Stock",
  "SLNH": "Soluna Holdings, Inc. Common Stock",
  "SLNHP": "Soluna Holdings, Inc Series A Preferred Stock",
  "SLP": "Simulations Plus, Inc.",
  "SLQT": "SelectQuote, Inc.",
  "SLRC": "SLR Investment Corp. Common Stock",
  "SLS": "SELLAS Life Sciences Group, Inc. Common Stock",
  "SLSN": "Solesence, Inc. Common Stock",
  "SLSR": "Solaris Resources Inc.",
  "SLVM": "Sylvamo Corporation",
  "SLXN": "Silexion Therapeutics Corp",
  "SM": "SM Energy Company",
  "SMA": "SmartStop Self Storage REIT, Inc.",
  "SMBC": "Southern Missouri Bancorp",
  "SMBK": "SmartFinancial, Inc.",
  "SMC": "Summit Midstream Corporation",
  "SMCI": "Super Micro Computer, Inc. Common Stock",
  "SMCIP": "Super Micro Computer, Inc. Depositary Shares representing a 1/20th Interest in a Share of Series A Preferred Stock",
  "SMFG": "Sumitomo Mitsui Financial Group, Inc ADR",
  "SMG": "The Scotts Miracle-Gro Company",
  "SMHI": "SEACOR Marine Holdings Inc. Common Stock",
  "SMID": "Smith-Midland Corporation Common Stock",
  "SMJF": "SMJ International Holdings Inc.",
  "SMMT": "Summit Therapeutics Inc. Common Stock",
  "SMP": "Standard Motor Products",
  "SMPL": "The Simply Good Foods Company Common Stock",
  "SMR": "NuScale Power Corporation",
  "SMRT": "SmartRent, Inc.",
  "SMSI": "Smith Micro Software Inc",
  "SMTC": "Semtech Corp",
  "SMTI": "Sanara MedTech Inc. Common Stock",
  "SMTK": "SmartKem, Inc. Common Stock",
  "SMWB": "Similarweb Ltd.",
  "SMX": "SMX (Security Matters) Public Limited Company",
  "SMXT": "Solarmax Technology Inc. Common Stock",
  "SN": "SharkNinja, Inc.",
  "SNA": "Snap-on Incorporated",
  "SNAL": "Snail, Inc. Class A Common Stock",
  "SNAP": "Snap Inc.",
  "SND": "Smart Sand, Inc. Common Stock",
  "SNDA": "Sonida Senior Living, Inc.",
  "SNDK": "Sandisk Corporation Common Stock",
  "SNDL": "Sundial Growers Inc. Common Shares",
  "SNDR": "Schneider National, Inc.",
  "SNDX": "Syndax Pharmaceuticals, Inc.",
  "SNES": "SenesTech, Inc. Common Stock",
  "SNEX": "StoneX Group Inc. Common Stock",
  "SNFCA": "Security National Financial Co",
  "SNGX": "Soligenix, Inc. Common Stock",
  "SNN": "Smith & Nephew plc",
  "SNOA": "Sonoma Pharmaceuticals, Inc. Common Stock",
  "SNOW": "Snowflake Inc.",
  "SNPS": "Synopsys Inc",
  "SNT": "Senstar Technologies Corporation Common Shares",
  "SNTG": "Sentage Holdings Inc. Class A",
  "SNTI": "Senti Biosciences Holdings, Inc. Common Stock",
  "SNWV": "SANUWAVE Health, Inc. Common Stock",
  "SNX": "TD SYNNEX Corporation",
  "SNY": "Sanofi ADR",
  "SNYR": "Synergy CHC Corp. Common Stock",
  "SO": "The Southern Company",
  "SOAR": "Volato Group, Inc.",
  "SOBO": "South Bow Corporation",
  "SOBR": "SOBR Safe, Inc. Common Stock",
  "SOC": "Sable Offshore Corp.",
  "SOCA": "Solarius Capital Acquisition Corp. Class A Ordinary Share",
  "SOFI": "SoFi Technologies, Inc. Common Stock",
  "SOGP": "Sound Group Inc. ADR",
  "SOHU": "Sohu.com Limited ADR",
  "SOLS": "Solstice Advanced Materials Inc. Common Stock",
  "SOLV": "Solventum Corporation",
  "SON": "Sonoco Products Company",
  "SONM": "DNA X, Inc. Common Stock",
  "SONO": "Sonos, Inc. Common Stock",
  "SONY": "Sony Group Corporation ADR",
  "SOPH": "SOPHiA GENETICS SA",
  "SOR": "Source Capital",
  "SORA": "AsiaStrategy",
  "SORN": "Soren Acquisition Corp. Class A",
  "SOS": "SOS Limited",
  "SOTK": "Sono-Tek Corporation Common Stock",
  "SOUL": "Soulpower Acquisition Corporation",
  "SOUN": "SoundHound AI, Inc. Class A Common Stock",
  "SOWG": "Sow Good Inc. Common Stock",
  "SPAI": "Safe Pro Group Inc. Common Stock",
  "SPB": "Spectrum Brands Holdings, Inc.",
  "SPCB": "SuperCom, Ltd",
  "SPCE": "Virgin Galactic Holdings, Inc.",
  "SPCX": "Space Exploration Technologies Corp. Class A Common Stock",
  "SPE": "Special Opportunities Fund, Inc.",
  "SPE-P-C": "Special Opportunities Fund, Inc Series C Preferred Stock",
  "SPEG": "Silver Pegasus Acquisition Corp Class A",
  "SPFI": "South Plains Financial, Inc. Common Stock",
  "SPG": "Simon Property Group, Inc.",
  "SPG-P-J": "Simon Property Group, Inc. 8 3/8% Series J",
  "SPGI": "S&P Global Inc.",
  "SPH": "Suburban Propane Partners L P",
  "SPHL": "Springview Holdings Ltd Class A",
  "SPHR": "Sphere Entertainment Co.",
  "SPIR": "Spire Global, Inc.",
  "SPKL": "Spark I Acquisition Corp. Class A Ordinary Share",
  "SPMA": "Sound Point Meridian Capital, Inc Series A Preferred Shares",
  "SPMC": "Sound Point Meridian Capital, Inc.",
  "SPME": "Sound Point Meridian Capital, Inc Series B Preferred Shares",
  "SPNT": "SiriusPoint Ltd.",
  "SPOK": "Spok Holdings, Inc",
  "SPOT": "Spotify Technology S.A.",
  "SPPL": "SIMPPLE LTD.",
  "SPRB": "Spruce Biosciences, Inc. Common Stock",
  "SPRC": "SciSparc Ltd.",
  "SPRO": "Spero Therapeutics, Inc. Common Stock",
  "SPRU": "Spruce Power Holding Corporation",
  "SPRY": "ARS Pharmaceuticals, Inc. Common Stock",
  "SPSC": "SPS Commerce, Inc.",
  "SPT": "Sprout Social, Inc Class A Common Stock",
  "SPTX": "Seaport Therapeutics, Inc. Common Stock",
  "SPWH": "Sportsman's Warehouse Holdings, Inc.",
  "SPWR": "SunPower Inc. Common Stock",
  "SPXC": "SPX Technologies, Inc.",
  "SPXX": "NUVEEN S&P 500 DYNAMIC OVERWRITE FUND",
  "SQFT": "Presidio Property Trust, Inc. Class A Common Stock",
  "SQFTP": "Presidio Property Trust, Inc Series D Preferred Stock",
  "SQM": "Sociedad Quimica y Minera de Chile SA",
  "SQNS": "Sequans Communications S.A. ADR",
  "SR": "Spire Inc.",
  "SRAD": "Sportradar Group AG Class A",
  "SRBK": "SR Bancorp, Inc. Common stock",
  "SRCE": "1st Source Corp",
  "SRE": "Sempra",
  "SRFM": "Surf Air Mobility Inc.",
  "SRG": "Seritage Growth Properties Class A",
  "SRG-P-A": "Seritage Growth Properties Series A Preferred Shares",
  "SRI": "Stoneridge, Inc",
  "SRL": "Scully Royalty Ltd. Common Shares",
  "SRPT": "Sarepta Therapeutics,, Inc. Common Stock",
  "SRRK": "Scholar Rock Holding Corporation Common Stock",
  "SRTA": "Strata Critical Medical, Inc. Class A Common Stock",
  "SRTS": "Sensus Healthcare, Inc",
  "SRV": "NXG Cushing Midstream Energy Fund",
  "SRXH": "SRX Global Inc",
  "SRZN": "Surrozen, Inc. Common",
  "SSAC": "SPACSphere Acquisition Corp. Class A",
  "SSB": "SouthState Bank Corporation",
  "SSBI": "Summit State Bank",
  "SSD": "Simpson Manufacturing Co., Inc.",
  "SSEA": "Starry Sea Acquisition Corp",
  "SSII": "SS Innovations International Inc. Common Stock",
  "SSL": "Sasol Limited",
  "SSM": "Sono Group N.V.",
  "SSMR": "Sunshine Silver Mining & Refining Company",
  "SSNC": "SS&C Technologies Inc",
  "SSP": "The E.W. Scripps Company",
  "SSRM": "SSR Mining Inc.",
  "SST": "System1, Inc.",
  "SSTI": "SoundThinking, Inc. Common Stock",
  "SSTK": "SHUTTERSTOCK, INC.",
  "SSYS": "Stratasys Inc (ISRAEL)",
  "ST": "Sensata Technologies Holding plc",
  "STAA": "Staar Surgical Co",
  "STAG": "STAG INDUSTRIAL, INC.",
  "STAK": "STAK Inc. Class A",
  "STBA": "S&T Bancorp Inc",
  "STC": "Stewart Information Services Corporation",
  "STDN": "Standard Nuclear, Inc.",
  "STE": "STERIS plc",
  "STEM": "Stem, Inc.",
  "STEP": "StepStone Group Inc. Class A Common Stock",
  "STEW": "SRH Total Return Fund, Inc.",
  "STEX": "Streamex Corp. Common Stock",
  "STFS": "Star Fashion Culture Holdings Limited Class A",
  "STG": "Sunlands Technology Group, ADR",
  "STGW": "Stagwell Inc. Class A Common Stock",
  "STHO": "Star Holdings Shares of Beneficial Interest",
  "STI": "Solidion Technology, Inc. Common Stock",
  "STIM": "Neuronetics, Inc. Common Stock",
  "STK": "Columbia Seligman Premium Technology Growth Fund, Inc.",
  "STKE": "Sol Strategies Inc. Common Shares",
  "STKH": "Steakholder Foods Ltd. ADR",
  "STKS": "The ONE Group Hospitality, Inc. Common Stock",
  "STLA": "Stellantis N.V.",
  "STLD": "Steel Dynamics Inc",
  "STLN": "Starling Oncology, Inc. Common Stock",
  "STM": "STMicroelectronics N.V.",
  "STN": "Stantec, Inc.",
  "STNE": "StoneCo Ltd. Class A Common Shares",
  "STNG": "Scorpio Tankers Inc.",
  "STOK": "Stoke Therapeutics, Inc. Common Stock",
  "STRA": "Strategic Education, Inc. Common Stock",
  "STRC": "Strategy Inc Variable Series A Preferred Stock",
  "STRD": "Strategy Inc Series A Preferred Stock",
  "STRF": "Strategy Inc Series A Preferred Stock",
  "STRK": "Strategy Inc Series A Preferred Stock",
  "STRL": "Sterling Infrastructure, Inc. Common Stock",
  "STRO": "Sutro Biopharma, Inc.",
  "STRR": "Star Equity Holdings, Inc. Common Stock",
  "STRRP": "Star Equity Holdings, Inc Series A Preferred Stock",
  "STRS": "Stratus Properties Inc",
  "STRT": "Strattec Security Corp",
  "STRW": "Strawberry Fields REIT, Inc.",
  "STRZ": "Starz Entertainment Corp. Common Shares",
  "STT": "State Street Corporation",
  "STT-P-G": "State Street Corporation Series G Preferred Stock",
  "STTK": "Shattuck Labs, Inc. Common Stock",
  "STUB": "StubHub Holdings, Inc.",
  "STVN": "Stevanato Group S.p.A.",
  "STWD": "STARWOOD PROPERTY TRUST, INC.",
  "STX": "Seagate Technology Holdings PLC Ordinary Shares (Ireland)",
  "STXS": "Stereotaxis, Inc. Common Stock",
  "STZ": "Constellation Brands, Inc.",
  "SU": "Suncor Energy, Inc.",
  "SUGP": "SU Group Holdings Limited Class A",
  "SUI": "Sun Communities, Inc",
  "SUIG": "Sui Group Holdings Limited Common Stock",
  "SUJA": "Suja Life, Inc. Class A Common Stock",
  "SUMA": "SUMA Acquisition Corporation Class A",
  "SUN": "SUNOCO L.P.",
  "SUNB": "Sunbelt Rentals Holdings, Inc.",
  "SUNC": "SunocoCorp LLC",
  "SUNE": "SUNation Energy, Inc. Common Stock",
  "SUNS": "Sunrise Realty Trust, Inc. Common Stock",
  "SUPN": "Supernus Pharmaceuticals, Inc.",
  "SUPV": "Grupo Supervielle S.A.",
  "SUPX": "SuperX AI Technology Limited",
  "SURG": "SurgePays, Inc. Common Stock",
  "SUZ": "Suzano S.A. ADR",
  "SVA": "Sinovac Biotech, Ltd",
  "SVAQ": "Silicon Valley Acquisition Corp. Class A",
  "SVC": "Service Properties Trust Common Stock",
  "SVCC": "Stellar V Capital Corp. Class A",
  "SVCO": "Silvaco Group, Inc. Common Stock",
  "SVIV": "Spring Valley Acquisition Corp. IV Class A",
  "SVM": "Silvercorp Metals Inc. Common Shares",
  "SVRA": "Savara Inc.",
  "SVRE": "SaverOne 2014 Ltd. ADR",
  "SVRN": "OceanPal Inc. Common Stock",
  "SVV": "Savers Value Village, Inc.",
  "SW": "Smurfit Westrock plc",
  "SWAG": "Stran & Company, Inc. Common Stock",
  "SWBI": "Smith & Wesson Brands, Inc. Common Stock",
  "SWIM": "Latham Group, Inc. Common Stock",
  "SWK": "Stanley Black & Decker, Inc.",
  "SWKS": "Skyworks Solutions Inc",
  "SWMR": "Swarmer, Inc Common Stock",
  "SWVL": "Swvl Holdings Corp Class A Common Shares",
  "SWX": "Southwest Gas Holdings, Inc.",
  "SWZ": "Total Return Securities Fund",
  "SXC": "SUNCOKE ENERGY INC",
  "SXI": "Standex International Corporation",
  "SXT": "Sensient Technology Corporation",
  "SXTC": "China SXT Pharmaceuticals, Inc. Class A",
  "SXTP": "60 Degrees Pharmaceuticals, Inc. Common Stock",
  "SY": "So-Young International Inc. ADR",
  "SYBT": "Stock Yards Bancorp, Inc.",
  "SYF": "SYNCHRONY FINANCIAL",
  "SYF-P-A": "Synchrony Financial Series A Preferred Stock",
  "SYF-P-B": "Synchrony Financial Series B Preferred Stock",
  "SYK": "Stryker Corporation",
  "SYM": "Symbotic Inc. Class A Common Stock",
  "SYNA": "Synaptics Inc",
  "SYNX": "Silynxcom Ltd.",
  "SYPR": "Sypris Solutions Inc",
  "SYRE": "Spyre Therapeutics, Inc. Common Stock",
  "SYY": "Sysco Corporation",
  "SZZL": "Sizzle Acquisition Corp. II Class A ordinary shares",
  "T": "AT&T Inc.",
  "T-P-A": "AT&T Inc Series A Preferred Stock",
  "T-P-C": "AT&T Inc Series C Preferred Stock",
  "TAC": "TransAlta Corporation",
  "TACH": "Titan Acquisition Corp. Class A",
  "TACO": "Berto Acquisition Corp.",
  "TACT": "Transact Technologies Inc",
  "TAK": "Takeda Pharmaceutical Company Limited ADR",
  "TAL": "TAL Education Group",
  "TALK": "Talkspace, Inc. Common Stock",
  "TALO": "Talos Energy, Inc. Common Stock",
  "TANH": "Tantech Holdings Ltd. Class A Common Shares",
  "TAOP": "Taoping Inc. BVI Ordinary Shares (0 par)",
  "TAOX": "Tao Synergies Inc. Common Stock",
  "TAP": "Molson Coors Beverage Company Class B",
  "TAP-A": "Molson Coors Beverage Company Class A",
  "TARA": "Protara Therapeutics, Inc. Common Stock",
  "TARS": "Tarsus Pharmaceuticals, Inc. Common Stock",
  "TASK": "TaskUs, Inc. Class A Common Stock",
  "TATT": "TAT Technologies Ltd",
  "TAVI": "Tavia Acquisition Corp.",
  "TAYD": "Taylor Devices Inc",
  "TBBB": "BBB Foods Inc.",
  "TBBK": "The Bancorp Inc.",
  "TBCH": "Turtle Beach Corporation Common Stock",
  "TBI": "Trueblue, Inc.",
  "TBLA": "Taboola.com Ltd.",
  "TBLD": "Thornburg Income Builder Opportunities Trust Common Stock",
  "TBN": "Tamboran Resources Corporation",
  "TBPH": "Theravance Biopharma, Inc.",
  "TC": "Token Cat Limited ADR",
  "TCBI": "Texas Capital Bancshares, Inc.",
  "TCBIO": "Texas Capital Bancshares, Inc. Depositary Shares Series B Preferred Stock",
  "TCBK": "Trico Bancshares",
  "TCBS": "Texas Community Bancshares, Inc. Common Stock",
  "TCBX": "Third Coast Bancshares, Inc. Common Stock",
  "TCGX": "TCGX Acquisition Corp. Class A",
  "TCI": "Transcontinental Realty Investors, Inc.",
  "TCMD": "Tactile Systems Technology, Inc.",
  "TCOM": "Trip.com Group Limited ADR",
  "TCPC": "BlackRock TCP Capital Corp. Common Stock",
  "TCRT": "Alaunos Therapeutics, Inc. Common Stock",
  "TCRX": "TScan Therapeutics, Inc. Common Stock",
  "TCX": "Tucows, Inc",
  "TD": "Toronto Dominion Bank",
  "TDAC": "Translational Development Acquisition Corp.",
  "TDAY": "USA TODAY Co., Inc.",
  "TDC": "TERADATA CORPORATION",
  "TDF": "Templeton Dragon Fund",
  "TDG": "TransDigm Group Incorporated",
  "TDIC": "Dreamland Limited Class A",
  "TDOC": "Teladoc Health, Inc.",
  "TDS": "Telephone and Data Systems Inc.",
  "TDS-P-U": "Telephone and Data Systems, Inc Preferred Stock",
  "TDS-P-V": "Telephone and Data Systems, Inc Preferred Stock",
  "TDTH": "Trident Digital Tech Holdings Ltd Class B",
  "TDUP": "ThredUp Inc. Class A Common Stock",
  "TDW": "Tidewater, Inc.",
  "TDWD": "Tailwind 2.0 Acquisition Corp. Class A",
  "TDY": "Teledyne Technologies Incorporated",
  "TE": "T1 Energy Inc.",
  "TEAD": "Teads Holding Co. Common Stock",
  "TEAM": "Atlassian Corporation Class A Common Stock",
  "TECH": "Bio-Techne Corp.",
  "TECK": "Teck Resources Limited",
  "TECX": "Tectonic Therapeutic, Inc. Common Stock",
  "TEI": "Templeton Emerging Markets Income Fund",
  "TEL": "TE Connectivity plc",
  "TELA": "TELA Bio, Inc. Common Stock",
  "TELO": "Telomir Pharmaceuticals, Inc. Common Stock",
  "TEM": "Tempus AI, Inc. Class A Common Stock",
  "TEN": "Tsakos Energy Navigation Ltd.",
  "TEN-P-E": "Tsakos Energy Navigation Limited Series E Series E Preferred Shares",
  "TEN-P-F": "Tsakos Energy Navigation Limited Series F Series F Preferred Shares",
  "TENB": "Tenable Holdings, Inc.",
  "TENX": "Tenax Therapeutics, Inc.",
  "TEO": "Telecom Argentina S.A.",
  "TER": "Teradyne, Inc. Common Stock",
  "TEVA": "Teva Pharmaceutical Industries Limited ADR",
  "TEX": "Terex Corporation",
  "TFC": "Truist Financial Corporation",
  "TFC-P-I": "Truist Financial Corporation Series I Preferred Stock",
  "TFC-P-O": "Truist Financial Corporation Series O Preferred Stock",
  "TFC-P-R": "Truist Financial Corporation Series R Preferred Stock",
  "TFII": "TFI International Inc.",
  "TFIN": "Triumph Financial, Inc.",
  "TFIN-P": "Triumph Financial, Inc Series C Preferred Stock",
  "TFPM": "Triple Flag Precious Metals Corp.",
  "TFSL": "TFS Financial Corporation",
  "TFX": "Teleflex Incorporated",
  "TG": "Tredegar Corporation",
  "TGB": "Trekor Metals Limited",
  "TGE": "The Generation Essentials Group",
  "TGEN": "Tecogen Inc.",
  "TGHL": "The GrowHub Limited Class A",
  "TGL": "Treasure Global Inc. Common Stock",
  "TGLS": "Tecnoglass Holdings Inc.",
  "TGS": "Transportadora de Gas del Sur S.A. ADS",
  "TGT": "Target Corporation",
  "TGTX": "TG Therapeutics, Inc.",
  "TH": "Target Hospitality Corp. Common Stock",
  "THC": "Tenet Healthcare Corporation New",
  "THCH": "TH International Limited",
  "THFF": "First Financial Corporation Common Stock",
  "THG": "The Hanover Insurance Group, Inc.",
  "THH": "TryHard Holdings Limited",
  "THM": "International Tower Hill Mines, Ltd.",
  "THO": "Thor Industries, Inc.",
  "THQ": "abrdn Healthcare Opportunities Fund",
  "THRM": "Gentherm Inc",
  "THRY": "Thryv Holdings, Inc. Common Stock",
  "THW": "abrdn World Healthcare Fund",
  "TIC": "TIC Solutions, Inc",
  "TIGO": "Millicom International Cellular S.A. Common Stock",
  "TIGR": "UP Fintech Holding Ltd ADR",
  "TII": "Titan Mining Corporation",
  "TIL": "Instil Bio, Inc. Common Stock",
  "TILE": "Interface Inc",
  "TIMB": "TIM S.A. ADR",
  "TIPT": "Tiptree Inc. Common Stock",
  "TISI": "Team, Inc.",
  "TITN": "Titan Machinery Inc.",
  "TJGC": "TJGC Group Limited",
  "TJX": "TJX Companies, Inc. (The)",
  "TK": "Teekay Corporation Ltd.",
  "TKC": "TURKCELL ILETISIM HIZMETLERI A.S. ADS",
  "TKLF": "Tokyo Lifestyle Co., Ltd. ADR",
  "TKNO": "Alpha Teknova, Inc. Common Stock",
  "TKO": "TKO Group Holdings, Inc.",
  "TKR": "The Timken Company",
  "TLF": "Tandy Leather Factory, Inc. Common Stock",
  "TLIH": "Ten-League International Holdings Limited",
  "TLK": "PT Telekomunikasi Indonesia",
  "TLN": "Talen Energy Corporation Common Stock",
  "TLNC": "Talon Capital Corp. Class A",
  "TLPH": "Talphera, Inc. Common Stock",
  "TLRY": "Tilray Brands, Inc. Common Stock",
  "TLS": "Telos Corporation Common Stock",
  "TLSA": "Tiziana Life Sciences Ltd. Common Shares",
  "TLSI": "TriSalus Life Sciences, Inc. Common Stock",
  "TLX": "Telix Pharmaceuticals Limited ADR",
  "TLYS": "Tilly's Inc.",
  "TM": "Toyota Motor Corporation ADR",
  "TMC": "TMC the metals company Inc. Common Stock",
  "TMCI": "Treace Medical Concepts, Inc. Common Stock",
  "TMCR": "The Metals Royalty Company Inc. Common Stock",
  "TMDE": "TMD Energy Limited",
  "TMDX": "TransMedics Group, Inc. Common Stock",
  "TME": "Tencent Music Entertainment Group ADR",
  "TMO": "Thermo Fisher Scientific, Inc.",
  "TMP": "Tompkins Financial Corporation",
  "TMQ": "Trilogy Metals Inc",
  "TMS": "Teamshares Inc. Common Stock",
  "TMTS": "Spartacus Acquisition Corp. II Class A",
  "TMUS": "T-Mobile US, Inc.",
  "TNC": "TENNANT COMPANY",
  "TNDM": "Tandem Diabetes Care, Inc.",
  "TNET": "TRINET GROUP, INC.",
  "TNGX": "Tango Therapeutics, Inc.",
  "TNK": "Teekay Tankers Ltd.",
  "TNL": "Travel + Leisure Co.",
  "TNMG": "TNL Mediagene",
  "TNON": "Tenon Medical, Inc. Common Stock",
  "TNXP": "Tonix Pharmaceuticals Holding Corp.",
  "TNYA": "Tenaya Therapeutics, Inc. Common Stock",
  "TOL": "Toll Brothers, Inc.",
  "TOMZ": "TOMI Environmental Solutions, Inc.",
  "TONT": "Graf Global Corp.",
  "TONX": "TON Strategy Company Common Stock",
  "TOON": "Kartoon Studios, Inc.",
  "TOP": "TOP Financial Group Limited Class A",
  "TOPP": "Toppoint Holdings Inc.",
  "TOPS": "TOP Ships Inc.",
  "TORO": "Toro Corp. Common Stock",
  "TOST": "Toast, Inc.",
  "TOUR": "Tuniu Corporation",
  "TOVX": "Theriva Biologics, Inc.",
  "TOWN": "Towne Bank",
  "TOYO": "TOYO Co., Ltd",
  "TP": "Ticketplus Ltd.",
  "TPB": "Turning Point Brands, Inc.",
  "TPC": "Tutor Perini Corporation",
  "TPCS": "Techprecision Corporation",
  "TPET": "Trio Petroleum Corp.",
  "TPG": "TPG Inc. Class A Common Stock",
  "TPL": "Texas Pacific Land Corporation",
  "TPR": "Tapestry, Inc. Common Stock",
  "TPST": "Tempest Therapeutics, Inc. Common Stock",
  "TPVG": "TRIPLEPOINT VENTURE GROWTH BDC CORP.",
  "TR": "Tootsie Roll Industries, Inc.",
  "TRAD": "APEX Tech Acquisition Inc.",
  "TRAK": "ReposiTrak, Inc.",
  "TRAW": "Traws Pharma, Inc. Common Stock",
  "TRAX": "First Tracks Biotherapeutics, Inc.",
  "TRC": "Tejon Ranch Co.",
  "TRDA": "Entrada Therapeutics, Inc. Common Stock",
  "TREE": "LendingTree, Inc.",
  "TREX": "Trex Company, Inc.",
  "TRGP": "Targa Resources Corp.",
  "TRGS": "TRG Latin America Acquisitions Corp. Class A",
  "TRI": "Thomson Reuters Corporation Common Shares",
  "TRIB": "Trinity Biotech plc",
  "TRIN": "Trinity Capital Inc.",
  "TRIP": "TripAdvisor, Inc.",
  "TRLV": "Trulieve Cannabis Corp.",
  "TRMB": "Trimble Inc. Common Stock",
  "TRMD": "TORM plc Class A Common Stock",
  "TRMK": "Trustmark Corp",
  "TRN": "Trinity Industries, Inc.",
  "TRNO": "Terreno Realty Corporation",
  "TRNR": "Interactive Strength Inc. Common Stock",
  "TRNS": "Transcat Inc",
  "TRON": "Tron Inc. Common Stock",
  "TROO": "TROOPS, Inc.",
  "TROW": "T Rowe Price Group Inc",
  "TROX": "TRONOX LIMITED CL A ORDINARY SHARES",
  "TRP": "TC Energy Corporation",
  "TRS": "Trimas Corporation",
  "TRSG": "Tungray Technologies Inc Class A",
  "TRST": "Trustco Bank Corp NY",
  "TRT": "Trio-Tech International",
  "TRTN-P-A": "Triton International Limited Series A Preference Shares",
  "TRTN-P-B": "Triton International Limited Series B Preference Shares",
  "TRTN-P-C": "Triton International Limited Series C Preference Shares",
  "TRTN-P-D": "Triton International Limited Series D Preference Shares",
  "TRTN-P-E": "Triton International Limited Series E Preference Shares",
  "TRTN-P-F": "Triton International Limited Series F Preference Shares",
  "TRTN-P-G": "Triton International Limited Series G Preference Shares",
  "TRTX": "TPG RE Finance Trust, Inc. Common Stock",
  "TRTX-P-C": "TPG RE Finance Trust, Inc Series C Preferred Stock",
  "TRU": "TransUnion",
  "TRUG": "TruGolf Holdings, Inc. Class A Common Stock",
  "TRUP": "Trupanion, Inc.",
  "TRV": "The Travelers Companies, Inc.",
  "TRVG": "trivago N.V. ADR",
  "TRVI": "Trevi Therapeutics, Inc. Common Stock",
  "TRX": "TRX Gold Corporation",
  "TS": "Tenaris S. A.",
  "TSAT": "Telesat Corporation Class A Common Shares and Class B Variable Voting Shares",
  "TSBK": "Timberland Bancorp Inc",
  "TSCO": "Tractor Supply Co",
  "TSEM": "Tower Semiconductor Ltd",
  "TSHA": "Taysha Gene Therapies, Inc. Common Stock",
  "TSI": "TCW Strategic Income Fund, Inc.",
  "TSLA": "Tesla, Inc. Common Stock",
  "TSLX": "Sixth Street Specialty Lending, Inc.",
  "TSM": "Taiwan Semiconductor Manufacturing Company Ltd.",
  "TSN": "Tyson Foods, Inc.",
  "TSQ": "TOWNSQUARE MEDIA, INC.",
  "TSSI": "TSS, Inc. Common Stock",
  "TT": "Trane Technologies plc",
  "TTAM": "Titan America SA",
  "TTAN": "ServiceTitan, Inc. Class A Common Stock",
  "TTC": "Toro Company (The)",
  "TTD": "The Trade Desk, Inc.",
  "TTE": "TotalEnergies SE",
  "TTEC": "TTEC Holdings, Inc. Common Stock",
  "TTEK": "Tetra Tech Inc",
  "TTGT": "TechTarget, Inc. Common Stock",
  "TTI": "TETRA Technologies, Inc.",
  "TTMI": "TTM Technologies Inc",
  "TTRX": "Turn Therapeutics Inc. Common Stock",
  "TTWO": "Take-Two Interactive Software Inc",
  "TU": "Telus Corporation",
  "TULP": "Bloomia Holdings, Inc. Common Stock",
  "TURB": "Turbo Energy, S.A. ADR",
  "TUSK": "Mammoth Energy Services, Inc. Common Stock",
  "TUYA": "Tuya Inc. ADR",
  "TV": "Grupo Televisa S.A.",
  "TVA": "Texas Ventures Acquisition III Corp Class A Ordinary Share",
  "TVAI": "Thayer Ventures Acquisition Corporation II Class A",
  "TVC": "Tennessee Valley Authority Power Bonds 1998 Series D due June 1, 2028",
  "TVE": "Tennessee Valley Authority Power Bonds 1999 Series A due May 1, 2029",
  "TVGN": "Tevogen Inc. Common Stock",
  "TVIV": "Texas Ventures Acquisition IV Corp Class A",
  "TVRD": "Tvardi Therapeutics, Inc. Common Stock",
  "TVTX": "Travere Therapeutics, Inc. Common Stock",
  "TW": "Tradeweb Markets Inc. Class A Common Stock",
  "TWAV": "TaoWeave, Inc. Common Stock",
  "TWFG": "TWFG, Inc. Common Stock",
  "TWG": "Top Wealth Group Holding Limited Class A",
  "TWI": "Titan International, Inc.(Delaware)",
  "TWIN": "Twin Disc, Incorporated",
  "TWLO": "Twilio Inc.",
  "TWLV": "Twelve Seas Investment Company III Class A",
  "TWN": "Taiwan Fund, Inc.",
  "TWO": "Two Harbors Investment Corp.",
  "TWO-P-A": "Two Harbors Investment Corp Series A Preferred Stock",
  "TWO-P-B": "Two Harbors Investment Corp Series B Preferred Stock",
  "TWO-P-C": "Two Harbors Investment Corp Series C Preferred Stock",
  "TWST": "Twist Bioscience Corporation Common Stock",
  "TX": "Ternium S.A. ADR",
  "TXG": "10x Genomics, Inc. Class A Common Stock",
  "TXMD": "TherapeuticsMD, Inc.",
  "TXN": "Texas Instruments Incorporated",
  "TXNM": "TXNM Energy, Inc.",
  "TXO": "TXO Partners, L.P.",
  "TXRH": "Texas Roadhouse, Inc.",
  "TXT": "Textron, Inc.",
  "TY": "TRI-Continental Corporation",
  "TY-P": "Tri-Continental Corporation $2.50 Cumulative Preferred",
  "TYG": "Tortoise Energy Infrastructure Corp.",
  "TYGO": "Tigo Energy, Inc. Common Stock",
  "TYL": "Tyler Technologies, Inc.",
  "TYRA": "Tyra Biosciences, Inc. Common Stock",
  "TZOO": "Travelzoo Common Stock",
  "U": "Unity Software Inc.",
  "UA": "Under Armour, Inc. Class C Common Stock, $0.0003 1/3 par value",
  "UAA": "Under Armour, Inc.",
  "UAC": "United Acquisition Corp. I",
  "UAL": "United Airlines Holdings, Inc. Common Stock",
  "UAMY": "United States Antimony Corporation",
  "UAN": "CVR Partners, LP",
  "UAVS": "AgEagle Aerial Systems, Inc.",
  "UBCP": "United Bancorp Inc/OH",
  "UBER": "Uber Technologies, Inc.",
  "UBS": "UBS Group AG",
  "UBSI": "United Bankshares Inc",
  "UCAR": "U Power Limited Class A",
  "UCB": "United Community Banks, Inc.",
  "UCFI": "CN Healthy Food Tech Group Corp. Common Stock",
  "UCL": "uCloudlink Group Inc. ADR",
  "UCTT": "Ultra Clean Holdings, Inc.",
  "UDR": "UDR, Inc.",
  "UE": "UBRAN EDGE PROPERTIES",
  "UEC": "Uranium Energy Corp.",
  "UEIC": "Universal Electronics Inc",
  "UFCS": "United Fire Group Inc.",
  "UFG": "Uni-Fuels Holdings Limited Class A",
  "UFI": "UNIFI, Inc. New",
  "UFPI": "UFP Industries, Inc. Common Stock",
  "UFPT": "UFP Technologies Inc",
  "UG": "United-Guardian, Inc.",
  "UGI": "UGI Corporation",
  "UGP": "Ultrapar Participacoes S.A.",
  "UHAL": "U-Haul Holding Company",
  "UHAL-B": "U-Haul Holding Company",
  "UHS": "Universal Health Services, Inc. Class B",
  "UHT": "Universal Health Realty Income Trust",
  "UI": "Ubiquiti Inc. Common Stock",
  "UIS": "Unisys Corporation",
  "UK": "Ucommune International Ltd Class A",
  "UL": "Unilever plc",
  "ULBI": "Ultralife Corporation",
  "ULCC": "Frontier Group Holdings, Inc. Common Stock",
  "ULH": "Universal Logistics Holdings, Inc. Common Stock",
  "ULS": "UL Solutions Inc.",
  "ULTA": "Ulta Beauty, Inc. Common Stock",
  "UMAC": "Unusual Machines, Inc.",
  "UMBF": "UMB Financial Corp",
  "UMBFO": "UMB Financial Corporation Series B Preferred Stock",
  "UMC": "United Microelectronic Corp.",
  "UMH": "UMH Properties, Inc.",
  "UMH-P-D": "UMH Properties, Inc Series D Preferred Stock",
  "UNB": "Union Bankshares, Inc",
  "UNCY": "Unicycive Therapeutics, Inc. Common Stock",
  "UNF": "Unifirst Corp",
  "UNFI": "United Natural Foods Inc",
  "UNH": "UNITEDHEALTH GROUP INCORPORATED (Delaware)",
  "UNIT": "Uniti Group Inc. Common Stock",
  "UNM": "Unum Group",
  "UNP": "Union Pacific Corp.",
  "UNTY": "Unity Bancorp",
  "UONE": "Urban One, Inc. Class A Common Stock",
  "UONEK": "Urban One, Inc. Class D Common Stock",
  "UP": "Wheels Up Experience Inc.",
  "UPB": "Upstream Bio, Inc. Common Stock",
  "UPBD": "Upbound Group, Inc. Common Stock",
  "UPC": "Universe Pharmaceuticals Inc. Class A",
  "UPLD": "Upland Software, Inc.",
  "UPS": "United Parcel Service, Inc. Class B",
  "UPST": "Upstart Holdings, Inc. Common stock",
  "UPWK": "Upwork Inc. Common Stock",
  "UPXI": "Upexi, Inc. Common Stock",
  "URBN": "Urban Outfitters Inc",
  "URG": "Ur-Energy Inc.",
  "URGN": "UroGen Pharma Ltd.",
  "URI": "United Rentals, Inc.",
  "UROY": "Uranium Royalty Corp. Common Stock",
  "USA": "Liberty All-Star Equity Fund",
  "USAC": "USA COMPRESSION PARTNERS LP",
  "USAR": "USA Rare Earth, Inc. Class A Common Stock",
  "USAS": "Americas Gold and Silver Corporation",
  "USAU": "U.S. Gold Corp. Common Stock",
  "USB": "U.S. Bancorp",
  "USB-P-A": "U.S. Bancorp Series A Preferred Stock",
  "USB-P-H": "US Bancorp Depositary Shares (1/1,000 Interest in Ser. B Non-Cum. Prptl. Prfrd. Stock)",
  "USB-P-P": "U.S. Bancorp Series K Preferred Stock",
  "USB-P-Q": "U.S. Bancorp Series L Preferred Stock",
  "USB-P-R": "U.S. Bancorp Series M Preferred Stock",
  "USB-P-S": "U.S. Bancorp Series O Preferred Stock",
  "USBC": "USBC, Inc.",
  "USCB": "USCB Financial Holdings, Inc. Class A Common Stock",
  "USDE": "StablecoinX Inc. Class A Common Stock",
  "USEA": "United Maritime Corporation Common Stock",
  "USFD": "US Foods Holding Corp.",
  "USGO": "U.S. GoldMining Inc. Common stock",
  "USIO": "Usio, Inc. Common Stock",
  "USLM": "United States Lime & Minerals",
  "USNA": "USANA Health Sciences Inc",
  "USPH": "US Physical Therapy Inc",
  "UTF": "Cohen & Steers  Infrastructure Fund, Inc.",
  "UTG": "Reaves Utility Income Fund",
  "UTHR": "United Therapeutics Corp",
  "UTI": "Universal Technical Institute, Inc.",
  "UTL": "Unitil Corporation",
  "UTMD": "Utah Medical Products Inc",
  "UTSI": "UTStarcom Holdings Corp Ordinary Shares (Cayman Islands)",
  "UTZ": "Utz Brands, Inc.",
  "UUU": "Universal Safety Products, Inc.",
  "UUUU": "Energy Fuels Inc.",
  "UVE": "UNIVERSAL INSURANCE HLDG, INC.",
  "UVSP": "Univest Financial Corporation Common Stock",
  "UVV": "Universal Corporation",
  "UWMC": "UWM Holdings Corporation",
  "UXIN": "Uxin Limited ADS",
  "UYSC": "UY Scuti Acquisition Corp.",
  "UZX": "Linkage Global Inc Class A",
  "V": "VISA Inc.",
  "VABK": "Virginia National Bankshares Corporation Common Stock",
  "VAC": "MARRIOTT VACATIONS WORLDWIDE CORPORATION",
  "VACI": "Viking Acquisition Corp. I",
  "VAL": "Valaris Limited",
  "VALE": "VALE S.A.",
  "VALN": "Valneva SE ADR",
  "VALU": "Value Line Inc",
  "VANI": "Vivani Medical, Inc. Common Stock (DE)",
  "VATE": "INNOVATE Corp.",
  "VBF": "INVESCO  BOND FUND",
  "VBIO": "Valion Bio, Inc. Common Stock",
  "VBNK": "VersaBank Common Shares",
  "VC": "VISTEON CORPORATION",
  "VCEL": "Vericel Corporation",
  "VCIG": "VCI Global Limited Ordinary Share",
  "VCRE": "Vicore Pharma Holding AB ADR",
  "VCTR": "Victory Capital Holdings, Inc. Class A Common Stock",
  "VCV": "INVESCO  CALIFORNIA VALUE MUNI INCOME TRUST",
  "VCX": "Fundrise Innovation Fund, LLC",
  "VCYT": "Veracyte, Inc.",
  "VECA": "Vernal Capital Acquisition Corp.",
  "VECO": "Veeco Instruments Inc",
  "VEEA": "Veea Inc. Common Stock",
  "VEEE": "Twin Vee PowerCats Co. Common Stock",
  "VEEV": "Veeva Systems Inc.",
  "VEL": "Velocity Financial, Inc.",
  "VELO": "Velo3D, Inc. Common stock",
  "VENU": "Venu Holding Corporation",
  "VEON": "VEON Ltd. ADS",
  "VERA": "Vera Therapeutics, Inc. Class A Common Stock",
  "VERI": "Veritone, Inc. Common Stock",
  "VERU": "Veru Inc.",
  "VERX": "Vertex, Inc. Class A Common Stock",
  "VET": "VERMILION ENERGY INC.",
  "VFC": "V.F. Corporation",
  "VFF": "Village Farms International, Inc. Common Shares",
  "VFS": "VinFast Auto Ltd.",
  "VG": "Venture Global, Inc.",
  "VGAS": "Verde Clean Fuels, Inc. Class A Common Stock",
  "VGI": "VIRTUS GLOBAL MULTI-SECTOR INCOME FUND",
  "VGM": "Invesco  Trust Investment Grade Municipals",
  "VGNT": "Versigent PLC",
  "VGZ": "Vista Gold Corp.",
  "VHC": "VirnetX Holding Corp Common Stock",
  "VHCP": "Vine Hill Capital Investment Corp. II Class A",
  "VHI": "Valhi, Inc.",
  "VHUB": "VenHub Global, Inc. Common Stock",
  "VIA": "Via Transportation, Inc.",
  "VIAV": "Viavi Solutions Inc. Common Stock",
  "VICI": "VICI Properties Inc. Common Stock",
  "VICR": "Vicor Corp",
  "VIDA": "VIDA Global Inc.",
  "VII": "Viking Acquisition Corp. II",
  "VIK": "Viking Holdings Ltd",
  "VINP": "Vinci Compass Investments Ltd. Class A Common Shares",
  "VIOT": "Viomi Technology Co., Ltd ADR",
  "VIP": "Vulcan Infrastructure and Power Inc. Class A Common Stock",
  "VIPS": "Vipshop Holdings Limited",
  "VIR": "Vir Biotechnology, Inc. Common Stock",
  "VIRC": "Virco Mfg. Corporation",
  "VIRT": "Virtu Financial, Inc. Class A",
  "VISN": "Vistance Networks, Inc. Common Stock",
  "VIST": "Vista Energy S.A.B. de C.V.",
  "VITL": "Vital Farms, Inc. Common Stock",
  "VIV": "Telefonica Brasil, S.A. ADR",
  "VIVK": "Vivakor, Inc. Common Stock",
  "VIVO": "VivoPower PLC Class A",
  "VIVS": "VivoSim Labs, Inc. Common Stock",
  "VKI": "Invesco Advantage Municipal Income Trust II",
  "VKQ": "Invesco Municipal Trust",
  "VKTX": "Viking Therapeutics, Inc",
  "VLGEA": "Village Super Market",
  "VLN": "Valens Semiconductor Ltd.",
  "VLO": "Valero Energy Corporation",
  "VLOS": "Velos Acquisition I Corp. Class A",
  "VLRS": "CONTROLADORA VUELA COMPANIA DE AVIACION, S.A.B. DE C.V.",
  "VLT": "Invesco  High Income Trust II",
  "VLTO": "Veralto Corporation",
  "VLY": "Valley National Bancorp",
  "VLYPN": "Valley National Bancorp Series C Preferred Stock",
  "VLYPO": "Valley National Bancorp Series B Preferred Stock",
  "VLYPP": "Valley National Bancorp Series A Preferred Stock",
  "VMAR": "Vision Marine Technologies Inc. Common Shares",
  "VMC": "Vulcan Materials Company(Holding Company)",
  "VMD": "Viemed Healthcare, Inc. Common Shares",
  "VMET": "Versamet Royalties Corporation Common Stock",
  "VMI": "Valmont Industries, Inc.",
  "VMO": "Invesco Municipal Opportunity Trust",
  "VNCE": "Vince Holding Corp. Common Stock",
  "VNDA": "Vanda Pharmaceuticals Inc.",
  "VNET": "VNET Group, Inc. ADR",
  "VNME": "Vendome Acquisition Corporation I Class A",
  "VNO": "Vornado Realty Trust",
  "VNO-P-L": "VORNADO REALTY TRUST Series L Preferred Shares",
  "VNO-P-M": "Vornado Realty Trust Series M Preferred Shares",
  "VNO-P-N": "Vornado Realty Trust Series N Preferred Shares",
  "VNO-P-O": "Vornado Realty Trust Series O Preferred Shares",
  "VNOM": "Viper Energy, Inc. Class A Common Stock",
  "VNRX": "VolitionRx Limited",
  "VNT": "Vontier Corporation",
  "VNTG": "Vantage Corp",
  "VOC": "VOC ENERGY TRUST",
  "VOD": "Vodafone Group PLC",
  "VOR": "Vor Biopharma Inc. Common Stock",
  "VOXR": "Vox Royalty Corp. Common Stock",
  "VOYA": "VOYA FINANCIAL, INC.",
  "VOYA-P-B": "Voya Financial, Inc Series B Preferred Stock",
  "VOYG": "Voyager Technologies, Inc.",
  "VPG": "Vishay Precision Group, Inc.",
  "VPV": "Invesco  Pennsylvania Value Municipal Income Trust",
  "VRA": "Vera Bradley, Inc.",
  "VRAX": "Virax Biolabs Group Limited",
  "VRCA": "Verrica Pharmaceuticals Inc. Common Stock",
  "VRDN": "Viridian Therapeutics, Inc. Common Stock",
  "VREX": "Varex Imaging Corporation Common Stock",
  "VRM": "Vroom, Inc. Common Stock",
  "VRME": "VerifyMe, Inc. Common Stock",
  "VRNS": "Varonis Systems, Inc.",
  "VRRM": "Verra Mobility Corporation Class A Common Stock",
  "VRSK": "Verisk Analytics, Inc. Common Stock",
  "VRSN": "VeriSign Inc",
  "VRT": "Vertiv Holdings Co Class A Common Stock",
  "VRTS": "Virtus Investment Partners, Inc.",
  "VRTX": "Vertex Pharmaceuticals Inc",
  "VRXA": "Veraxa Biotech AG",
  "VS": "Versus Systems Inc. Common Stock",
  "VSA": "VisionSys AI Inc ADR",
  "VSAT": "Viasat Inc",
  "VSEC": "VSE Corp",
  "VSH": "Vishay Intertechnology, Inc.",
  "VSME": "VS Media Holdings Limited Class A",
  "VSNT": "Versant Media Group, Inc. Class A Common Stock",
  "VST": "Vistra Corp.",
  "VSTM": "Verastem, Inc.",
  "VSTS": "Vestis Corporation",
  "VSXY": "Victorias Secret & Co.",
  "VTAK": "Catheter Precision, Inc.",
  "VTEX": "VTEX",
  "VTGN": "Vistagen Therapeutics, Inc. Common Stock",
  "VTIX": "Virtuix Holdings Inc. Class A Common Stock",
  "VTMX": "Corporacion Inmobiliaria Vesta, S.A.B de C.V., ADR",
  "VTN": "Invesco  Trust for Investment Grade New York Municipals",
  "VTOL": "Bristow Group Inc.",
  "VTR": "Ventas, Inc.",
  "VTRS": "Viatris Inc. Common Stock",
  "VTS": "Vitesse Energy, Inc..",
  "VTSI": "VirTra, Inc. Common Stock",
  "VTVT": "vTv Therapeutics Inc. Class A Common Stock",
  "VUZI": "Vuzix Corporation",
  "VVOS": "Vivos Therapeutics, Inc. Common Stock",
  "VVR": "Invesco  Senior Income Trust",
  "VVV": "Valvoline Inc.",
  "VVX": "V2X, Inc.",
  "VWAV": "VisionWave Holdings, Inc. Common Stock",
  "VYGR": "Voyager Therapeutics, Inc. Common Stock",
  "VYX": "NCR Voyix Corporation",
  "VZ": "Verizon Communications",
  "VZLA": "Vizsla Silver Corp.",
  "W": "Wayfair Inc.",
  "WAB": "Wabtec Inc.",
  "WABC": "Westamerica Bancorporation",
  "WAFD": "WaFd, Inc. Common Stock",
  "WAFDP": "WaFd, Inc. Depositary Shares",
  "WAFU": "Wah Fu Education Group Limited",
  "WAL": "Western Alliance Bancorporation",
  "WAL-P-A": "Western Alliance Bancorporation Series A Preferred Stock",
  "WALD": "Waldencast plc Class A Ordinary Share",
  "WASH": "Washington Trust Bancorp Inc",
  "WAT": "Waters Corp",
  "WATT": "Energous Corporation",
  "WAVE": "Eco Wave Power Global AB (publ) ADR",
  "WAY": "Waystar Holding Corp. Common Stock",
  "WB": "Weibo Corporation",
  "WBD": "Warner Bros. Discovery, Inc. Series A Common Stock",
  "WBI": "WaterBridge Infrastructure LLC",
  "WBS": "Webster Financial Corporation Waterbury",
  "WBS-P-F": "Webster Financial Corporation Series F Preferred Stock",
  "WBS-P-G": "Webster Financial Corporation Series G Preferred Stock",
  "WBTN": "WEBTOON Entertainment Inc. Common Stock",
  "WBUY": "WEBUY GLOBAL LTD. Class A",
  "WBX": "Wallbox N.V.",
  "WCC": "Wesco International Inc.",
  "WCN": "Waste Connections, Inc.",
  "WCT": "Wellchange Holdings Company Limited Class A",
  "WD": "Walker & Dunlop, Inc.",
  "WDAY": "Workday, Inc. Class A Common Stock",
  "WDC": "Western Digital Corp.",
  "WDFC": "Wd-40 Co",
  "WDH": "Waterdrop Inc. ADR",
  "WDI": "Western Asset Diversified Income Fund",
  "WDS": "Woodside Energy Group Limited ADR",
  "WEA": "Western Asset Premier Bond Fund",
  "WEAV": "Weave Communications, Inc.",
  "WEC": "WEC Energy Group, Inc.",
  "WELL": "Welltower Inc.",
  "WEN": "The Wendy's Company",
  "WENC": "West Enclave Merger Corp.",
  "WENN": "Wen Acquisition Corp Class A",
  "WERN": "Werner Enterprises Inc",
  "WES": "Western Midstream Partners, LP",
  "WEST": "Westrock Coffee Company Common Stock",
  "WETH": "Wetouch Technology Inc. Common Stock",
  "WETO": "Wetour Robotics Limited",
  "WEX": "WEX Inc.",
  "WEYS": "Weyco Group Inc",
  "WF": "Woori Financial Group Inc. ADR",
  "WFC": "Wells Fargo & Co.",
  "WFC-P-A": "Wells Fargo & Company Class A Preferred Stock",
  "WFC-P-C": "Wells Fargo & Company Class A Preferred Stock",
  "WFC-P-D": "Wells Fargo & Company Class A Preferred Stock",
  "WFC-P-L": "WELLS FARGO 7.5% NON CUMV PERP CONV",
  "WFC-P-Y": "Wells Fargo & Company",
  "WFC-P-Z": "Wells Fargo & Company Class A Preferred Stock",
  "WFCF": "Where Food Comes From, Inc. Common Stock",
  "WFF": "WF Holding Limited",
  "WFG": "West Fraser Timber Co. Ltd",
  "WFRD": "Weatherford International plc",
  "WGO": "Winnebago Industries, Inc.",
  "WGS": "GeneDx Holdings Corp. Class A Common Stock",
  "WH": "Wyndham Hotels & Resorts, Inc. Common Stock",
  "WHD": "Cactus, Inc.",
  "WHF": "WhiteHorse Finance, Inc.",
  "WHG": "WESTWOOD HOLDINGS GROUP, INC.",
  "WHK": "WhiteHawk Minerals Corp.",
  "WHLR": "Wheeler Real Estate Investment Trust, Inc",
  "WHLRD": "Wheeler Real Estate Investment Trust, Inc. Series D Series D Preferred Stock",
  "WHLRP": "Wheeler Real Estate Investment Trust, Inc. Preferred Stock",
  "WHR": "Whirlpool Corp.",
  "WHR-P-A": "Whirlpool Corporation Series A Preferred Stock",
  "WHWK": "Whitehawk Therapeutics, Inc. Common Stock",
  "WIA": "Western Asset Inflation-Linked Income Fund",
  "WILC": "G Willi-Food International Ltd",
  "WIMI": "WiMi Hologram Cloud Inc. Class B",
  "WINA": "Winmark Corp",
  "WING": "Wingstop Inc",
  "WIT": "Wipro Limited",
  "WIW": "Western Asset Inflation-Linked Opportunities & Income Fund",
  "WIX": "WIX.com Ltd.",
  "WK": "Workiva Inc.",
  "WKC": "World Kinect Corporation",
  "WKEY": "WISeKey International Holding AG ADR",
  "WKHS": "Workhorse Group, Inc",
  "WKSP": "Worksport, Ltd. Common Stock",
  "WLDN": "Willdan Group, Inc.",
  "WLDS": "Wearable Devices Ltd. Ordinary Share",
  "WLFC": "Willis Lease Finance Corp",
  "WLII": "Willow Lane Acquisition Corp. II Class A",
  "WLK": "Westlake Corporation",
  "WLKP": "WESTLAKE CHEMICAL PARTNERS LP",
  "WLTH": "Wealthfront Corporation Common Stock",
  "WLY": "John Wiley & Sons, Inc. Class A",
  "WLYB": "John Wiley & Sons, Inc. Class B",
  "WM": "Waste Management, Inc.",
  "WMB": "Williams Companies Inc.",
  "WMG": "Warner Music Group Corp. Class A Common Stock",
  "WMK": "Weis Markets, Inc.",
  "WMS": "ADVANCED DRAINAGE SYSTEMS, INC.",
  "WMT": "Walmart Inc. Common Stock",
  "WNC": "Wabash National Corp.",
  "WNEB": "Western New England Bancorp, Inc.",
  "WNW": "Meiwu Technology Company Limited",
  "WOK": "WORK Medical Technology Group LTD Class A",
  "WOLF": "Wolfspeed, Inc.",
  "WOOF": "Petco Health and Wellness Company, Inc. Class A Common Stock",
  "WOR": "Worthington Enterprises, Inc.",
  "WPAC": "White Pearl Acquisition Corp.",
  "WPC": "W.P. Carey Inc. (REIT)",
  "WPM": "Wheaton Precious Metals Corp. Common Stock",
  "WPP": "WPP PLC",
  "WPRT": "Westport Fuel Systems Inc Common Shares",
  "WRAP": "Wrap Technologies, Inc. Common Stock",
  "WRB": "W.R. Berkley Corporation",
  "WRBY": "Warby Parker Inc.",
  "WRD": "WeRide Inc. ADR",
  "WRLD": "World Acceptance Corp",
  "WRN": "Western Copper and Gold Corporation",
  "WS": "Worthington Steel, Inc.",
  "WSBC": "WesBanco Inc",
  "WSBCO": "WesBanco, Inc Series B Preferred Stock",
  "WSBF": "Waterstone Financial, Inc.",
  "WSBK": "Winchester Bancorp, Inc. Common Stock",
  "WSC": "WillScot Holdings Corporation Class A Common Stock",
  "WSE": "Wise Group plc Class A",
  "WSFS": "WSFS Financial Corp",
  "WSHP": "WeShop Holdings Limited Class A",
  "WSM": "Williams-Sonoma, Inc.",
  "WSO": "Watsco, Inc.",
  "WSO-B": "Watsco, Inc. Class B",
  "WST": "West Pharmaceutical Services, Inc.",
  "WSTN": "Westin Acquisition Corp Class A Ordinary Share",
  "WT": "WisdomTree, Inc.",
  "WTBA": "West Bancorporation",
  "WTF": "Waton Financial Limited",
  "WTFC": "Wintrust Financial Corp",
  "WTFCN": "Wintrust Financial Corporation Preferred Stock",
  "WTG": "Wintergreen Acquisition Corp.",
  "WTI": "W&T Offshore, Inc.",
  "WTM": "White Mountains Insurance Group Ltd.",
  "WTRG": "Essential Utilities, Inc.",
  "WTS": "Watts Water Technologies, Inc. Class A",
  "WTTR": "Select Water Solutions, Inc.",
  "WTW": "Willis Towers Watson Public Limited Company",
  "WU": "The Western Union Company",
  "WULF": "TeraWulf Inc. Common Stock",
  "WVE": "Wave Life Sciences Ltd.",
  "WVVI": "Willamette Valley Vineyards",
  "WVVIP": "Willamette Valley Vineyards, Inc. Series A Series A Preferred Stock",
  "WW": "WW International, Inc. Common Stock",
  "WWD": "Woodward, Inc.",
  "WWR": "Westwater Resources, Inc.",
  "WWW": "Wolverine World Wide, Inc.",
  "WXM": "WF International Limited",
  "WY": "Weyerhaeuser Company",
  "WYFI": "WhiteFiber, Inc.",
  "WYHG": "Wing Yip Food Holdings Group Limited ADR",
  "WYNN": "Wynn Resorts Ltd",
  "WYY": "WidePoint Corporation",
  "XAIR": "Beyond Air, Inc. Common Stock",
  "XBIO": "Xenetic Biosciences, Inc.",
  "XBIT": "XBiotech Inc",
  "XBP": "XBP Global Holdings, Inc. Common Stock",
  "XCBE": "X3 Acquisition Corp. Ltd. Class A",
  "XCH": "XCHG Limited ADR",
  "XCUR": "Exicure, Inc. Common Stock",
  "XE": "X-Energy, Inc. Class A Common Stock",
  "XEL": "Xcel Energy, Inc.",
  "XELB": "XCEL BRANDS INC.",
  "XENE": "Xenon Pharmaceuticals Inc",
  "XERS": "Xeris Biopharma Holdings, Inc. Common Stock",
  "XFLH": "XFLH Capital Corporation",
  "XFLT": "XAI Floating Rate & Alternative Income Trust",
  "XFOR": "X4 Pharmaceuticals, Inc. Common Stock",
  "XGN": "Exagen Inc. Common Stock",
  "XHG": "XChange TEC.INC ADR",
  "XHLD": "TEN Holdings, Inc. Common Stock",
  "XHR": "Xenia Hotels & Resorts, Inc.",
  "XIFR": "XPLR Infrastructure, LP",
  "XLO": "Xilio Therapeutics, Inc. Common Stock",
  "XMAX": "XMAX, Inc. Common Stock",
  "XMTR": "Xometry, Inc. Class A Common Stock",
  "XNCR": "Xencor, Inc.",
  "XNDU": "Xanadu Quantum Technologies Limited Class B Subordinate Voting Shares",
  "XNET": "Xunlei Limited",
  "XOM": "ExxonMobil Holdings Corporation",
  "XOS": "Xos, Inc. Common Stock",
  "XP": "XP Inc. Class A Common Stock",
  "XPEL": "XPEL, Inc. Common Stock",
  "XPER": "Xperi Inc",
  "XPEV": "XPeng Inc. American depositary shares, each representing two Class A ordinary shares",
  "XPL": "Solitario Resources Corp.",
  "XPO": "XPO, Inc.",
  "XPOF": "Xponential Fitness, Inc.",
  "XPON": "Expion360 Inc. Common Stock",
  "XPRO": "Expro Ltd",
  "XRAY": "DENTSPLY SIRONA Inc.",
  "XRN": "Chiron Real Estate Inc.",
  "XRN-P-A": "Chiron Real Estate Inc. Series A Series A Preferred Stock",
  "XRN-P-B": "Chiron Real Estate Inc Series B Preferred Stock",
  "XRPN": "Armada Acquisition Corp. II Class A",
  "XRTX": "XORTX Therapeutics Inc. Common Stock",
  "XRX": "Xerox Holdings Corporation Common Stock",
  "XSLL": "Xsolla SPAC 1 Class A",
  "XTIA": "XTI Aerospace, Inc. Common Stock",
  "XTLB": "XTL Biopharmaceuticals Ltd. ADR",
  "XTNT": "Xtant Medical Holdings, Inc.",
  "XWEL": "XWELL, Inc. Common Stock",
  "XXI": "Twenty One Capital, Inc.",
  "XXII": "22nd Century Group Inc.",
  "XYF": "X Financial ADR",
  "XYL": "Xylem Inc",
  "XYZ": "Block, Inc.",
  "XZO": "Exzeo Group, Inc.",
  "YAAS": "Youxin Technology Ltd Class A",
  "YALA": "Yalla Group Limited ADR",
  "YARW": "Yarrow Bioscience, Inc. Common Stock",
  "YB": "Yuanbao Inc. ADR",
  "YCBD": "cbdMD, Inc. Common Stock",
  "YCY": "AA Mission Acquisition Corp. II",
  "YDDL": "One and One Green Technologies. Inc Class A",
  "YDES": "YD Bio Limited",
  "YDKG": "Yueda Digital Holding Class A Ordinary Share",
  "YELP": "YELP INC.",
  "YETI": "YETI Holdings, Inc. Common Stock",
  "YEXT": "Yext, Inc.",
  "YHC": "LQR House Inc. Common Stock",
  "YHGJ": "Yunhong Green CTI Ltd. Common Stock",
  "YHNA": "YHN Acquisition I Limited",
  "YI": "111, Inc. ADR",
  "YIBO": "Planet Image International Limited Class A",
  "YICC": "Yorkville International Capital Corp. Class A",
  "YJ": "Yunji Inc. ADR",
  "YMAT": "J-Star Holding Co., Ltd. Class A",
  "YMM": "Full Truck Alliance Co. Ltd. ADR",
  "YMT": "Yimutian Inc. ADR",
  "YORW": "York Water Co",
  "YOU": "Clear Secure, Inc.",
  "YOUL": "Youlife Group Inc. ADR",
  "YPF": "YPF Sociedad Anonima ADR",
  "YQ": "17 Education & Technology Group Inc. ADR",
  "YRD": "Yiren Digital Ltd.",
  "YSG": "Yatsen Holding Limited ADR",
  "YSS": "York Space Systems Inc.",
  "YSWY": "Yesway, Inc. Class A Common Stock",
  "YSXT": "YSX Tech. Co., Ltd Class A",
  "YTRA": "Yatra Online, Inc.",
  "YUM": "Yum! Brands, Inc.",
  "YUMC": "Yum China Holdings, Inc. Common Stock",
  "YXT": "YXT.COM GROUP HOLDING LIMITED ADR",
  "YYAI": "AiRWA Inc. Common Stock",
  "YYGH": "YY Group Holding Limited Class A",
  "Z": "Zillow Group, Inc. Class C Capital Stock",
  "ZBAO": "Zhibao Technology Inc. Class A",
  "ZBH": "Zimmer Biomet Holdings, Inc.",
  "ZBIO": "Zenas BioPharma, Inc. Common Stock",
  "ZBRA": "Zebra Technologies Corporation",
  "ZCMD": "Zhongchao Inc. Class A",
  "ZD": "Ziff Davis, Inc. Common Stock",
  "ZDAI": "DirectBooking Technology Co., Ltd. Class A",
  "ZDGE": "Zedge, Inc.",
  "ZENA": "ZenaTech, Inc. Common Stock",
  "ZEO": "Zeo Energy Corporation Class A Common Stock",
  "ZEPP": "Zepp Health Corporation American depositary shares, each representing sixteen Class A ordinary shares",
  "ZETA": "Zeta Global Holdings Corp.",
  "ZG": "ZILLOW GROUP INC CLASS A",
  "ZGN": "Ermenegildo Zegna N.V.",
  "ZH": "Zhihu Inc. ADR",
  "ZIM": "ZIM Integrated Shipping Services Ltd.",
  "ZION": "Zions Bancorporation N.A.",
  "ZIONP": "Zions Bancorporation, N.A Series A Preferred Stock",
  "ZIP": "ZipRecruiter, Inc.",
  "ZJK": "ZJK Industrial Co., Ltd. Class A",
  "ZJYL": "JIN MEDICAL INTERNATIONAL LTD. Class A",
  "ZKH": "ZKH Group Limited ADR",
  "ZKIN": "ZK International Group Co., Ltd Ordinary Share",
  "ZKP": "Lafayette Digital Acquisition Corp. I Class A",
  "ZLAB": "Zai Lab Limited ADR",
  "ZM": "Zoom Communications, Inc. Class A Common Stock",
  "ZNB": "Zeta Network Group Class A",
  "ZNTL": "Zentalis Pharmaceuticals, Inc. Common Stock",
  "ZONE": "CleanCore Solutions Inc.",
  "ZOOZ": "ZOOZ Strategy Ltd.",
  "ZS": "Zscaler, Inc. Common Stock",
  "ZSQR": "Z Squared Inc. Common Stock",
  "ZSTK": "ZeroStack Corp. Common Stock",
  "ZTEK": "Zentek Ltd. Common Stock",
  "ZTG": "Zenta Group Company Limited Class A",
  "ZTO": "ZTO Express (Cayman) Inc. ADR",
  "ZTR": "Virtus Total Return Fund Inc.",
  "ZTS": "ZOETIS INC.",
  "ZUMZ": "Zumiez Inc.",
  "ZURA": "Zura Bio Limited Class A",
  "ZVIA": "Zevia PBC",
  "ZVRA": "Zevra Therapeutics, Inc. Common Stock",
  "ZWS": "Zurn Elkay Water Solutions Corporation",
  "ZYBT": "Zhengye Biotechnology Holding Limited Class A",
  "ZYME": "Zymeworks Inc.",
};

/**
 * 영문 검색용 역매핑 인덱스 (소문자, 특수문자 제거)
 * 런타임에 한 번만 생성
 */
let _enSearchIndex: { key: string; orig: string; ticker: string }[] | null = null;

export function getENSearchIndex(): { key: string; orig: string; ticker: string }[] {
  if (_enSearchIndex) return _enSearchIndex;
  _enSearchIndex = [];
  for (const [ticker, name] of Object.entries(US_TICKER_TO_EN)) {
    _enSearchIndex.push({
      key: name.toLowerCase().replace(/[^a-z0-9]/g, ""),
      orig: name,
      ticker,
    });
  }
  return _enSearchIndex;
}
